{
  "accessibility": {
    "closeModal": "Close modal",
    "useSetting": "Use setting",
    "srOnly": {
      "close": "Close",
      "loading": "Loading..."
    }
  },
  "account": {
    "salesResources": {
      "title": "Sales Resources",
      "searchDocuments": "Search Documents",
      "minimalRating": "Minimal Rating",
      "maxRating": "Max Rating"
    },
    "saasRebilling": {
      "enableRebillingMessage": "Enable rebilling for this client to make up to 10x in profits on usage of phone, emails, automations etc.",
      "enableRebilling": "Enable Rebilling",
      "servicesActivateAfterPayment": "Rebilling services will be active after the client adds a payment method. Until then, client’s account access will be restricted.",
      "cannotModifyOnHold": "Cannot modify rebilling configurations since this account already has a SaaS plan on hold. Rebilling markups will be configured according to the plan when the client adds a payment method.",
      "rebillingSettings": "Rebilling Settings"
    }
  },
  "affiliates": {
    "aboutMe": "About me",
    "error": {
      "unableToSend": "Unable to send Email"
    },
    "industriesServed": "Industries served",
    "sendAMessage": "Send a message",
    "sendMessageIntro": "Send a message to introduce yourself to this advisor. Include details about yourself and the services you're looking for.",
    "socialSites": "Social sites",
    "success": {
      "emailSent": "Email Sent Successfully"
    },
    "validationErrors": {
      "validEmail": "Please provide a valid email.",
      "validMessage": "Please provide a valid message.",
      "validName": "Please provide a valid name."
    },
    "yearsInBusiness": "Years in business",
    "yourEmail": "Your email",
    "yourName": "Your name",
    "paymentDetailsAccessMessage": " This payment details section is only accessible and editable by the <strong>Agency Owner</strong>. If you need assistance, please contact your <strong>Agency Owner ({ agencyOwnerEmail })</strong>.",
    "partnerBadgeAlt": "Partner badge",
    "photoAlt": "Partner photo",
    "defaultCompany": "No company",
    "moreServices": "+ {count} more services"
  },
  "agency": {
    "saas": {
      "saasMode": "SAAS Mode",
      "pendingPaymentInformation": "Pending Payment Information",
      "customerId": "Customer ID",
      "noPaymentMethods": "Seems like no payment methods are added! Please add a payment method to activate the saas mode",
      "enableSaasDescription": "Enable SaaS on this location to create subscription, rebill telephone &amp; email usage",
      "missingEmailAddress": "Account's Email address is missing, please add details first.",
      "toConvertToSaaS": "To convert this account to SaaS, you need to add a location admin first and try again",
      "newUser": "Create New User",
      "stripeCustomerConnected": "Stripe customer successfully connected!",
      "requestClientPaymentDetails": "Request Client’s Payment Details",
      "saasLocationDescription": "Locations in SaaS mode need your client's credit card to work. You can request via sending an email, text or sharing an URL",
      "selectSpace": "Select space to continue",
      "spaceDescription": "The space that you select here will be used to store this customer's information, process their payments, and manage their subscriptions.",
      "stripe": "Stripe",
      "freeCreditsDescription": "When a user signs up, you can offer them free credits to use email &amp; telephony services.",
      "thatAboutMinsInCalls": "That's about {count} texts or {count1}  mins in calls",
      "subscriptionSettings": "Subscription Settings",
      "toUpgradeOrCancelPlan": "To upgrade or cancel plan",
      "allowClientUpgrade": "Allow client(sub-account) to upgrade to a higher plan.",
      "addNewPlanFeatures": "Add new plan’s features upon upgrading",
      "upgradeFeatureDescription": "Upon upgrading to a higher plan, the sub-accounts will get access to the additional features in the new plan. access to the additional features in the new plan.",
      "allowClientCancel": "Allow client(sub-account) to cancel their subscription.",
      "snapshotDescription": "Selected snapshot will be automatically added to the newly created SaaS Location",
      "ownSnapshots": "Own Snapshots",
      "selectAndContinue": "Select And Continue"
    },
    "advancedSettings": {
      "controlLocationSettings": "Control the Location settings",
      "disableAddSmtp": "Disable the Add Email Service button in the sub-account Email Services Settings",
      "disableAddSmtpDescription": "Restrict sub-account users to add their own Email service provider",
      "enableReVerification": "Enable Re-verification for 90 days",
      "lcEmailNotEnabled": "Location does not have LeadConnector as default Email Provider",
      "onlyVisibleForAgency": "You can only see these setting enabled for agency",
      "reVerificationDescription": "Each email verification status will be revoked after 90 days (Protect your sender reputation and ensure the highest inbox deliverability)",
      "account": {
        "accountDetails": "Account Details",
        "advancedEmailSettings": "Advanced Email Settings",
        "hipaa": "HIPAA",
        "hipaaCompliant": "HIPAA Compliant",
        "smsEmailLimits": "SMS/Email Limits",
        "socialProfiles": "Social Profiles",
        "subscribed": "Subscribed"
      },
      "activityTracking": {
        "history": "History"
      },
      "addAccount": {
        "accountInfo": "Account Information",
        "accountSnapshots": "Account Snapshots",
        "businessNiche": "Business niche",
        "chooseBusinessNiche": "Choose Business Niche...",
        "pickSnapshot": "Please pick a snapshot",
        "selectSnapshot": "Select Snapshot",
        "title": "Add Sub-Account",
        "accountInfo1": "Account info"
      },
      "addBalance": {
        "addBalanceToWallet": "Add Balance to Wallet",
        "addMoneyToWallet": "Add Money to Wallet",
        "balanceAddedSuccessfully": "Balance Added Successfully",
        "cardWillBeCharged": "Card ending in {cardNumber} will be charged",
        "complimentaryCredits": "Complimentary Credits ({credits})",
        "creditsRemovedByAgency": "Credits removed by agency",
        "currentBalance": "Current Balance",
        "customerCCWillNotBeCharged": "Customer credit card will not be charged",
        "moneyWillBeAddedToWallet": "Money will be added to wallet",
        "pleaseProvideAmountBetween": "Please provide amount between {min} and {max}",
        "processing": "Processing",
        "removeBalance": "Remove Balance",
        "transactionSuccessful": "Transaction Successful",
        "walletBalance": "Wallet Balance ({balance})"
      },
      "addPaymentMethod": {
        "adding": "Adding...",
        "cardDetails": "Card Details",
        "cardSuccessfullyAdded": "Card successfully added",
        "errorWhileAddingCard": "Error while adding new card!",
        "maximumCardUpdateLimitReached": "Maximum card update limit reached",
        "rateLimitMessage": "It seems like you've reached the maximum number of attempts allowed for adding cards today. Please try again after 24 hours."
      },
      "aiProductRebilling": {
        "funnel": " funnel",
        "images": " Images,",
        "per1000Words": " /1000 words, ",
        "perFunnel": " /funnel",
        "perImage": " / Image,",
        "pleaseCheckSupport": "please check our",
        "ratesMayDiffer": "Rates may differ as per region. Calculations shown are as per rates for UK,",
        "ratesMayDifferUS": "Rates may differ as per region. Calculations shown as per twilio rates for US, please check twilio for more details.",
        "pleaseCheckTwilioRates": "Outbound SMS for US/Canada to be charged at $0.0079/segment. Inbound SMS at $0.0075/segment.",
        "words": " words, "
      },
      "api": {
        "advancedFunctionalityNote": "Advanced Functionality Note",
        "agencyApiKeys": "Agency API Keys",
        "apiAccess": {
          "partOfAdvancedApi": "This is part of the Advanced API that is available on the Pro Plan.",
          "toUpgrade": "to upgrade."
        },
        "createNew": "Create New",
        "developerCouncilInfo": "Developer Council Information",
        "noAccess": "You don't have access to this section.",
        "securityAlert": "Security Alert Message",
        "table": {
          "fetchingKeys": "Fetching Company Keys...",
          "noKeysYet": "You do not have any api keys yet.",
          "toCreateFirstKeys": "to create your first api keys."
        },
        "zapierNote": "Zapier Note"
      },
      "calendarBeta": {
        "abilityChooseGoogleCalendars": "Ability to choose Google Calendars to 'Add to' + 'Conflict' Calendars to check to compute availability for every user",
        "abilityToAllocateRoundRobin": "Ability to allocate appointments in round robin",
        "abilityToChooseSpecificUser": "Ability to choose a specific user the appointment to be booked with",
        "adminAbilitySeeEveryUser": "Admin - Ability to see every User's Calendar Appointments",
        "adminAbilityViewAllCalendar": "Admin - Ability to view all User's Calendar Appointments",
        "adminsCanDeleteIntegrations": "Admins can delete any integrations they want, but Users can only remove their own",
        "adminsCanSeeAllIntegrations": "Admins can see all integrations irrespective of who created them but Users can see integrations that they created for themselves",
        "contactDetailAppointments": "Contact Detail > Appointments (New)",
        "conversationsScheduleAppointment": "Conversations > Schedule Appointment (New)",
        "essentialConsiderations": "Essential Considerations",
        "funnelsWebsitesCalendar": "Funnels/Websites > Calendar (New)",
        "helpReorientTriggers": "While on the call, we'll help reorient the triggers to suit the new calendar configuration",
        "iAgreeMessage": "If you are comfortable with the aforementioned changes, please hit 'I Agree' and get started with Calendar (Beta) on this location",
        "integrationNew": "Integration (New)",
        "loseAbilityToViewEdit": "Users on the new version will lose the ability to 'view/edit' Appointments (created on the previous version) through the Opportunity Details modal- but they can continue to perform all those actions on the Appointments page",
        "newOldTriggersCoexist": "The New and Old triggers will co-exist",
        "nonAdminAbilityViewPersonal": "Non-admin - Ability to only view their personal appointments (Assigned data/ Calendar mapping Under TEAM MANAGEMENT has no impact)",
        "nonAdminViewPersonalOnly": "Non-admin - Ability to only view their personal appointments",
        "notAtMoment": "Not at the moment. But we are trying hard to bring it to mobile as soon as possible.",
        "oldAppointmentsCanBeViewed": "The old appointments can well be viewed on the appointments page via a toggle switch.",
        "oldAppointmentsDisplayed": "Old Appointments will be displayed alongside the New Appointments in the same appointments list",
        "oldCalendarVersionAppointments": "Old Calendar Version + Old Appointments",
        "onlyNewCalendarWidget": "Only New Calendar Widget can be added",
        "opportunityAddAppointment": "Opportunity > Add Appointment (New)",
        "profilePageAdmin": "Profile Page for Admin (New)",
        "profilePageAllUsers": "Profile Page (All Users)",
        "providesAllOptions": "Provides for all options (Groups + Services) necessary to configure the new calendar",
        "reintegratingConnectionsRequired": "Re-integrating all connections may be required once the Calendar Beta is enabled for a location",
        "roundRobinHighlight": "The ability to round-robin appointments between different group of agents is the main highlight of this update.",
        "schedulingCalendarAppointments": "Scheduling > Calendar/Appointments (New Filters + Toggle to switch between new and old appointments)",
        "settingsCalendarBeta": "Settings > Calendar (Beta)",
        "surfacingFirstTime": "Surfacing it for the first time",
        "teamManagementAdminOnly": "Team Management (Available to Admins only)",
        "toggleOffNewVersion": "Toggle Off (New Version)",
        "toggleOnOldVersion": "Toggle On (Old Version)",
        "whatChangesWithNewVersion": "What changes does the new version of the Calendar come with?",
        "whatDoesCalendarEntail": "What does the Calendar (Private Beta) entail?",
        "whatHappensToOldAppointments": "What happens to our old appointments after the transition?",
        "whatWillWeSeeMobile": "What will we see on Mobile during Beta?",
        "willOldAppointmentsBeFactored": "Will the old appointments be factored in when computing availability for the fresh appointments?",
        "willOldCalendarUrlsWork": "Will our old Calendar URLs continue to work after the transition?",
        "willWeGetNewVersionMobile": "Will we get to use the new version on Mobile during beta?",
        "yesOldSettingsPageContinues": "Yes. In fact the old settings page will continue to exist and so is your ability to make any changes there. The old calendar widget and the new calendar widget will function independently yet be in constant sync with each other to ensure accurate computation of your availability across the two systems. To avoid confusion, we would highly encourage you to use the new URLs wherever possible, so that you are burdened to monitor two separate URLs for same sets of users.",
        "yesSyncOnGoogleCalendar": "Yes, since there is one-way sync on, the google calendar will ensure that unavailable slots are blocked out."
      },
      "companyPlansModal": {
        "billedAnnually": "Billed Annually",
        "billedMonthly": "Billed Monthly",
        "changePlanFor": "Change Plan for {locationName}",
        "notAuthorized": "You are not authorized to perform this action. Only agency users/admin, location admin can perform it.",
        "payAnnually": "Pay Annually",
        "payMonthly": "Pay Monthly"
      },
      "locationBillingHistory": {
        "billingHistory": "Billing History",
        "cardNo": "Card No.",
        "errorWhileFetchingInvoices": "Error while fetching invoices, click to retry",
        "invoiceDescription": "Invoice Description",
        "invoiceNo": "Invoice No.",
        "noInvoices": "No Invoices",
        "refunded": "Refunded",
        "succeeded": "succeeded",
        "view": "VIEW"
      },
      "locationWallet": {
        "autoRechargeWith": "Auto recharge with",
        "balance": "Balance:",
        "credits": "Credits",
        "seeTransactions": "See Transactions",
        "whenBalanceLowerThan": "when balance lower than"
      },
      "mailTransactionModal": {
        "checkYourEmail": "Please check your email ({emails}).",
        "csvSentMessage": "We will send a CSV file to your email. It usually takes 7 - 10 minutes.",
        "enterEmailAddress": "Enter Email Address",
        "exportAndSendCsv": "Export & Send CSV",
        "exportTransactions": "Export Transactions",
        "itUsuallyArrives": "It usually arrives in 10 minutes.",
        "useCommasToSeparate": "Use commas to separate multiple emails."
      },
      "modifySubscription": {
        "cancelClientDescription": "Cancel your client's subscription and close the account",
        "cancelDescription": "Cancel your subscription and close the account",
        "cancelImmediately": "Cancel Immediately",
        "cancelNow": "Cancel Now",
        "cancelSubscription": "Cancel subscription",
        "changedYourMind": "Changed your mind?",
        "changedYourMindClient": "You can resume your client's subscription",
        "changedYourMindYou": "You can resume your subscription",
        "confirmByTyping": "Confirm by typing {text} below",
        "confirmCancellation": "Confirm Cancellation",
        "modifySubscription": "Modify subscription",
        "modifyYourSubscription": "Modify your subscription",
        "resumeSubscription": "Resume Subscription",
        "subscriptionWillBeCancelledOn": "This will schedule your subscription to be cancelled on {date}. You can resume the subscription by aborting the scheduled cancellation anytime.",
        "subscriptionWillBeCancelledOnClient": "This will schedule your client's subscription to be cancelled on {date}. You and your clients can resume the subscription by aborting the scheduled cancellation anytime.",
        "subscriptionWillBeCancelledOnDate": "Your subscription will be cancelled on {date}.",
        "subscriptionWillBeCancelledOnDateClient": "Your client's subscription will be cancelled on {date}.",
        "subscriptionWillBeResumed": "Your subscription will be resumed and you will start getting billed normally.",
        "subscriptionWillBeResumedClient": "Your client's subscription will be resumed and they will start getting billed normally.",
        "upgradeDescription": "Move to higher subscription plan",
        "weAreGladYouStaying": "We're glad to know that you're staying!",
        "nextBillingDate": "Next billing date: {date}",
        "cancelImmediatelyTitle": "Do you really want to cancel the subscription immediately?",
        "cancelNowDescription": "Your subscription is scheduled to be cancelled on {date}. If you choose to cancel now, then your account, including all outgoing activity like scheduled messages and emails will be stopped immediately.",
        "cancelNowDescriptionClient": "Your client's subscription is scheduled to be cancelled on {date}. If you choose to cancel now, then your client's account, including all outgoing activity like scheduled messages and emails will be stopped immediately.",
        "modifyDescription": "You can {action} your subscription",
        "modifyDescriptionClient": "You can {action} your client's subscription"
      },
      "noPaymentMethodWarning": {
        "addNow": "Add Now",
        "youNeedToEnterCardInfo": "You need to enter your card information.",
        "youNeedToEnterClientCardInfo": "You need to enter your client's card information."
      },
      "productRebilling": {
        "chargesBasedOnTokens": "Charges are based on tokens. Word counts shown below are estimates to help you understand usage. Actual charges may vary.",
        "examplePricingGpt4oMini": "Example Pricing - GPT-4o Mini",
        "for750kWords": "(for 750,000 words) ",
        "gpt4oMini": " GPT-4o-mini ",
        "input": "Input",
        "or": "or ",
        "output": "Output",
        "perImage": " / Image",
        "perResultSelection": " / Result Selection",
        "ratesMayDifferUK": "Rates may differ as per region. Calculations shown are as per rates for UK, please check our",
        "ratesMayDifferUS": "Rates may differ as per region and number type. Calculations shown as per Twilio rates for US,",
        "pleaseCheckSupport": "please check our",
        "resultSelection": " Result Selection",
        "supportDoc": "support doc",
        "forMoreDetails": "for more details",
        "words": " words"
      },
      "removePaymentMethod": {
        "endingIn": "Ending in *{cardNo}",
        "no": "No",
        "removeCard": "Remove Card?",
        "removing": "Removing..",
        "yesRemove": "Yes, Remove"
      },
      "requestSaasModal": {
        "requestClientPaymentDetails": "Request Client Payment Details",
        "saasLocationDescription": "Setup a SaaS subscription for this location",
        "selectSpace": "Select Space",
        "spaceDescription": "Choose where you want to set up billing for this location"
      },
      "saasEnableProducts": {
        "disable": "Disable",
        "enableDisableProducts": "Enable / Disable Products",
        "feature": "Feature",
        "unsavedChanges": "Unsaved Changes"
      },
      "saasSubscriptionPlan": {
        "agencyStripeFailed": "Next billing for this client seems to be in the past. This happens when your agency's stripe account does not function properly. Please login to your agency's stripe to fix it.",
        "copiedText": "copied text:",
        "couldNotCopy": "Async: Could not copy text: ",
        "multiplier": " X ",
        "nextBillingDatePrefix": " Next Billing Date: ",
        "plan": "Plan",
        "pleaseContactAgency": "Please Contact Agency to enable your subscription.",
        "stripeSubscriptionId": "Stripe subscription ID:",
        "subscriptionPlans": "Subscription Plans",
        "subscriptionWillBeCancelledOn": "Your subscription will be cancelled on {date}",
        "subscriptionWillBeCancelledOnClient": "Your client's subscription will be cancelled on {date}",
        "toModifyClientSubscription": "to modify your client's subscription",
        "toModifyYourSubscription": "to modify your subscription",
        "whatsappNumberSubscription": "WhatsApp Number Subscription",
        "yourBillingDatePast": "Your next billing date seems to be in the past. Please contact {email} to fix this. Everything will continue as usual meanwhile."
      },
      "salesResources": {
        "certifiedUser": "Certified User",
        "clearFilter": "Clear Filter",
        "dateRange": "Date Range"
      },
      "upgradePlanProcessedModal": {
        "paymentInfo": "You will be paying $ {amount} /month billed {interval}",
        "planUpgradeFailed": "Your plan could not be upgraded!!",
        "planUpgraded": "Your plan has been upgraded!",
        "retryUpgrade": "Retry upgrade",
        "upgradeFailed": "Your plan upgrade is failed, please try again",
        "upgradedSuccessfully": "You have successfully upgraded your plan {oldPlan} to {newPlan}"
      },
      "upgradePlanSelectionModal": {
        "billedAsMonthlyCharge": "billed as monthly charge of {amount} /month",
        "billedAsYearlyCharge": "billed as yearly charge of {amount} /year",
        "upgradeFrom": "Upgrade from",
        "whatYouWillGet": "What you'll get:"
      },
      "walletTransactionModal": {
        "balanceAfterTransaction": "Balance after transaction:",
        "callDuration": "Call duration:",
        "callSid": "Call SID:",
        "charge": "Charge:",
        "contact": "Contact:",
        "contactName": "Contact name:",
        "contactPhone": "Contact phone:",
        "credit": "Credit:",
        "creditsAfterTransaction": "Credits after transaction:",
        "dateSent": "Date Sent",
        "deleted": "<Deleted>",
        "discount": "Discount:",
        "eventId": "Event ID:",
        "from": "From:",
        "noContactFound": "No contact found",
        "noOfSegments": "No of Segments:",
        "openContactPage": "Open Contact page",
        "openConversation": "Open conversation",
        "openEvent": "Open Event",
        "originalCharge": "Original Charge:",
        "received": "Received",
        "smsSid": "SMS SID:",
        "timeBilled": "Time billed:",
        "timeOfCall": "Time of Call",
        "transactionDetails": "Transaction Details -",
        "transactionId": "Transaction ID:",
        "type": "Type:",
        "segments": "Segments"
      },
      "calendarSettings": {
        "meetings": "Meetings",
        "services": "Services",
        "hideCalendarWarning": "If you want to hide calendar module altogether do so from the subaccount settings > my staff > roles and permissions",
        "calendarSettingsUpdated": "Calendar settings updated",
        "meetingDescription": "Enable this option to allow subaccounts to use the Meetings feature, designed for managing sales calendars, onboarding calls, round-robin scheduling, team collaborations, class bookings, interviews, and more. Ideal for businesses needing flexible and collaborative scheduling tools.",
        "serviceDescription": "Turn on Services to give subaccounts access to a complete booking solution for service-based businesses. This includes creating booking pages with multiple services, managing resources, handling multiple locations, setting staff-specific pricing, adding service variations or add-ons, and more."
      }
    },
    "apiKeys": {
      "apiKey": "ApiKey",
      "copied": "Copied!",
      "copyApiKey": "Copy Api Key",
      "createApiKey": "Create API Key",
      "deleteAllKeys": "Delete All Keys",
      "nameRequired": "The name field is required.",
      "somethingWentWrong": "Sorry! Something went wrong! Try again.",
      "updatedSuccessfully": "Updated successfully"
    },
    "billing": {
      "accountPaused": "Your account {name} has been paused.",
      "accountProvisioned": "Your account is being provisioned.",
      "activateSubAccount": "Activate Sub-Account",
      "activeServices": "Active Services",
      "addNewCard": "Add new card",
      "addNewService": "Add New Service",
      "addPaymentMethod": "add a payment method",
      "alertIcon": "alertIcon",
      "approve": "Approve",
      "authenticateCardMessage": "For added security you need to authenticate your card details again.",
      "badActorWarning": "If you believe that this sub-account was created by a bad actor, we recommend deleting this sub-account and canceling the corresponding subscription.",
      "callUs": "Call us",
      "cancelAndDelete": "Cancel Subscription and Delete Sub-Account",
      "completeFormNextStep": "Please complete form on next step",
      "congratulations": "🎉 Congratulations! 🎉",
      "contactAgency": "Please contact your agency to resolve this issue",
      "contactThroughEmailOrPhone": "You can either contact us through email or phone to resolve this",
      "dataSafe": "All your data is safe and all automations, webpages, etc will resume working after successful payment.",
      "declineSubAccount": "Decline the Sub-Account",
      "deleteRecommendation": "It is recommended to delete this sub-account. Or else you can do that later from Sub-Accounts > Manage Client page.",
      "emailUsAt": "Email us at",
      "moveToDashboard": "Move To Dashboard",
      "noPaymentMethods": "Seems like no payment methods are added! Please",
      "paymentMethod": "Payment Method",
      "paymentMethodUpdated": "Your payment method has been updated",
      "paymentNotCompleted": "You are seeing this message because payment was not completed.",
      "proceedToNextStep": "Proceed to Next Step",
      "questionMark": "?",
      "reachOutMessage": "feel free to reach out to us in case of any questions.",
      "reactivateBillingFor": "Reactivate Billing for {location}",
      "retryPayment": "Retry Payment",
      "secureSystemMessage": "We have moved to a more secure billing system.",
      "setupMessage": "Someone is going to reach out to you to set up the account. It usually takes 12-24 hours,",
      "signout": "Signout",
      "subAccountId": "Sub-Account Id:",
      "successfullyInitiated": "{product} has been successfully initiated",
      "systemError": "There is a system error",
      "toReactivate": "to reactivate the account",
      "userImage": "userImage",
      "verificationSkipped": "The email and phone verification will be skipped for this sub-account and the client will be able to access it.",
      "verifyAccount": "Verify Account",
      "verifyAfterAttempt": "You can verify this account after at least 1 verification attempt from sub-account admin",
      "verifySubAccount": "Verify the Sub-Account",
      "recommendedPlans": "Recommended Plans",
      "buildYourOwnPlan": "BUILD YOUR OWN PLAN",
      "resetToDefaults": "Reset to defaults",
      "paymentMethodChange": "If you need to change payment method",
      "approveSubAccount": "Approve the Sub-Account",
      "approveSubAccountDescription": "The sub-account will be resumed, and the sub-account admins will be able to access and use it.",
      "productInitiated": "Product Initiated"
    },
    "deleteConfirmation": {
      "actionCannotBeReversed": "This action cannot be reversed.",
      "cancelKeep": "Cancel, Keep",
      "confirmDeletionInstructions": "Confirm deletion by typing {word} below:",
      "enterConfirm": "Enter {word} to regenerate",
      "message": "This locations api key will be deleted.",
      "title": "Delete location api key?",
      "yesDelete": "Yes, Delete"
    },
    "generalDetails": {
      "noPermission": "You don't have permission to upload file. Check your permissions with your agency admin.",
      "relatedContacts": "Related Contacts ({count})"
    },
    "locationApiKeys": {
      "deleteAllConfirmMessage": "Are you sure you want to delete all the locations api keys?",
      "deleteAllConfirmTitle": "Delete all Location API keys?",
      "deleteConfirmMessage": "This will delete the api key for Location: {location}. Do you wish to continue?",
      "deleteAgencyApiKeyConfirmMessage": "This will delete the api key. Do you wish to continue?",
      "fetchingLocations": "Fetching locations...",
      "maxApiKeysMessage": "You can have a maximum of 5 API keys.",
      "noLocationsFound": "No locations found",
      "old": "Old",
      "proPlanRequiredMessage": "This is part of the Advanced API that is available on the Pro Plan.",
      "searchLocation": "Search location",
      "title": "Location API Key"
    },
    "locationCard": {
      "deletionScheduledMessage": "This sub-account will be deleted on {date}, if you've changed your mind -",
      "emailUsageNotRebilled": "Email usage is not being rebilled",
      "emailUsageRebilled": "Email usage is being rebilled to your client",
      "listings": "Listings",
      "manageClient": "Manage Client",
      "paymentPending": "Payment is Pending",
      "remainingWalletBalance": "Remaining wallet balance of this SaaS Location",
      "requestPaymentAgain": "Request Payment Again",
      "saasModeActivated": "SaaS mode is activated",
      "saasModeNotActivated": "SaaS mode is not activated",
      "saasSubscriptionNotEnabled": "SaaS subscription plan is not enabled",
      "saasSubscriptionRunning": "SaaS subscription plan is running",
      "social": "Social",
      "switchToSaaS": "Switch to SaaS",
      "switchToSubAccount": "Switch to Sub-Account",
      "telephoneUsageNotBilled": "Telephone usage is not being billed",
      "telephoneUsageRebilled": "Telephone usage is being rebilled to your client",
      "wordpressActive": "Wordpress active",
      "wordpressInactive": "Wordpress inactive",
      "wordpressNotSoldYet": "WordPress not sold yet",
      "wordpressSaleSuccessful": "WordPress sale successful",
      "yextActive": "Yext active",
      "yextInactive": "Yext inactive",
      "yextNotSoldYet": "Yext not sold yet",
      "yextSaleSuccessful": "Yext sale successful",
      "reviews": "Reviews"
    },
    "messageUsage": {
      "acceptTnc": "Please accept T&C",
      "cannotPerformAction": "Can not perform this action. Please reach out to support.",
      "currentLimit": "Current Limit",
      "days": "Day(s)",
      "failedToUpdate": "Failed to update message usage",
      "helpCentre": "Help centre",
      "increaseLimitFurther": "Increase Limit Further",
      "increaseLimitNow": "Increase Limit Now",
      "lessThanUsage": "Current usage is {usage}, and selected usage is less than current usage.",
      "lessThanUsageModal": "Current usage is {usage}, the limit cannot be less than the current usage",
      "limitAlreadyUnlocked": "Limit is already Unlocked",
      "limitReached": "Limit reached",
      "limitUpdatedFrom": "{type} limit updated from {old} to {new}",
      "lookingForSmsLimit": "Looking for SMS Limit?",
      "minLimitShould": "Min limit should be {limit}",
      "newLimit": "New {type} Limit",
      "perDay": "/ Day",
      "sameLimit": "Selected limit is same as current limit!",
      "smsLimitLocation": "SMS Limit can now be found at the location level",
      "smsLimitSettingsInfo": "You can now find these settings under 'Messaging Limit' in 'Advanced Settings'",
      "timesInLast30Days": "Times in last 30 days",
      "todaysUsage": "Today's Usage",
      "typePerDay": "{type} / Day",
      "updateLimit": "Update Limit",
      "updateLimitFor": "Update {type} limit for {name}"
    },
    "prospectDetails": {
      "activeCampaignsWorkflows": "Active {type}",
      "contactSource": "Contact Source",
      "customer": "Customer",
      "noPastCampaignsWorkflows": "No Past {type}",
      "pastCampaignsWorkflows": "Past {type}"
    },
    "settings": {
      "affiliateSettings": "Affiliate Settings",
      "agencyBilling": "Agency Billing",
      "agencyTeamManagement": "Agency Team Management",
      "apiKeys": "API Keys",
      "compliance": "Compliance",
      "customMenuLink": "Custom Menu Link",
      "launchpadSettings": "Launchpad Settings",
      "phoneSystemTwilio": "Phone System - Twilio",
      "smtpService": "SMTP Service",
      "userSettings": "User Settings",
      "agencySettings": "Agency Settings",
      "mailgun": "MailGun"
    },
    "snapshot": {
      "errorCreating": "Error while creating snapshot",
      "pickAnAccount": "You need to pick an account.",
      "snapshotName": "Snapshot name",
      "snapshotNameRequired": "You need to give the snapshot a name."
    },
    "socialDetails": {
      "blogRss": "Blog RSS",
      "foursquare": "Foursquare",
      "foursquareUrl": "Foursquare URL",
      "googlePlacesId": "Google Places ID",
      "googlePlus": "Google+",
      "googlePlusUrl": "Google+ URL",
      "instagramUrl": "Instagram URL",
      "linkedInUrl": "LinkedIn URL",
      "pinterest": "Pinterest",
      "pinterestUrl": "Pintrest URL",
      "yelp": "Yelp",
      "yelpUrl": "Yelp URL",
      "youTube": "YouTube"
    },
    "requestSms": "Request via SMS",
    "iAlreadyHaveACustomer": "I already have a customer",
    "noAccountFound": "No account found !!",
    "thisIs": "This is",
    "pleaseEnterValueBetween0To30Days": "Please enter a value between 0 to 30 days",
    "learnHowToAddOneTimeSetupFeeToThesePlans": "Learn how to add one-time setup fee to these plans",
    "doNotDeleteStripeProductsWarning": "Please <span style=\"font-weight: bold;\">do not delete</span> these products inside your stripe account",
    "opportunityStats": "Opportunity Stats",
    "createNewSnapshot": "Create New Snapshot",
    "stripeSettings": {
      "agencyDashboardVisibleTo": "Agency Dashboard visible to",
      "onlyMe": "Only me",
      "allAgencyAdmins": "All Agency Admins",
      "stripeConnect": "Will be deprecated soon. Switch to Stripe Connect",
      "recommendStripe": "We recommend using stripe connect for better security",
      "switchToStripeConnect": "Switch to Stripe Connect",
      "highLevelAccess": "HighLevel will have access to your data, and can create payments and customers on your behalf",
      "stripeAccountWarning": "Once connected the Stripe account cannot be changed later. It is recommended to use a new Stripe account dedicated to Highlevel earnings.",
      "connectToStripeAccount": "Connect to your Stripe account",
      "unverified": "The Stripe account connected to this agency is unverified and cannot collect payments. Please complete verification by logging in to your stripe account.",
      "loginToStripe": "Login to Stripe",
      "connectedAccount": "Connected Account",
      "verified": "VERIFIED",
      "totalPendingBalance": "Total Pending Balance",
      "disconnectStripe": "Disconnect Stripe",
      "removeSaasPlanConfigurations": "Remove all SaaS Plan Configurations?",
      "haveSaasPlans": "You have SaaS plans created in the Stripe account!",
      "disconnectWarning": "If you disconnect it, all SaaS plans will be lost and you will need to create those again.",
      "acknowledgeDisconnect": "I acknowledge that all my SaaS plans will be lost and I will need to build those again",
      "disconnect": "Disconnect"
    },
    "zoomSuccess": {
      "title": "Hope you had a great experience!",
      "message": "Thanks for being on the call. Looking forward to hosting you again!"
    },
    "supportDashboard": {
      "trialExperienceSpecialist": "Your Trial Experience Specialist",
      "successSpecialist": "Your Success Specialist",
      "supportSpecialist": "Your Support Specialist",
      "jumpOnZoomCall": "Jump on a zoom call with me for your kick-off call",
      "jumpOnChat": "Jump on a chat with me for help",
      "joinVideoCallNow": "Join Video Call Now",
      "whatToExpect": "What to expect?",
      "helpArticles": "Help Articles",
      "changelog": "Changelog",
      "ideasBoard": "Ideas Board"
    },
    "saasDashboard": {
      "title": "Saas Dashboard",
      "plansAndPricing": "Plans & Pricing"
    },
    "listAccounts": {
      "newInterfaceAvailable": "A cleaner, faster interface is now available for this page. Give it a try!",
      "enableInLabs": "Enable in Labs",
      "pendingTransferRequests": "You've got pending sub-account transfer requests.",
      "otherAgenciesRequested": "Other agencies have requested to transfer sub-accounts to you.",
      "reviewRequests": "Review Requests",
      "clientList": "Client List (Sub-Accounts)",
      "subAccountTransfers": "Sub-Account transfers"
    },
    "implementationModal": {
      "title": "Your HighLevel Video call experience is about to begin!",
      "videoCall": "Video Call",
      "whatsNext": "What's Next?",
      "enteringLobby": "You will be entering our lobby with fellow Highlevelers just like you!",
      "successConcierge": "Our Success Concierge will greet you and connect you with the next available advisor for a 1:1 session.",
      "haveReady": "Please have the following ready",
      "stableInternet": "Stable Internet Connection.",
      "videoNameMatches": "Your Video name matches your HighLevel username.",
      "estimatedDuration": "Estimated Session Duration",
      "firstVisit": "First Visit: HighLevel Onboarding Session: (45-60 mins).",
      "returning": "Returning: Continued Implementation Setup Assistance (15-25 mins).",
      "meetingBegins": "Your meeting will begin automatically in &nbsp;<span class=\"text-[#155EEF]\">{ countdown } seconds.</span>&nbsp; Or you can join immediately by clicking the button below:",
      "joinNow": "Join now"
    },
    "gdpr": {
      "logo": "GDPR Logo",
      "dataProtection": "Data Protection and GDPR",
      "introduction": "Introduction",
      "intro1": "HighLevel is committed to protecting the privacy of our users and their customers. We stay appraised of developments in data protection laws to ensure that you can be confident in your safety while using our platform.",
      "intro2": "This page is intended to explain what the rules are, how they apply to your use of the HighLevel platform and the steps we have taken to comply.",
      "intro3": " You should review this document in conjunction with our Privacy Policy and contact a specialist legal professional if you require more information or advice.",
      "gdprRegulation": "General Data Protection Regulation (GDPR)",
      "regulation1": "Regulation (EU) 2016/679, more commonly known at the General Data Protection Regulation (GDPR) is an EU regulation aimed at harmonizing data protection and privacy laws across the EU. The provisions of the GDPR apply wherever personal data of an EU data subject is involved.",
      "regulation2": "The GDPR is focused on giving individuals more control over how their data is used by companies, and making the collection and processing of data more transparent.",
      "regulation3": "The GDPR was incorporated directly into UK law following the end of the Brexit transition period, meaning that UK businesses still have to comply with its provisions through the ‘UK GDPR’.",
      "basicConcepts": "Basic GDPR concepts",
      "controllerAndProcessor": "Controller and processor",
      "controllerProcessorObligation": "The GDPR imposes various obligations on a person depending on whether they are a controller or a processor of personal data.",
      "controllerDefinition": " A controller is an entity which decides to process personal data, and makes decisions regarding the basis of processing and the methods which will be used. Controllers have certain obligations regarding personal data, which you should familiarize yourself with before collecting personal data from your customers.",
      "processorDefinition": "A processor is an entity which processes data for and on behalf of a controller. They make no independent decisions regarding the data or its processing, as they only process it on behalf of the controller and must comply with all instructions given by the controller.",
      "youAreController": "When you use the HighLevel service, you are a controller. You are in control of the data you upload to the HighLevel system, what you do with that data, and why. As a result, you are responsible for ensuring that you have a legal basis on which to process the data, and that you do not retain the data for any longer than is necessary.",
      "highlevelIsProcessor": "You should ensure that you understand your obligations as a controller, and update your own systems and policies to allow the lawful transfer of personal data to HighLevel.HighLevel is a data processor. We, through the HighLevel platform, store and manage the data you have collected under your instructions. We will never use any personal data which you have uploaded to the HighLevel system for our own purposes or without your instruction.",
      "legalBasisForProcessing": "Legal basis for processing",
      "legalBasisRequirement": "Personal data may only be collected and processed if there is a legal basis for doing so. The allowable legal bases are set out in the GDPR.",
      "processorReliesOnCustomers": "As a processor, HighLevel relies on our customers to select the correct basis under which they will be collecting and processing personal data, and to put the appropriate notices and consents in place. Before you use the HighLevel service, you should take time to identify which legal base may be available to you, and only collect and retain personal data to the extent necessary to carry out that basis. You should not change the basis under which you have collected personal data without very good reason, so it is important to understand the requirements of the different bases and make sure you select the right one at the start.",
      "dataSubjectAccessRights": "Data subject access rights",
      "dataSubjectRights": "The GDPR grants data subjects (i.e. your customers) certain rights relating to their personal data, including the right to access, correct and/or delete any data relating to them.",
      "highlevelEasySystems": "HighLevel has put in place easy systems for you to inform us if you receive such a request from a data subject, and for us to inform you if we receive such a request. We will ensure that, following your instructions, these requests are promptly complied with. You should familiarize yourself with the obligations which will be imposed on you, including relating to any personal data you hold on your own systems, or services other than HighLevel.",
      "transfersToUSA": "Transfers of data to the USA",
      "transfersRestrictions": "Personal data may not be transferred outside the EEA other than under specific circumstances. We utilize the Standard Contractual Clauses as part of our Data Processing Agreement which we sign with all of our customers.",
      "dataSecurity": "Data Security",
      "securitySafeguards": "We have put in place strong security safeguards and measures to ensure that any personal data we hold is stored securely. We regularly test our products for bugs and vulnerabilities.",
      "backupSystems": "We ensure that we have regular back-up systems in place, and ensure that we have data recovery and data integrity systems and processes to minimize risk of corruption to or loss of personal data.",
      "stepsForCompliance": "Steps we have taken to ensure GDPR compliance",
      "dutyAsProcessor": "We take our duties as a processor very seriously. We have put in place a number of procedures and taken a number of steps in order to ensure that we remain compliant with the GDPR and that you are able to lawfully send personal data collected by you to us, for example:",
      "standardContractualClauses": "Our data processing agreement utilizes the Standard Contractual Clauses to ensure that you are able to lawfully send personal data to us in the USA.",
      "detectBreaches": "We are able to detect personal breaches and to inform our customers as soon as possible.",
      "dealWithAccessRequests": "We are able to deal with subject access requests and rights of erasure requests, and ensure that we inform you when a data subject has made such a request to us.",
      "assessedDocumented": "We have assessed and documented the personal data processed by us on your behalf.",
      "assessedSecurity": "We have assessed our security and upgraded this where necessary to ensure that it is appropriate for the level of risk we face in relation to a data breach.",
      "dataProcessingAgreement": "Data Processing Agreement",
      "dateUpdated": "Date Updated: April 01, 2023",
      "downloadAgreement": "Download Agreement",
      "supportEmail": "support{'@'}gohighlevel.com",
      "anyQuestions": "Any questions?"
    },
    "sendGridSettings": {
      "title": "SendGrid Settings",
      "settingsForLocations": "SendGrid Settings for Locations",
      "sendGrid": "SendGrid",
      "last12Months": "Last 12 Months",
      "totalSent": "Total Sent",
      "opens": "Opens",
      "clicks": "Clicks",
      "bounces": "Bounces"
    },
    "launchpadSettings": {
      "disableLaunchpad": "Disable Launchpad for all my locations.",
      "description1": "Launchpad is a well thoughtout landing page that is proved to increase customer satisfaction and retention by increasing the product usage. ",
      "description2": "Connecting GMB, FB, Webchat plugin, using mobile app etc have proved to be great features that retain the customers for longer.",
      "confirmDisable": "Are you sure you want to disable Launchpad?"
    },
    "affiliateSettings": {
      "affiliateLinkDescription": "This is your affiliate link, use this link to allow people you know to sign up for an account and you will recieve 40% of their monthly recurring revenue for life.",
      "appendToUrls": "Append this to the end of your URLs:",
      "needToSignUp": "Need to sign up?",
      "goToUrl": "Go to the URL:",
      "andSignUpUsing": "and sign up using the email address",
      "asYourEmailAddress": "as your email address for FirstPromoter.",
      "pageSettings": "Page Settings",
      "facebookPixelId": "Facebook Pixel ID",
      "pixelId": "Pixel ID"
    },
    "agencyAPIKeySettings": {
      "enhancedAccountSecurity": "Starting June 17, 2024, Enhanced Account Security will be automatically enabled on your account by default. The enhanced security enhancements include:",
      "discontinuationOfAutoGeneration": "Discontinuation of Auto-generation of Location API keys",
      "exclusionOfApiKeysInLocationCrudApis": "Exclusion of API Keys in Location CRUD APIs",
      "optOutLink": "To opt-out of this change, please disable Enhanced Account Security in <a href=\"/settings/company\">Settings > Company</a>",
      "advancedFunctionalityNote": "This API is for advanced functionality. Our support team is not able to provide direct assistance regarding the API configuration.",
      "developerCouncilInfo": "We do offer a Developer Council which meets for office hours once a month (<a href=\"https://gohighlevel.com/events\">https://gohighlevel.com/events</a>) and a Developer Community Slack Channel where you can find assistance from the community and our API team. (<a href=\"https://www.gohighlevel.com/dev-slack\">https://www.gohighlevel.com/dev-slack</a>)",
      "zapierNote": "To use zapier you need to use the Location API key for the specific location. You can get that from the list below or by switching into the account using the switcher on the left menu.",
      "partOfAdvancedApi": "This is part of the Advanced API that is available on the Pro Plan.",
      "upgradeMessage": "This is part of the Advanced API that is available on the Pro Plan. <a>Click Here</a> to upgrade."
    },
    "accountMap": {
      "addAccountManually": "Add Account Manually"
    },
    "accountTeamsManagement": {
      "settingsAsGroups": "Settings as Groups."
    },
    "accountDetails": {
      "basicDetails": "Basic Details",
      "saas": "SaaS",
      "rebilling": "Rebilling",
      "marketplaceApps": "Marketplace Apps",
      "advancedEmailSettings": "Advanced Settings",
      "calendarSettings": "Calendar Settings"
    },
    "advancedEmailSettings": {
      "controlLocationSettings": "Control the Location settings",
      "disableAddEmailService": "Disable the Add Email Service button in the sub-account Email Services Settings",
      "disableAddSmtp": "Disable the Add Email Service button in the sub-account Email Services Settings",
      "restrictSubAccountEmailProvider": "Restrict sub-account users to add their own Email service provider",
      "disableAddSmtpDescription": "Restrict sub-account users to add their own Email service provider",
      "enableReVerification": "Enable Re-verification for 90 days",
      "locationNoLeadConnector": "Location does not have LeadConnector as default Email Provider",
      "lcEmailNotEnabled": "Location does not have LeadConnector as default Email Provider",
      "onlyForAgency": "You can only see these setting enabled for agency",
      "onlyVisibleForAgency": "You can only see these setting enabled for agency",
      "reVerificationDescription": "Each email verification status will be revoked after 90 days (Protect your sender reputation and ensure the highest inbox deliverability)"
    }
  },
  "attributes": {
    "addAttribute": "Add Attribute",
    "attributeName": "Attribute Name",
    "enterAttributeName": "Enter attribute name",
    "number": "Number",
    "selectAttributeType": "Select Attribute Type"
  },
  "audit": {
    "changeModal": {
      "additionalMetaData": "Additional Meta Data",
      "title": "Added / Updated Fields"
    }
  },
  "bulkActions": {
    "additionalDetails": "Additional Details",
    "allOnGivenDate": "All on given date",
    "attempted": "Attempted",
    "batchQuantity": "Batch Quantity",
    "bulkActionProcessing": "Bulk Action Processing",
    "bulkActionTitle": "Bulk Action",
    "campaignRequired": "Campaign is required",
    "currentStatus": "Current Status",
    "delayBetweenBatches": "Delay Between Batches",
    "dispatchMode": "Dispatch Mode: {mode}",
    "editBatchQuantity": "Edit Batch Quantity",
    "emailStats": "Email Stats",
    "enterBatchSprintLimit": "Please enter a batch sprint limit",
    "hideStats": "Hide Stats",
    "mode": "Mode",
    "nextProcessingOn": "Next Processing On",
    "noStatsFound": "No stats found",
    "parentBulkActionID": "Parent Bulk Action ID",
    "pleaseEnterQuantity": "Please enter a quantity",
    "processAllAsSoonAsPossible": "Process all as soon as possible",
    "processAllOnGivenDate": "Process all on given date",
    "processDuring": "Process During",
    "processGraduallyDrip": "Process gradually (drip)",
    "processingAllowedOn": "Processing Allowed On",
    "restoredBulkActionId": "Restored bulk action id:",
    "revert": "Revert",
    "revertedBulkActionId": "Reverted bulk action id:",
    "saveChanges": "Save Changes",
    "scheduledStart": "Scheduled Start",
    "showErrorLog": "Show Error Log",
    "showImported": "Show Imported",
    "showStats": "Show Stats",
    "skipped": "Skipped",
    "statistics": "Statistics",
    "statuses": {
      "complete": "Complete",
      "next-drip": "Next Drip",
      "notStarted": "Not Started",
      "processing": "Processing",
      "queueing": "Queueing",
      "reading": "Reading",
      "resumed": "Resumed",
      "reverted": "reverted",
      "waiting": "Waiting"
    },
    "successful": "Successful",
    "tagsAdded": "Tags Added",
    "tagsRemoved": "Tags Removed",
    "tagsRestored": "Tags Restored",
    "timeElapsed": "Time Elapsed",
    "totalExported": "Total Exported",
    "totalMerge": "Total Merged",
    "unknownError": "Unknown error",
    "updateBatchQuantity": "Update Batch Quantity",
    "updated": "Updated",
    "usesDynamicList": "** Uses dynamic list",
    "workflowRequired": "Workflow is required"
  },
  "business": {
    "addedToCompany": "Contact(s) added to company successfully",
    "cantAddMoreContacts": "Cannot add more than 50 contacts at a time",
    "cleanerUi": "Cleaner UI",
    "common": {
      "addContact": "Add Contact",
      "internalServerError": "Internal Server Error",
      "to": "to"
    },
    "companiesNowHave": "Companies now have",
    "companyNoteLabsText": "Company Notes is a labs feature",
    "contactRemoveCompany": "Are you sure you want to remove this contact from the company?",
    "moreFunctionalUx": "More Functional UX",
    "newCompanyUpdate": "New Company Update!",
    "tabs": "Tabs",
    "tasks": {
      "assignTask": "Assign Task",
      "assignee": "Assignee",
      "deleteTask": "Delete Task",
      "editTask": "Edit Task",
      "markAsComplete": "Mark as Complete",
      "markAsPending": "Mark as Pending",
      "nameAndDescription": "Name and Description",
      "noTasksAvailable": "No tasks available"
    },
    "visitLabs": "Visit Labs"
  },
  "calendar": {
    "googleCalendar": "Google Calendar",
    "noSync": "No Sync",
    "outlookCalendar": "Outlook Calendar"
  },
  "common": {
    "topBar": {
      "toggleFrontendDebugger": "Toggle Frontend Debugger"
    },
    "icons": {
      "star": ""
    },
    "errorOccurred": "An error occurred, please try again",
    "tabs": "Tabs",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "goToHomepage": "Go to homepage",
    "leadConnectorHqLogo": "Lead Connector HQ logo",
    "companyLogo": "Company logo",
    "countries": {
      "australia": "Australia",
      "austria": "Austria",
      "czechRepublic": "Czech Republic",
      "belgium": "Belgium",
      "brazil": "Brazil",
      "canada": "Canada",
      "chile": "Chile",
      "denmark": "Denmark",
      "switzerland": "Switzerland",
      "germany": "Germany",
      "estonia": "Estonia",
      "spain": "Spain",
      "finland": "Finland",
      "france": "France",
      "uk": "UK",
      "hongKong": "Hong Kong",
      "hungary": "Hungary",
      "ireland": "Ireland",
      "italy": "Italy",
      "japan": "Japan",
      "kenya": "Kenya",
      "lithuania": "Lithuania",
      "mexico": "Mexico",
      "netherlands": "Netherlands",
      "newZealand": "New Zealand",
      "norway": "Norway",
      "philippines": "Philippines",
      "puertoRico": "Puerto Rico",
      "poland": "Poland",
      "portugal": "Portugal",
      "sweden": "Sweden",
      "singapore": "Singapore",
      "unitedStates": "United States",
      "vietnam": "Vietnam",
      "southAfrica": "South Africa"
    },
    "countryshortcodes": {
      "ca": "CA",
      "eu": "EU",
      "in": "IN",
      "na": "NA",
      "us": "US"
    },
    "misc": {
      "0": "0",
      "1": "1",
      "10": "10",
      "10x": "10x",
      "1 (555) 987-6543": "+1 (555) 987-6543",
      "1x": "1x",
      "3x": "3x",
      "720_x_720_px": " 720 x 720 px",
      "x": "x",
      "g": "G",
      "m": "/M",
      "s": "s",
      "k": " K",
      "esc": "ESC",
      "fb": "fb",
      "ghl": "GHL",
      "mrr": "MRR",
      "dnd": "DND",
      "gbp": "GBP",
      "sms": "SMS",
      "api": "API",
      "otp": "OTP",
      "tcr": "TCR",
      "ein": "EIN",
      "acn": "ACN",
      "cbn": "CBN",
      "vat": "VAT",
      "cvv": "CVV",
      "amex": "AMEX",
      "visa": "VISA",
      "mastercard": "MasterCard",
      "dinersClub": "Diners Club",
      "2fa": "2FA",
      "ivr": "IVR",
      "ppc": "PPC",
      "cpaas": "CPaaS",
      "lc": "LC",
      "a2p": "A2P",
      "sha": "SHA",
      "_frameborder0_scrollingauto_width100_height500ifra": "\" frameborder=\"0\" scrolling=\"auto\" width=\"100%\" height=\"500\"></iframe>",
      "iframe_src": "<iframe src=\"",
      "editNumberPoolStrongnamestrong": "Edit Number Pool - <strong>{name}</strong>",
      "displayphonenumber": "displayPhoneNumber",
      "js_heap_memory": "JS Heap Memory",
      "vuex_store_modules": "Vuex Store Modules",
      "vuex_store_size": "Vuex Store Size",
      "admanagerlogo": "ad-manager-logo",
      "seosearchatlaslogo": "seo-search-atlas-logo",
      "modelimage": "model-image",
      "tipaltiiframe": "tipalti-iframe",
      "fileimage": "file-image",
      "urlimage": "url-image",
      "msgsndr8": "msgsndr8",
      "testmaindomaincom": "testmain{'@'}domain.com",
      "webdevexamplecom": "web-dev{'@'}example.com",
      "httpexamplecom": "http://example.com",
      "smtpgmailcom": "smtp.gmail.com",
      "xyzcomOrUtmcampaignxyz": "xyz.com or utm_campaign=xyz",
      "websitecom": "website.com",
      "strongshakenstirstrongVerifica": "<strong>SHAKEN/STIR</strong> verification is complete for your sub-account. Build trust with your customers through verified calls.",
      "mp3wavfile": "mp3/wav file",
      "usd": "$",
      "1_555_9876543": "+1 (555) 987-6543"
    },
    "stepProgress": "Step {currentStep} of {totalSteps}",
    "loadMore": "Load more",
    "1_segment_is_equal_to_a_sms_of_160_characters_clic": "1 segment is equal to a SMS of 160 characters. Click on the icon to know more details around pricing.",
    "1_segment_is_equal_to_an_sms_of_160_characters_cli": "1 segment is equal to an SMS of 160 characters. Click on the icon to know more details around pricing.",
    "_email": "/ email",
    "_ip": "/ IP",
    "_min": " / min",
    "_of_total": "% of Total",
    "_please_add_a_payment_method_for": "! Please add a payment method for ",
    "_segment": " / segment",
    "_used": "% used",
    "a_new_twilio_account_needs_to_be_created_before_we": "A new twilio account needs to be created before we can start rebilling",
    "a_sub_account_can_have_up_to_10_custom_objects_if_": "A Sub Account can have up to 10 custom objects. If the limit is exceeded, no custom objects will be created from this snapshot.",
    "a_twilio_account_is_already_setup_for_this_location": "A twilio account is already setup for this location",
    "accountName": "Account Name",
    "account_sid": "Account SID:",
    "action": "Action",
    "actions": "Actions",
    "activate": "Activate",
    "active": "Active",
    "active_listeners": "Active listeners",
    "active_subscriptions": "Active Subscriptions",
    "ad_manager": " Ad Manager",
    "add": "Add",
    "addAction": "Add action",
    "add_eliza": "Add Eliza",
    "add_image": "Add image",
    "add_payment_method": "Add payment method",
    "add_to_account": "Add To Account",
    "add_user_icon": "Add User Icon",
    "add_your_first_email": "Add your first email.",
    "address": "Address",
    "adwords_reporting": "Adwords Reporting",
    "affiliate_manager": "Affiliate Manager",
    "agency": "Agency",
    "agency_logo": "agency logo",
    "agency_settings": "Agency Settings",
    "agent_reporting": "Agent Reporting",
    "ai_employee": " AI Employee ",
    "all": "All",
    "allow_subaccounts_to_cancel_their_subscription": "Allow sub-accounts to cancel their subscription",
    "allow_subaccounts_to_upgrade_to_a_higher_plan": "Allow sub-accounts to upgrade to a higher plan",
    "allowed_format": "Allowed Format:",
    "am": "AM",
    "announcements_click_to_open_in_new_tab": "Announcements - click to open in new tab",
    "answers": "Answers",
    "app_name": "App Name",
    "appointments": "Appointments",
    "apps": " apps",
    "ask_ai": "Ask AI",
    "ask_anything": "Ask anything...",
    "assigned_to_another_user": "(Assigned to another user)",
    "at_least_one_location_is_required": "At least one location is required",
    "attach_snapshot": "Attach Snapshot",
    "attribution_reporting": "Attribution Reporting",
    "authorized_representative": "Authorized Representative",
    "automation_type": "Automation Type",
    "available_hours": "Available Hours",
    "avg_memoryinstance": "Avg Memory/Instance",
    "back": "Back",
    "base_url": "Base URL",
    "between_10_kb_and_5_mb": " Between 10 KB and 5 MB",
    "birthday_sms": "Birthday SMS",
    "birthday_sms_with_image": "Birthday SMS with Image",
    "blogging": "Blogging",
    "bounced": "Bounced",
    "bulk_requests": "Bulk requests",
    "business_email": "Business Email",
    "business_hours_configurations": "Business Hours Configurations",
    "business_industry": "Business Industry",
    "business_information": "Business Information",
    "business_logo": "Business Logo",
    "business_niche": "Business Niche",
    "business_phone": "Business Phone",
    "business_physical_address": "Business Physical Address",
    "business_regions_of_operations": "Business Regions of Operations",
    "business_registration_id_type": "Business Registration ID Type",
    "business_registration_number": "Business Registration Number",
    "business_type": "Business Type",
    "business_website": "Business Website",
    "busy": "Busy",
    "buttons": {
      "cancel": "Cancel",
      "confirm": "Confirm",
      "deleteAll": "Delete All",
      "view": "View",
      "close": "Close",
      "previous": "Previous",
      "next": "Next",
      "clear": "Clear",
      "save": "Save",
      "edit": "Edit",
      "delete": "Delete",
      "reset": "Reset",
      "refresh": "Refresh",
      "nextLoading": "Next...",
      "copied": "Copied",
      "notNow": "Not Now",
      "send": "Send",
      "send1": "Send",
      "download": "Download",
      "sendNow": "Send Now",
      "saved": "Saved",
      "back": "Back",
      "update": "Update",
      "add": "Add",
      "submit": "Submit",
      "submitting": "Submitting",
      "done": "Done",
      "manageUsers": "Manage Users",
      "no": "No",
      "yes": "Yes"
    },
    "calendar": "Calendar",
    "calendar_groups": "Calendar Groups",
    "call": "Call",
    "call_reporting": "Call Reporting",
    "call_tracking_is_disabled": "Call tracking is disabled",
    "call_voicemail_settings": "Call & Voicemail Settings",
    "calls": " calls",
    "campaign": "Campaign",
    "campaigns": "Campaigns",
    "cancel": " Cancel ",
    "cancel_subscription": "Cancel Subscription",
    "cancelled": "Cancelled",
    "certificates": "Certificates",
    "change": "Change",
    "changed_data": "Changed Data",
    "charge": " Charge",
    "charged_to_customer": "Charged to customer",
    "chat": "Chat",
    "chat_user": "Chat User",
    "chat_widget_icon": "Chat Widget Icon",
    "chats_will_be_saved_for_2_days": "Chats will be saved for 2 days",
    "check": "check",
    "check_number_validity_before_first_sms_block_incom": "Check number validity before first SMS, block incoming spam calls and lookup names of unknown callers before answering the phone. Additional charges apply",
    "cinque_terre": "Cinque Terre",
    "city": "City",
    "clear_history": "Clear History",
    "click_here": "Click Here",
    "click_on_create_new_snapshot_to_add_one": " Click on Create New Snapshot to add one.",
    "click_to_access_the_highlevel_welcome_course": "Click to access the HighLevel Welcome Course",
    "click_to_upgrade": "Click to Upgrade",
    "clicked": "Clicked",
    "clio": "Clio",
    "cloning": "Cloning",
    "close_debugger": "Close debugger",
    "close_whatsapp_template_creator": "Close WhatsApp Template Creator",
    "collection": "Collection",
    "columns": "Columns",
    "coming_soon": "Coming Soon",
    "company_email_": "Company Email (",
    "complete_component_data": "Complete Component Data",
    "complete_event_data": "Complete Event Data",
    "complete_query_data": "Complete Query Data",
    "completed": "Completed",
    "complimentary_credits": "Complimentary Credits",
    "component": "Component",
    "component_name": "Component Name",
    "component_type": "Component Type",
    "components": " components",
    "condition": "Condition",
    "confirm": "CONFIRM",
    "confirmation_message": "Confirmation Message",
    "confirmed": "Confirmed",
    "connect_with_a_certified_admin_click_to_open_in_ne": "Connect with a Certified Admin - click to open in new tab",
    "connect_with_us_start_live_chat": "Connect with Us - start live chat",
    "connect_your_stripe_account": "connect your Stripe Account ",
    "connect_zoom": "Connect Zoom",
    "consider_leaving_it_blank_should_you_choose_to_use": "Consider leaving it blank, should you choose to use the pre-configured Meeting Location",
    "contact": "Contact",
    "contact_support": "contact support",
    "contact_us_call_highlevel_at_18887324197": "Contact Us - call HighLevel at +1(888)732-4197",
    "contacts": "Contacts",
    "content_ai": "Content AI",
    "controls": "Controls",
    "conversations": "Conversations",
    "copied": "Copied",
    "cost_borne_by_you": " cost borne by you",
    "count": "Count",
    "country": "Country",
    "createNewFolder": "Create New Folder",
    "credit_balance": "CREDIT BALANCE",
    "current_location_id": "Current Location ID",
    "custom": "Custom",
    "custom_email": "Custom Email",
    "custom_niche": "Custom Niche",
    "customer_notifications": "Customer Notifications",
    "customize": "Customize",
    "customize_chat_widget": "Customize Chat Widget",
    "dashboard_stats": "Dashboard stats",
    "data_keys": "Data Keys",
    "date": "Date",
    "days": "Days",
    "dedicated_ip": "Dedicated IP ",
    "default": "Default",
    "default_snapshots": "Default Snapshots",
    "delete": "Delete",
    "deleted": "deleted",
    "delivered": "Delivered",
    "description": "description",
    "details": "Details",
    "disable_gbp_messaging_not_recommended": "disable GBP Messaging (not recommended)",
    "disable_tracking": "Disable Tracking",
    "disabled": "Disabled",
    "dismiss": "Dismiss",
    "display_name": "Display name",
    "do_not_delete": "do not delete",
    "do_something": "DO SOMETHING",
    "do_you_want_to_keep_the_same_or_create_a_new_one": "Do you want to keep the same or create a new one?",
    "download_application_icon": "Download application icon",
    "draft": "Draft",
    "dropdown_icon": "dropdown icon",
    "duplicate": "Duplicate",
    "duration": "Duration",
    "eliza": "Eliza",
    "eliza_bypass_tag_optional": "Eliza Bypass Tag (Optional)",
    "eliza_is_required": "Eliza is required.",
    "eliza_service": "Eliza Service",
    "email": "Email",
    "email_resell_settings": "Email Resell Settings",
    "email_sending": "Email Sending",
    "email_signature": "Email Signature",
    "enable": "Enable",
    "enable_beta": " Enable Beta",
    "enable_company_automation": "Enable company automation",
    "enable_disable_deprecated_features": "Enable / Disable Deprecated Features",
    "enable_gbp_call_tracking": " Enable GBP call tracking ",
    "enable_gbp_messaging": "enable GBP Messaging",
    "enable_signature_on_all_outgoing_messages": "Enable signature on all outgoing messages",
    "enabled": "Enabled",
    "notEnabled": "Not Enabled",
    "enter_a_logical_name": "Enter a logical name",
    "enter_the_exact_business_address_as_it_appears_in_": "Enter the exact business address as it appears in the EIN listing.",
    "enter_the_exact_legal_business_name_as_registered_": "Enter the exact legal business name, as registered with the EIN.",
    "enter_the_full_street_address_as_it_appears_in_the": "Enter the full street address as it appears in the EIN listing.",
    "enter_user_email": "Enter User Email",
    "enter_user_phone_number": "Enter User Phone Number",
    "enter_your_business_registration_id_type": "Enter Your Business Registration ID Type",
    "enter_your_business_vertical_eg_travel": "Enter Your Business Vertical (eg: Travel)",
    "error_code": "Error Code",
    "error_code_chart": "Error Code Chart",
    "error_while_copying_api_key": "Error while copying API Key!",
    "event": "Event",
    "event_bus_listeners": "Event Bus Listeners",
    "events": " events",
    "everything_in": "Everything in ",
    "exact": "Exact",
    "execute_this_action_if_the_current_time_falls_in_t": "Execute this action if the current time falls in this window, else wait until the next window to execute this action.",
    "extension": "Extension",
    "facebook": "Facebook",
    "facebook_ads": "Facebook Ads",
    "facebook_ads_reporting": "Facebook Ads Reporting",
    "facebook_adsets": "Facebook AdSets",
    "facebook_campaigns": "Facebook Campaigns",
    "facebook_icon": "Facebook Icon",
    "facebook_page": "Facebook page",
    "feature_image": "feature image",
    "features": "Features:",
    "feedback": "Feedback: ",
    "file_path": "File Path",
    "firestore_listeners": "Firestore Listeners",
    "forms": "Forms",
    "free": "Free",
    "fri": "Fri",
    "friendly_business_name": "Friendly Business Name",
    "from": " from ",
    "funnels": "Funnels",
    "gbp_call_tracking": "GBP Call Tracking",
    "gbp_configuration": "GBP Configuration",
    "general": "General",
    "general_information": "General Information",
    "generating_link_please_wait": "Generating link, please wait...",
    "google_ads_adgroups": "Google Ads AdGroups",
    "google_ads_ads": "Google Ads Ads",
    "google_ads_campaigns": "Google Ads Campaigns",
    "google_ads_keywords": "Google Ads Keywords",
    "google_business_messaging": "Google Business Messaging",
    "google_business_profile": "Google Business Profile",
    "google_my_business_icon": "Google My Business icon",
    "hello": "Hello ",
    "here": "here",
    "hhmm_a": "hh:mm A",
    "hi": "Hi ",
    "hide": "Hide",
    "highlevel_events_click_to_open_in_new_tab": "Highlevel Events - click to open in new tab",
    "how_can_i_help_you_today": "How can I help you today?",
    "how_did_the_call_go": "How did the call go?",
    "how_do_i_calculate_my_email_cost_click_on_the_icon": "How do i calculate my email cost? Click on the icon to know more",
    "how_does_it_work": "How does it work",
    "htmlElement": "Html Element (TODO):",
    "html_element_todo": "Html Element (TODO): ",
    "id": "ID: ",
    "if": "If",
    "if_activated_the_sender_information_will_be_automa": "If activated, the sender information will be automatically added to the first SMS message of any Bulk Messages to ensure compliance and increase delivery rates.",
    "if_activated_we_will_insert_unsubscribe_links_in_y": "If activated, We will insert unsubscribe links in your email footers, so recipients can unsubscribe without marking the email as a Complaint / Spam.",
    "ignore_this_update": "Ignore this update",
    "image": "image",
    "image_turned_on": "Image Turned On",
    "imported_date": "Imported Date",
    "imported_snapshots": "Imported Snapshots",
    "inbound": "Inbound",
    "inbound_number": "Inbound Number",
    "incoming_call_timeout": "Incoming Call Timeout",
    "instance_id": "Instance ID",
    "instances": "Instances: ",
    "instructions_mentioned_in_this_page": "instructions mentioned in this page",
    "internal": "Internal",
    "intro_message": "Intro Message",
    "intro_question": "Intro Question",
    "invalid": "Invalid",
    "invoicing": "Invoicing",
    "is_scheduled_for_deletion_on": " is scheduled for deletion on ",
    "job_position": "Job Position",
    "job_title": "Job Title",
    "join_our_facebook_group_click_to_open_in_new_tab": "Join our Facebook Group - click to open in new tab",
    "jpg_or_png": " JPG or PNG ",
    "just_one_sec": "Just one sec...",
    "key_sizes": "Key Sizes",
    "label": "label",
    "labels": {
      "sortDirection": "Sort Direction",
      "tableStyling": "Table Styling",
      "loadingMore": "Loading more...",
      "loading": "Loading...",
      "filter": "Filter",
      "search": "Search...",
      "sortBy": "Sort By",
      "perPage": "Per Page",
      "date": "Date",
      "time": "Time",
      "readMore": "Read More",
      "day": "Day",
      "slot": "Slot",
      "template": "Template",
      "city": "City",
      "country": "Country",
      "state": "State",
      "customerName": "Customer Name",
      "friendlyName": "Friendly Name",
      "required": "* required",
      "addressLine1": "Address Line 1",
      "addressLine2": "Address Line 2",
      "postalCode": "Postal Code",
      "searchUsers": "Search Users",
      "unknown": "Unknown",
      "businessName": "Business Name"
    },
    "last_updated": "Last Updated",
    "launchpad_icon": "launchpad icon",
    "lead": "Lead",
    "leadconnector": "LeadConnector",
    "learn_how": "(Learn How?)",
    "legal_business_name": "Legal Business Name",
    "limit_updated_from": " limit updated from ",
    "listeners": " listeners",
    "loading_your_conversation_history": "Loading your conversation history...",
    "location": "Location",
    "locations": " locations",
    "logical_name": "Logical Name",
    "logical_name_is_required": "Logical name is required.",
    "logo": "Logo",
    "mailgun": "MailGun",
    "making_calls": "Making calls",
    "manage_custom_email": "Manage Custom Email",
    "marketing": "Marketing",
    "maximize": "Maximize",
    "me_": "Me (",
    "member_since": "Member Since",
    "membership": "Membership",
    "memory_analysis": "Memory Analysis",
    "memory_api_not_available": "Memory API not available",
    "message": "Message",
    "minimize": "Minimize",
    "minimum_must_be": " Minimum must be ",
    "miscellaneous_charges": "Miscellaneous Charges",
    "missed_call_text_back": "Missed Call Text Back",
    "missed_text_back_call_message": "Missed Text Back Call Message",
    "model": "Model",
    "module": "Module",
    "modules": " modules",
    "mon": "Mon",
    "month": "/month",
    "monthly": "monthly",
    "more_emails_in_thread": " more emails in thread",
    "mount_count": "Mount Count",
    "mount_time": "Mount Time",
    "moved_to_calendar_settings": "Moved to calendar settings",
    "multiple_locations_using_same_twilio_account": "Multiple locations using same twilio account",
    "must_be_in_range_of_0": " Must be in range of 0-",
    "must_be_less_than_monthly_plan_12": " Must be less than Monthly Plan * 12 ",
    "my_business_is": "My business is ",
    "my_snapshots": "My Snapshots",
    "name": "Name",
    "name_of_other_registration_id_type": "Name of Other Registration ID Type",
    "newFolder": "New Folder",
    "new_task_update": "New Task Update!",
    "next": "Next",
    "no_answer": "No Answer",
    "no_bigger_than_25mb": "no bigger than 2.5mb",
    "no_customer_selected": "No customer selected",
    "no_error_data_found": "No error data found",
    "no_payment_method_available": "No Payment Method available",
    "no_provider_found": "No provider found",
    "no_snapshots_found": "No snapshots found!",
    "noshow": "No-Show",
    "not": "Not",
    "not_now": "Not Now",
    "not_saved": "Not saved",
    "notes": "Notes",
    "notifications": "Notifications",
    "now": "Now",
    "numbers_and": " number(s) and ",
    "objective": "Objective:",
    "of": "of",
    "onboarding_video_tutorials_click_to_open_in_new_ta": "Onboarding Video Tutorials - click to open in new tab",
    "online_listings": "Online listings",
    "only_assigned_data": "Only assigned data",
    "open_performance_debugger": "Open Performance Debugger",
    "opened": "Opened",
    "opportunities": "Opportunities",
    "options": {
      "ascending": "Ascending",
      "descending": "Descending",
      "none": "-- None --"
    },
    "or_drag_and_drop": "or drag and drop",
    "outbound": "Outbound",
    "pagination": "Pagination",
    "pass_body_content_here": " Pass Body content here ",
    "password": "Password",
    "paused": "Paused",
    "payment_links": "Payment links",
    "payment_methods": "Payment methods",
    "payment_refund": "Payment Refund",
    "payment_settings_navigation": "Payment settings navigation",
    "payments": "Payments",
    "payments_integration": "Payments Integration",
    "pending": "Pending",
    "per_page": "Per Page",
    "percentage": "Percentage",
    "permanently_delete_this_email": "Permanently delete this email",
    "personal_logo": "Personal Logo",
    "phone": "Phone",
    "phone_number_with_country_code": "Phone Number (With Country Code)",
    "pick_a_niche": "Pick a Niche",
    "pick_a_snapshot": "Pick a snapshot",
    "pick_business_industry": "Pick Business Industry",
    "pick_business_registration_id_type": "Pick Business Registration ID Type",
    "pick_business_type": "Pick Business Type",
    "pick_job_position": "Pick Job Position",
    "plans_pricing": "Plans & Pricing",
    "please_enter_a_value_greater_than_20": "Please enter a value greater than 20.",
    "pm": "PM",
    "points": "Points",
    "postalzip_code": "Postal/Zip Code",
    "previous": "Previous",
    "privacy_policy_url": "Privacy Policy Url",
    "privacy_policy_url_will_be_shown_on_your_google_ag": "Privacy Policy Url will be shown on your google agent info.",
    "process_your_payment": "Process your payment",
    "profile_picture": "Profile Picture",
    "profit": "Profit",
    "prospecting": " Prospecting ",
    "provide_prebuild_snapshots_to_the_new_accounts": "Provide pre-build snapshots to the new accounts.",
    "queries": " queries",
    "questions": "Questions",
    "quick_actions_icon": "Quick actions icon",
    "re_generate_key": "Re Generate key",
    "read_only": "Read Only",
    "receipts_settings": "Receipts settings",
    "receiving_calls": "Receiving calls",
    "recent_events": "Recent Events",
    "recommended": "Recommended",
    "recommended_resolution": "Recommended resolution:",
    "reconnect": "Reconnect ",
    "record_payment": "Record Payment",
    "registered": " registered.",
    "renameFolder": "Rename Folder",
    "replied": "Replied",
    "representative_email": "Representative Email",
    "resell_settings": " Resell Settings",
    "reset": "Reset",
    "resolve_now": "Resolve Now",
    "resource_counts": "Resource Counts",
    "restore": "Restore",
    "results": "Results",
    "reviews": "Reviews",
    "rollover_unused_credits_to_next_month": "Rollover unused credits to next month",
    "row": " row",
    "runNow": "Run Now",
    "sample_data": "(Sample Data)",
    "sat": "Sat",
    "save": "Save",
    "save_missed_call_text_settings": "Save missed call text settings",
    "save_staging_url": "Save Staging URL",
    "saved": "Saved",
    "saving": "Saving..",
    "search": "Search",
    "search_active_apps": "Search active apps...",
    "search_components": "Search components...",
    "search_customer": "Search customer",
    "search_email": "Search Email",
    "search_history": "Search history...",
    "search_icon": "search icon",
    "search_listeners": "Search listeners...",
    "search_modules": "Search modules...",
    "search_queries": "Search queries...",
    "see_this_review_on_gbp": "See this review on GBP ",
    "segments": " segments",
    "select": "Select",
    "select_a_snapshot": "Select a snapshot",
    "monetary": "MONETARY",
    "pleaseSelectAValue": "Please select a value",
    "select_account": "Select Account",
    "select_an_account": "Select an Account",
    "select_eliza_bypass_tag": "Select Eliza Bypass Tag",
    "select_phone_number": "Select Phone Number",
    "select_send_to_eliza_tag": "Select Send to Eliza Tag",
    "select_snapshot": " Select Snapshot",
    "select_upto": "Select upto ",
    "selected": "Selected: ",
    "send": "Send",
    "send_to_eliza_tag_optional": "Send to Eliza Tag (Optional) ",
    "seo": " SEO ",
    "settings": "Settings",
    "setup_pending": "Setup Pending",
    "share": "Share",
    "shared_snapshots": "Shared Snapshots",
    "shared_type": "Shared Type",
    "shipping_and_delivery": "Shipping and Delivery",
    "shipping_origin": "Shipping origin",
    "show": "Show",
    "showed": "Showed",
    "signin_with_single_signon": "Signin with single sign-on",
    "size": "Size",
    "sms_message_sent_to_customer": "SMS message sent to customer",
    "snapshot_date": "Snapshot Date",
    "snapshot_name": "Snapshot Name",
    "social_planner": "Social Planner",
    "sortBy": "Sort By",
    "sortOptions": {
      "createdDate": "Created Date"
    },
    "source": "Source",
    "sources": "Sources:",
    "spent": "Spent",
    "staging_url_settings_for_db_event": "Staging URL Settings (For Db Event)",
    "state": "State",
    "state_prov_region_": "State / Prov / Region *",
    "states": {
      "alabama": "Alabama",
      "alaska": "Alaska",
      "arizona": "Arizona",
      "arkansas": "Arkansas",
      "california": "California",
      "colorado": "Colorado",
      "connecticut": "Connecticut",
      "delaware": "Delaware",
      "district_of_columbia": "District Of Columbia",
      "florida": "Florida",
      "georgia": "Georgia",
      "hawaii": "Hawaii",
      "idaho": "Idaho",
      "illinois": "Illinois",
      "indiana": "Indiana",
      "iowa": "Iowa",
      "kansas": "Kansas",
      "kentucky": "Kentucky",
      "louisiana": "Louisiana",
      "maine": "Maine",
      "maryland": "Maryland",
      "massachusetts": "Massachusetts",
      "michigan": "Michigan",
      "minnesota": "Minnesota",
      "mississippi": "Mississippi",
      "missouri": "Missouri",
      "montana": "Montana",
      "nebraska": "Nebraska",
      "nevada": "Nevada",
      "new_hampshire": "New Hampshire",
      "new_jersey": "New Jersey",
      "new_mexico": "New Mexico",
      "new_york": "New York",
      "north_carolina": "North Carolina",
      "north_dakota": "North Dakota",
      "ohio": "Ohio",
      "oklahoma": "Oklahoma",
      "oregon": "Oregon",
      "pennsylvania": "Pennsylvania",
      "rhode_island": "Rhode Island",
      "south_carolina": "South Carolina",
      "south_dakota": "South Dakota",
      "tennessee": "Tennessee",
      "texas": "Texas",
      "utah": "Utah",
      "vermont": "Vermont",
      "virginia": "Virginia",
      "washington": "Washington",
      "west_virginia": "West Virginia",
      "wisconsin": "Wisconsin",
      "wyoming": "Wyoming",
      "noRecordsFound": "No records found",
      "noEntriesToShow": "No entries to show",
      "unsuccessful": "Unsuccessful",
      "pending": "Pending",
      "noUsersFound": "No users found"
    },
    "status": "Status",
    "stop_delete_operation": "Stop Delete Operation",
    "street_address": "Street Address",
    "street_address_as_it_appears_in_the_ein_listing": "Street Address as it appears in the EIN listing.",
    "stripe_icon": "Stripe Icon",
    "stripe_integration": "Stripe Integration",
    "stripe_secret_key": "Stripe Secret key",
    "subscriptions": "Subscriptions",
    "sun": "Sun",
    "surveys": "Surveys",
    "suspend_subaccount_when_their_saas_subscription_fa": "Suspend Sub-account when their SaaS subscription fails.",
    "switchAccount": "Switch Account",
    "switch_off_sections_below_to_disable": "Switch off sections below to disable",
    "tags": "Tags",
    "tax_settings": "Tax settings",
    "team_management": "Team Management",
    "team_notifications": "Team Notifications",
    "template": "Template",
    "terms_and_conditions": "Terms and Conditions",
    "test_mobile_no": "Test Mobile No.",
    "text_messages": "Text Messages",
    "the_proposed_size_is_350px_180px": "The proposed size is 350px * 180px",
    "the_proposed_size_is_512512px": "The proposed size is 512*512px",
    "the_selected_language_will_be_used_by_the_system_a": "The selected language will be used by the system as default.",
    "the_welcome_message_automatically_appears_after_a_": "The welcome message automatically appears after a user starts a new conversation.",
    "these_are_margins_that_are_billed_to_your_clients_": "These are margins that are billed to your clients over the ",
    "this_data_will_be_used_for_future_compliance_regis": "This data will be used for future compliance registration.",
    "this_is_my_twilio_use_same": "This is my Twilio, use same",
    "this_is_visible_to_both_agency_and_location": "This is visible to both agency and location",
    "this_name_will_be_visible_to_leads_chatting_with_y": "This name will be visible to leads chatting with your business",
    "this_setting_is_applicable_with_only_team_calendar": "This setting is applicable with only team calendars.",
    "this_stripe_customer_is_already_connected_to_anoth": "This Stripe Customer is already connected to another sub-account.",
    "thu": "Thu",
    "tiktok": "Tiktok",
    "time_signed": " Time Signed: ",
    "time_zone_": "Time Zone *",
    "timestamp": "Timestamp",
    "title": "Title",
    "to_resolve_this_problem_follow_the": "To resolve this problem, follow the ",
    "token": "Token:",
    "total": "Total: ",
    "trigger_link": "Trigger Link",
    "triggers": "Triggers",
    "tue": "Tue",
    "twilio": "Twilio",
    "twilio_setup_pending": "Twilio Setup Pending",
    "type": "Type",
    "type_campaign_objective": "Type campaign objective",
    "type_message": "Type message",
    "unsavedChangesWarning": "Your changes will not be saved. Are you sure you want to leave?",
    "unsaved_changes": "Unsaved changes",
    "unsubscribed": "Unsubscribed",
    "unsuccessful": "Unsuccessful",
    "update_business_profile_details": "Update business profile details",
    "update_is_inprogress_visit_integrations_page_to_fi": "Update is in-progress visit integrations page to find more.",
    "update_url": "Update URL",
    "updated_date": "Updated Date",
    "updates": " updates",
    "updating": "Updating...",
    "upgrade_to_agency_pro": "upgrade to Agency Pro ",
    "upload": "Upload",
    "upload_a_file": "Upload a file",
    "usd": " USD",
    "use_this_for_zapier_and_api_integration": "Use this for Zapier and API integration.",
    "user_email": "User Email",
    "user_permissions": "User Permissions",
    "user_role": "User Role",
    "user_type": "User Type",
    "valid": "Valid",
    "verification_status": "Verification Status",
    "verify": "Verify",
    "verify_email_using_otp": "Verify email using OTP",
    "view_less": " View Less ",
    "visiblehidden": "Visible/Hidden",
    "visit_our_help_center_click_to_open_in_new_tab": "Visit our Help Center - click to open in new tab",
    "voicemail": "Voicemail",
    "wave_integration": "Wave Integration",
    "we_have_found_some_errors_in_your_contact_fields_c": "We have found some error/s in your contact fields. Click on the folder to view and resolve.",
    "websites": "Websites",
    "wed": "Wed",
    "welcome_message": "Welcome Message",
    "whatsapp": " WhatsApp",
    "whatsapp_icon": "Whatsapp icon",
    "when": "When",
    "when_selected_calls_will_be_routed_to_your_mobile_": "When selected calls will be routed to your mobile app. (Supported in both iOS and Android)",
    "when_selected_calls_will_be_routed_to_your_web_app": "When selected calls will be routed to your web app.",
    "which_business_do_you_want_to_link_to_this_locatio": "Which business do you want to link to this location?",
    "widget_code": "Widget Code",
    "will_give_you_about": " will give you about",
    "wordpress": "WordPress",
    "wordpress_icon": "Wordpress Icon",
    "workflows": "Workflows",
    "xero_integration": "Xero Integration",
    "you_need_to_complete_few_easy_steps_to_delete_this": "You need to complete few easy steps to delete this location",
    "you_are_not_authorized_to_perform_this_action_only": "You are not authorized to perform this action. Only agency admins can delete sub-accounts.",
    "your_email_cost": "Your email cost",
    "your_facebook_page_has_been_integrated_however_the": "Your Facebook page has been integrated. However, the following features will not work since LeadConnector does not have the required permissions: ",
    "your_outlook_connection_has_expired_please_disconn": "Your outlook connection has expired. Please disconnect & then reconnect with the account to establish the connection.",
    "zip_code": "Zip Code",
    "zoom_connected_please_close_this_modal": "Zoom Connected, Please close this modal",
    "hidden": "Hidden",
    "messageDetails": "Message Details",
    "openOptions": "Open options",
    "progress": "Progress",
    "close": "Close",
    "loading": "Loading",
    "fullName": "Full Name",
    "languages": "Languages",
    "phoneNumber": "Phone Number",
    "phoneNumberWithCountry": "Phone Number with Country Code",
    "sendMessage": "Send Message",
    "services": "Services",
    "servicesProvided": "Services provided",
    "pleaseProvideAValid": "Please provide a valid Phone Number.",
    "copy": "Copy",
    "editApiKey": "Edit API Key",
    "confirmPay": "Confirm & Pay",
    "contactUs": "Contact Us",
    "decline": "Decline",
    "deleteSubaccount": "Delete Sub-Account",
    "disabled1": "disabled",
    "purchaseSummary": "Purchase Summary",
    "subscriptionPlan": "Subscription Plan",
    "businessName": "Business name",
    "chooseOne": "Choose one..",
    "stateProvRegion": "State / Prov / Region",
    "streetAddress": "Street address",
    "timeZone": "Time Zone",
    "website": "Website",
    "zipPostalCode": "Zip / Postal code",
    "apiKey": "API Key",
    "createdAt": "Created At",
    "deleteAllLocationApi": "Delete all location api keys",
    "deleteApiKey": "Delete api key",
    "generatedBy": "Generated By",
    "lastUsedAt": "Last Used At",
    "pageNavigation": "Page navigation",
    "somethingWentWrong": "Something went wrong!",
    "clickHere": "Click here",
    "emailRebillingActive": "Email rebilling active",
    "saasSubscriptionActive": "SaaS subscription active",
    "scheduledForDeletion": "Scheduled for deletion",
    "twilioRebillingActive": "Twilio rebilling active",
    "iAcknowledgeThisIs": "I acknowledge this is a valid sub-account and I have verified the use case of sending more than {limit} {type} / Day",
    "iAcknowledgeThisIs1": "I acknowledge this is a valid sub-account and I have verified the use case of sending hence adjusting the daily SMS limit",
    "emailSentByLocation": "Email sent by location so far today.",
    "goToSmsLimit": "Go To SMS Limit Settings",
    "toIncreaseTheLimit": "To increase the limit further, reach out to support team.",
    "newLimitOfLimit": "New Limit of {limit} is invalid. Please provide a value between {min} and {max}",
    "typeLimitUpdatedSuccessfully": "{type} limit updated Successfully",
    "locationsCurrentLimitIs": "Location's current limit is {current}. You can only update limit between {min} and {max} from here. For any limit updation beyond {maxAllowed}, reach out to support team.",
    "notNow": "Not now",
    "smsSentByLocation": "SMS sent by location so far today.",
    "youHaveSuccessfullyUpdated": "You have successfully updated the limit",
    "willAutoUnlockIn": "Will auto unlock in",
    "contactType": "Contact Type",
    "createdBy": "Created by:",
    "createdOn": "Created on:",
    "dateOfBirth": "Date of Birth",
    "emailAddress": "Email Address",
    "firstName": "First Name",
    "lastName": "Last Name",
    "twilioLookupMarkedThis": "Twilio Lookup marked this phone number as invalid.",
    "twilioLookupStatedThis": "Twilio Lookup stated this is a {type} number, so it won't receive SMS.",
    "accountSnapshot": "Account Snapshot",
    "auditLogs": "Audit Logs",
    "account": "Account",
    "selectAccount": "Select account",
    "facebookUrl": "Facebook URL",
    "instagram": "Instagram",
    "linkedin": "LinkedIn",
    "twitter": "Twitter",
    "twitterUrl": "Twitter URL",
    "youtubeUrl": "YouTube URL",
    "text": "Text",
    "allTagsLinkedTo": "All tags linked to the selected contacts should be removed",
    "automation": "Automation",
    "bulkOperation": "Bulk Operation",
    "campaign1": "Campaign",
    "created": "Created",
    "dateTime": "Date & Time",
    "description1": "Description",
    "drip": "Drip",
    "edit": "Edit",
    "someStatsAreNot": "Some stats are not available if provider is SMTP. Accuracy of metrics depend upon receiver's domain.",
    "error": "Error",
    "from1": "From",
    "immediately": "Immediately",
    "pause": "Pause",
    "processed": "Processed",
    "queued": "Queued",
    "restored": "Restored",
    "resume": "Resume",
    "sent": "Sent",
    "scheduled": "Scheduled",
    "success": "Success",
    "templateName": "Template Name",
    "total1": "Total",
    "totalAttempted": "Total Attempted",
    "user": "User",
    "viewDetails": "View Details",
    "workflow": "Workflow",
    "company": "Company",
    "note": "Note",
    "perPage": "per page",
    "showing": "Showing",
    "task": "Task",
    "tasks": "Tasks",
    "customFields": "Custom Fields",
    "dueDate": "Due Date",
    "tryNow": "Try Now!",
    "archive": "Archive",
    "markAsRead": "Mark as Read",
    "markAsUnread": "Mark as Unread",
    "youNeedToAdd": "You need to add calendar to start scheduling appointments.",
    "additionalNotes": "Additional Notes",
    "appointmentStatus": "Appointment Status",
    "appointmentTitle": "Appointment Title",
    "contactName": "Contact Name",
    "contactTimezoneUsedFor": "Contact Timezone (Used for Reminder)",
    "day": "Day",
    "editAppointment": "Edit Appointment",
    "nameRequired": "Name required",
    "slotRequired": "Slot required",
    "teamMemberIsRequired": "Team member is required.",
    "meetingLocation": "Meeting Location",
    "pickTeamMember": "Pick Team Member",
    "phoneNumbers": "Phone numbers",
    "roundRobin": "Round Robin",
    "selectCalendar": "Select calendar",
    "selectTeamMember": "Select Team Member",
    "actionRequired": "Action Required",
    "scheduleAppointment": "Schedule appointment",
    "considerLeavingItBlank": "Consider leaving it blank, should you choose to use the pre-configured Appointment Title",
    "assignedTo": "Assigned To",
    "download": "Download",
    "loadingTranscription": "Loading transcription...",
    "mute": "Mute",
    "playpause": "Play/Pause",
    "playbackSpeed": "Playback Speed",
    "remove": "Remove",
    "stop": "Stop",
    "timePlayedTotalTime": "Time played : Total time",
    "viewTranscript": "View Transcript",
    "below": "below",
    "calls1": "Calls",
    "liveChat": "Live Chat",
    "whatsapp1": "WhatsApp",
    "chatConversationAssigned": "Chat Conversation Assigned",
    "youAreChoosingNot": "You are choosing not the delete and close the LC Phone sub-account, this means that you will still be charged for all the usage irrespective of location being charged or not.",
    "thingsAreJustGetting": "Things are just getting started, lets explore how GHL can help build your business.\nMeanwhile, you can keep sending messages to your heart's content",
    "wohooConversationsAreFlowing": "Wohoo! Conversations are flowing now",
    "conversationBegan": "Conversation began",
    "fetchOlderMessages": "Fetch older messages",
    "inboundDndHasBeen": "Inbound DND has been activated for this contact",
    "internalComment": "Internal Comment",
    "confirmByTyping": "Confirm by typing",
    "iConfirmToDisconnect": "I confirm to disconnect and close the LC Phone account for this location. I am aware that this would mean all the numbers and A2P Campaigns will be deleted and cannot be retrieved back.",
    "iConfirmThatI": "I confirm that I have discussed this with my client and have authority to take this action",
    "connect": "Connect",
    "disputeThisReview": "Dispute this review",
    "dndIsActiveFor": "DND is active for Calls",
    "off": "OFF",
    "done": "Done",
    "downloadFile": "Download file",
    "AddAccount": "+ Add Account",
    "attachFile": "Attach File",
    "clickHereToAdd": "Click here to add one.",
    "customerName": "Customer Name",
    "customerPhone": "Customer phone",
    "orEnterAMessage": "Or Enter A Message",
    "fromEmail": "From Email",
    "fromName": "From Name",
    "youDontHaveAny": "You don't have any templates yet.",
    "requestPayment": "Request Payment",
    "schedule": "Schedule",
    "selectATemplate": "Select A Template",
    "sendNow": "Send now",
    "smtpProvidersHasSome": "SMTP providers has some limitations. Click here to know more.",
    "subject": "Subject",
    "useATemplateSnippet": "Use a template (Snippet)",
    "deliveredtotalDelivered": "{delivered}/{total} delivered",
    "countMoreEmailsIn": "{count} more emails in thread",
    "primary": "(Primary)",
    "reply": "Reply",
    "respond": "Respond",
    "retry": "Retry",
    "to": "To:",
    "fbCommentReplyDm": "FB Comment reply - DM",
    "fbMessage": "FB Message",
    "theseAttachmentsMayNot": "These attachments may not be supported anymore.",
    "urlCannotBeFound": "URL cannot be found",
    "activity": "Activity",
    "filters": "Filters",
    "goToPost": "Go to post",
    "inboundCall": "Inbound Call",
    "instagramDm": "Instagram DM",
    "internalChat": "Internal Chat",
    "search2": "Search...",
    "starred": "Starred",
    "leftAVoicemail": "Left a voicemail",
    "manual": "Manual",
    "mergeFields": "Merge Fields",
    "addToDocuments": "Add to documents",
    "failedToAddAttachments": "Failed to add attachments to documents",
    "attachmentsAddedToDocuments": "Attachments added to documents successfully",
    "newCommentOnPagename": "New comment on {pageName} post.",
    "outboundCall": "Outbound Call",
    "replyAsDm": "Reply as DM",
    "replyingAsAPrivate": "Replying as a private DM is not available for comments older than 7 days.",
    "reportFeedbackForAi": "Report Feedback for AI",
    "storyMention": "Story Mention",
    "storyReply": "Story Reply",
    "bulkRequest": "Bulk Request",
    "eventsAreCurrentlyCaptured": "Events are currently captured for the contact's email address only.",
    "failed": "Failed",
    "gbpMessage": "GBP Message",
    "pageName": "Page name",
    "unknown": "Unknown",
    "typeAMessage": "Type a message",
    "new": "New",
    "newAppointmentBookedBy": "New appointment booked by",
    "customerNameRequired": "Customer name required",
    "messageIsRequired": "Message is required",
    "pickATemplateTo": "Pick a template to use.",
    "newMessage": "New message",
    "newTask": "New Task",
    "toMakeACall": "To make a call please enter a phone number in this field.",
    "primary1": "Primary",
    "provider": "Provider",
    "refresh": "Refresh",
    "resetPassword": "Reset Password",
    "thisReviewHasAlready": "This review has already been posted to {network}. Are you sure you want to re-post it?",
    "seeThisReviewOn": "See this review on GBP",
    "reviewResponse": "Review Response",
    "searchUsers": "Search Users",
    "sendEmail": "Send Email",
    "sending": "Sending...",
    "thisSubaccountHasPhonenumberco": "This sub-account has {phoneNumberCount} numbers and {campaignsCount} A2P Campaign(s). Deleting this account will still incur charges if the LC Phone System account is not disconnected and closed.",
    "thisSubaccountDoesNot": "This sub-account does not have any numbers and A2P Campaigns. Pausing this account will not incur you any charges but we suggest disconnecting and closing the LC Phone account.",
    "summary": "Summary",
    "unassigned": "Unassigned",
    "viewSubmission": "View Submission",
    "contactSupport": "Contact Support",
    "create": "Create",
    "illDoThisLater": "I'll do this later",
    "enterBusinessName": "Enter Business Name",
    "firstNameOfThe": "First Name of the Business Owner",
    "mobileBusinessPhone": "Mobile / Business Phone",
    "iDontHaveA": "I don't have a website",
    "clientName": "Client Name",
    "letUsSetupYour": "Let us setup your own account or your first client",
    "clientNameIsRequired": "Client name is required",
    "pleaseEnterAValid": "Please enter a valid email address",
    "emailAddressIsRequired": "Email address is required",
    "firstNameIsRequired": "First name is required",
    "lastNameIsRequired": "Last name is required",
    "phoneNumberIsRequired": "Phone number is required",
    "copyOfName": "Copy of {name}",
    "goToDashboard": "Go to Dashboard",
    "permissionsNotEnabled": "Permissions not enabled!",
    "createAndSellCustom": "Create and sell custom products with print-on-demand dropshipping",
    "viewApp": "View App",
    "seamlessFulfillmentRealtimeShi": "Seamless Fulfillment & Real-Time Shipping Rates for Your Ecommerce Stores",
    "learnMore": "Learn More",
    "activateFormMapping": "Activate form mapping",
    "avatarName": "Avatar Name",
    "formFields": "Form Fields",
    "formName": "Form Name",
    "mapFields": "Map Fields",
    "update": "Update",
    "pauseSubaccount": "Pause Sub-Account",
    "pausing": "Pausing...",
    "subaccount": "sub-account",
    "howItWorks": "How it works",
    "uponCompletingThisAction": "Upon completing this action, the transfer request will be sent to the receiving agency ({relNo}). The sub-account will be transferred immediately after they accept it. Please note that this action is irreversible.",
    "ejectSubaccount": "Eject sub-account",
    "newAgencyCreationMail": "New Agency creation mail sent to selected user. User can create new agency by clicking on the link sent in the mail.",
    "unableToTransferSubaccount": "Unable to transfer sub-account to this agency.",
    "nominateAccountOwnerFor": "Nominate Account Owner for the New Account",
    "pleaseConfirmOwnershipWill": "Please confirm ownership will be transferred to",
    "scheduledDate": "Scheduled Date",
    "thisDateIsBased": "This date is based on this company's timezone, which is {timezone}",
    "campaignName": "Campaign name",
    "copyCampaign": "Copy Campaign",
    "endTime": "End time",
    "event10xEmail4": "Event: 10X Email 4 (Listing Distribution) ",
    "10xEmail1Reviews": "10X Email 1 (Reviews)",
    "fromAddress": "From address",
    "leadValue": "Lead value",
    "option1": "Option 1",
    "option2": "Option 2",
    "option3": "Option 3",
    "preview": "Preview",
    "selectCampaign": "Select campaign",
    "startTime": "Start time",
    "time": "Time",
    "users": "Users",
    "noRecordsFound": "No records found",
    "pageDetail": "Page detail",
    "selectAll": "Select All",
    "submission": "Submission",
    "addProduct": "Add Product",
    "visitors": "visitors",
    "By": " by",
    "conversions": "Conversions ",
    "liveReviews": "Live Reviews",
    "liveVisitors": "Live Visitors",
    "pageVisits": "Page Visits",
    "stream": "Stream",
    "addOneOrMore": "Add one or more page URLs or copy them directly from your web browser.",
    "WeWillAutomatically": " We will automatically track your website visitors in real time. ",
    "connectYourLocationsFacebook": "Connect your location's Facebook Account",
    "connected": "Connected!",
    "Contains": " contains ",
    "expression": "Expression",
    "facebookAccount": "Facebook Account",
    "wowYouDontNeed": "Wow! you don't need to configure anything here, you can move on.",
    "Regex": " regex ",
    "selectUrlMatchType": "Select URL match type",
    "Simple": " simple ",
    "LivePreview": " Live Preview",
    "seconds": "seconds",
    "launch": "Launch ",
    "decorativeVector1": "Decorative vector 1",
    "showingFromToTo": "Showing {from} to {to} of {total} entries",
    "cloneProduct": "Clone Product",
    "connectFacebookInstagram": "Connect Facebook & Instagram",
    "connectPage": "Connect page!",
    "everythingIn": "Everything in",
    "agentChat25": "Agent Chat (~ 2 - 5 min wait time )",
    "aiSupportChat": "AI Support Chat",
    "startChat": "Start Chat",
    "locations1": "locations",
    "phone1": "phone",
    "slack": "Slack",
    "segments1": "segments",
    "areYouSureYou": "Are you sure you want to delete this folder?",
    "verified": "Verified",
    "highlevelPrice": "HighLevel Price",
    "howDoesItWork": "How does it work?",
    "payNow": "Pay Now",
    "priceMustBeMore": "Price must be more or equal to HighLevel price",
    "saving2": "Saving",
    "yourPrice": "Your Price",
    "yourProfit": "Your Profit",
    "youNeedToComplete": "You need to complete few easy compliance steps to disable SaaS mode for this location",
    "youAreNotAuthorized": "You are not authorized to perform this action. Only agency admins can perform it.",
    "disableSaasModeFor": "Disable SaaS Mode for {name}",
    "companyBilling": "Company Billing",
    "bccEmailsCommaDelimited": "BCC Emails (comma delimited)",
    "unableToDeleteMailgun": "Unable to delete Mailgun account, please contact support.",
    "forwardingAddress": "Forwarding Address",
    "forwardingAddressesCommaDelimi": "Forwarding addresses (comma delimited)",
    "amount": "Amount",
    "billingDate": "Billing Date",
    "debugWalletTransactionsTotal": "DEBUG Wallet Transactions, Total: {count}",
    "detailedTransactions": "Detailed Transactions",
    "transactionsOnlyAfter26th": "Transactions only after 26th Apr, 2022 are listed and available for export",
    "someRecordsMayTake": "Some records may take 24 hrs to update here.",
    "totalBalance": "Total Balance",
    "walletTransactions": "Wallet transactions",
    "walletTransactionsAllDate": "Wallet Transactions - All - {date}",
    "enterMessage": "Enter message",
    "applyThisChangeTo": "Apply this change to all sub-accounts.",
    "characters": "Characters",
    "iConfirmThatI1": "I confirm that I have discussed this with my client and I have their approval.",
    "iConfirmThatI2": "I confirm that I will ensure all SMS messages sent from this account are in compliance with current policy.",
    "theContentsOfThis": "The contents of this message will automatically be added to the first SMS that's sent via Bulk Messages.",
    "iConfirmThatSms": "I confirm that SMS messages will only be sent to contacts who have opted in to receiving SMS.",
    "quickTip": "Quick Tip",
    "messageWillBeAppended": "Message will be appended in first sms of a conversion if it does not contains opt out language",
    "readMore": "Read More",
    "noncompliantActivityMayLead": "Non-compliant activity may lead to the suspension of your account's SMS & voice-related features.",
    "typeConfirmBelowTo": "Type Confirm below to proceed",
    "products": "Products",
    "chooseCountry": "Choose country...",
    "email2": "Email*",
    "firstName1": "First Name*",
    "lastName1": "Last Name*",
    "brandDetails": "Brand Details",
    "brandName": "Brand name*",
    "useEitherLegalName": "Use either legal name of the organization which is sending the messages, or your own name if this brand is not for an organization.",
    "businessIndustry": "Business Industry*",
    "chooseVertical": "Choose vertical...",
    "mobileNumberForOtp": "Mobile Number For OTP Verification (With country code)*",
    "pleaseProvideAMobile": "Please provide a mobile number that you have access to so you can confirm OTP verification. Only US/Canadian numbers will be accepted. You may not use a CPaaS phone number such as one obtained from LeadConnector. You cannot use the same mobile number to register more than 3 Sole Proprietor brands. This limit is managed by TCR.",
    "increasedDeliveryRate": "Increased delivery rate",
    "sendUpto3000Segments": "Send upto 3000 segments per day",
    "businessDetails": "Business Details",
    "thereWasSomeIssue": "There was some issue while submitting the Profile.",
    "yourProfileSubmissionFailed": "Your profile submission Failed.",
    "endUserConsent": "End user consent",
    "minLength40Characters": "Min length: 40 characters. Max length: 2048 characters.",
    "closeExamples": "Close Examples",
    "sampleMessage1": "Sample message #1*",
    "seeExamples": "See Examples",
    "enterCampaignDetails": "Enter campaign details",
    "youWillReceiveAn": "You will receive an OTP message on your provided mobile number to verify from TCR. Please reply Yes within 24 hrs of receiving the SMS.",
    "brandNameIsRequired": "Brand Name is required.",
    "businessVerticalIsRequired": "Business Vertical is required.",
    "mobileNumberIsRequired": "Mobile Number is required.",
    "hideDetail": "Hide Detail",
    "showDetail": "Show Detail",
    "people": "people",
    "person": "person",
    "after": "after",
    "before": "before",
    "hour": "hour",
    "hours": "hours",
    "minute": "minute",
    "minutes": "minutes",
    "triggerLinksEmbeddedIn": "trigger links (embedded in message) clicked as % of messages sent",
    "addNewEvent": "Add New Event",
    "addTask": "Add Task",
    "manualCall": "Manual Call",
    "manualSms": "Manual SMS",
    "messenger": "Messenger",
    "wait": "Wait",
    "webhook": "Webhook",
    "about": "About",
    "accessRestricted": "Access Restricted",
    "addPartner": "Add Partner",
    "addPartnerForm": "Add Partner Form",
    "affiliatePortal": "Affiliate Portal",
    "badges": "Badges",
    "aBriefBio": "A brief bio",
    "dashboard": "Dashboard",
    "experience": "Experience",
    "industryServed": "Industry Served",
    "instagramAccount": "Instagram account",
    "invoiceHistory": "Invoice History",
    "englishGermanHindi": "English, German, Hindi",
    "linkToWebsite": "link to website",
    "linkedinAccount": "LinkedIn account",
    "locationId": "Location Id",
    "partnerName": "Partner Name",
    "partnerStatus": "Partner Status",
    "paymentDetails": "Payment Details",
    "paymentHistory": "Payment History",
    "profilePhoto": "Profile Photo",
    "profilePhotoUrl": "profile photo url",
    "promoterReports": "Promoter Reports",
    "searchPartner": "Search Partner",
    "twitterAccount": "Twitter account",
    "updatePartner": "Update Partner",
    "updatePartnerForm": "Update Partner Form",
    "yearOfExperience": "year of experience",
    "youtubeAccount": "Youtube account",
    "serviceProvided": "Service Provided",
    "controlTheSubaccountSettings": "Control the Sub-account Settings",
    "generalInfo": "General Info",
    "okay": "Okay",
    "proceed": "Proceed",
    "addCard": "Add Card",
    "makeThisCardPrimary": "Make this card primary",
    "nameOnCard": "Name on Card",
    "chargedToCustomer": "Charged to Customer",
    "clientBillingPage": "Client Billing page",
    "companyStripeIntegrationPage": "Company Stripe Integration page",
    "enableRebilling": "Enable Rebilling",
    "enabling": "Enabling...",
    "forMoreDetails": "for more details.",
    "youreOnTheFreelancer": "You're on the Freelancer plan which limits you to 1.05x markup.",
    "minimumAmountShouldBe": "Minimum amount should be between ${min} and ${max}",
    "beforeEnablingThisFeature1": "Before enabling this feature, please connect your Stripe account on the",
    "planToSetYour": "plan to set your margins higher.",
    "rebillAmount": "Rebill Amount",
    "supportDoc": "support doc",
    "10WillGiveYou": "$10 will give you about",
    "minimumMustBeBetween": "Minimum must be between 0.0001 to 0.005",
    "sorryYouCannotRebillAtTheMarkup": "Sorry! you cannot rebill at the markup on the Freelancer plan, please",
    "modifyingTheseSettingsWillChange": "Modifying these settings will change the cost incurred by your clients going forward.",
    "pleaseDoNotModifyThese": "Please do not modify these if you aren't sure of its effects.",
    "theseSettingsWillApply": "These settings will apply to your new clients going forward",
    "congratulationsYourDedicatedIp": "Congratulations! Your dedicated IP reselling value has been successfully saved.",
    "youHaveAgreedToProvide": "You have agreed to provide dedicated IP's directly to a sub-account. The agency will cover the charges on behalf of the sub-account.",
    "youHaveDiscontinuedToProvide": "You have discontinued to provide dedicated IP's directly to a sub-account. The agency will no longer cover the charges on behalf of the sub-account.",
    "oopsSomethingWentWrongAndWeCouldnt": "Oops! Something went wrong, and we couldn't save your dedicated IP reselling configuration. Please try again later.",
    "pleaseAgreeToTheTerms": "Please agree to the terms",
    "errorWhileFetchingDomains": "Error while fetching domains",
    "sameStripeCustomerProfileCantBeMapped": "Same Stripe customer profile can't be mapped to more than one sub-account.",
    "pleasePickADifferentStripeCustomer": "Please pick a different Stripe customer profile or use \"Share a link\" option so we can create a new Stripe customer profile for this sub-account.",
    "clickNextToChooseAPlan": "Click 'Next' to choose a plan and create a new subscription.",
    "youDontHaveAnyActiveSubscriptions": "You don't have any active subscriptions",
    "youCanEitherSelectAnExistingSubscription": "You can either select an existing subscription, or create a new subscription in the next step.",
    "useCommasToSeparateMultipleEmails": "Use commas to separate multiple emails.",
    "useCommasToSeparateMultiplePhoneNumbers": "Use commas to separate multiple phone numbers.",
    "noUserFoundInThisLocation": "No User found in this location",
    "noPhoneNumberAttached": "No Phone Number attached",
    "pleaseUseTheFollowingLinkToAttachYourPaymentMethod": "Please use the following link to attach your payment method.",
    "allowDuplicateContact": "Allow Duplicate Contact",
    "allowDuplicateOpportunity": "Allow Duplicate Opportunity",
    "mergeFacebookContactsByName": "Merge Facebook Contacts By Name",
    "onlyIncomingMessagesFromFacebookWillBeMerged": "Only incoming messages from Facebook will be merged if they match an exisitng contact's name. Names are case-sensitive.",
    "disableContactTimezone": "Disable Contact Timezone",
    "markEmailsAsInvalidDueToHardBounce": "Mark Emails as Invalid due to Hard Bounce",
    "contactsEmailsWillBeMarkedAsInvalid": "Contact's Emails will be marked as Invalid automatically when it Hard Bounces. Email actions in Automations will be skipped for Contacts with Invalid Emails.",
    "gatherIntelligenceOnUnknownPhoneNumbers": "Gather Intelligence on Unknown Phone Numbers",
    "makeSmsCompliantByAddingAnOptOutMessage": "Make SMS compliant by adding an opt out message.",
    "ifActivatedTheOptOutMessageWillBeAutomaticallyAdded": "If activated, the opt-out message will be automatically added to the first SMS that's sent via Bulk Messages to ensure compliance and increase delivery rates.",
    "platformLanguage": "Platform Language",
    "outboundCommunicationLanguageForCustomValues": "Outbound communication language for custom values",
    "updateInformation": "Update Information",
    "upgradeToTheAgency": "Upgrade to the Agency Pro",
    "yourCost": "Your Cost",
    "addACalendarTo": "Add a calendar to start booking appointments.",
    "addselectAContactTo": "Add/Select a contact to schedule appointments",
    "appointmentSlotIsNot": "Appointment slot is not yet picked",
    "loading1": "Loading . . .",
    "teamMemberIsRequired1": "Team Member is required",
    "currentPlan": "Current plan",
    "features1": "Features",
    "upgrade": "Upgrade",
    "viewLess": "View Less",
    "viewMoreCount": "View More (+{count})",
    "cardNumber": "Card Number",
    "expiryDate": "Expiry Date",
    "paymentMethods": "Payment Methods",
    "primaryCard": "Primary Card",
    "removeCurrentCard": "Remove Current Card",
    "AddBalance": "+ Add Balance",
    "complimentaryCredits": "Complimentary Credits:",
    "expiringOnDate": "Expiring on {date}",
    "apiVersion": "API Version",
    "application": "Application",
    "ipAddress": "IP address",
    "related": "Related",
    "request": "Request",
    "yourAccountIncludingAll": "Your account, including all outgoing activity like scheduled messages and emails will be stopped immediately.",
    "yourAccountIncludingAll1": "Your account, including all outgoing activity like scheduled messages and emails will be stopped immediately.",
    "nextBillingDateDate": "Next Billing Date: {date}",
    "scheduledForCancellation": "Scheduled for cancellation",
    "abandoned": "Abandoned",
    "add1": "Add",
    "addOpportunity": "Add opportunity --",
    "addOpportunityName": "Add Opportunity Name",
    "Task": "+ Task",
    "bookupdateAppointment": "Book/Update Appointment",
    "companyName": "Company Name",
    "areYouSureYou1": "Are you sure you want to delete this opportunity?",
    "contactInfo": "Contact Info",
    "editOpportunity": "Edit opportunity --",
    "enterValue": "Enter Value",
    "goToContactDetail": "Go to Contact Detail Page",
    "leads": "Leads",
    "lost": "Lost",
    "nameIsRequired": "Name is required.",
    "youreNotAllowedTo": "You're not allowed to change customer name!! Check your permission with agency admin.",
    "open": "Open",
    "opportunity": "Opportunity",
    "opportunityAlreadyExistsIn": "Opportunity already exists in this pipeline",
    "opportunityInfo": "Opportunity Info",
    "opportunityName": "Opportunity Name",
    "opportunitySource": "Opportunity Source",
    "owner": "Owner",
    "pipeline": "Pipeline",
    "removeOwner": "Remove owner",
    "selectPipeline": "Select Pipeline",
    "selectStage": "Select Stage",
    "stage": "Stage",
    "countTasks": "{count} tasks",
    "won": "Won",
    "and": "and ",
    "addASubscription": "Add a Subscription",
    "noSaasPlanEnabled": "No SaaS Plan Enabled",
    "per": "per",
    "assignTo": "Assign To",
    "assignedTo1": "Assigned to:",
    "areYouSureYou2": "Are you sure you want to delete this task?",
    "due": "Due:",
    "dueDateIsRequired": "Due date is required",
    "dueIn": "Due in",
    "dueToday": "Due today",
    "late": "Late",
    "notAssigned": "Not assigned",
    "taskDescription": "Task Description",
    "taskTitle": "Task Title",
    "annually": "annually",
    "attachments": "Attachment/s",
    "areYouSureYou3": "Are you sure you want to delete this bulk request?",
    "startImmediately": "Start Immediately",
    "customers": "Customers",
    "tag": "Tag",
    "pickType": "Pick type",
    "whoShouldItRun": "Who should it run for?",
    "addBulkRequest": "Add Bulk Request",
    "editBulkRequest": "Edit Bulk Request",
    "scheduledDateIsRequired": "Scheduled date is required",
    "newCampaignName": "New Campaign Name",
    "areYouSureYou4": "Are you sure you want to delete this campaign?",
    "moveToFolder": "Move to folder",
    "pleaseRename": "please rename",
    "removeFromFolder": "Remove From folder",
    "photoPreview": "photo preview",
    "pleaseWait": "Please wait...",
    "customValues": "Custom Values",
    "whatActionShouldWe": "What action should we perform?",
    "entitynameName": "{entityName} Name",
    "useLcEmail": "Use LC Email",
    "21Jun2018": "21 Jun 2018",
    "930Am": "9.30 AM",
    "Via": " via ",
    "createdTrackingNumbers": "Created Tracking Numbers",
    "iUnderstandImBuyingadding": "I understand I'm buying/adding {count} new phone numbers.",
    "forwardCallsTo": "Forward Calls To",
    "numberName": "Number Name",
    "numberPoolName": "Number Pool Name",
    "numberToSwap": "Number to Swap",
    "sameAsForwardingNumber": "Same As Forwarding Number",
    "callFromSource": "Call from [Source].",
    "callRecording": "Call Recording",
    "84Complete": "84% Complete",
    "thisCallWillBe": "This call will be recorded for quality assurance.",
    "whisperMessage": "Whisper Message",
    "allExceptDirect": "All Except Direct",
    "allExceptDirectOrganic": "All Except Direct & Organic",
    "allSearch": "All Search",
    "allVisitorsRecommended": "All visitors (recommended)",
    "bing": "Bing",
    "direct": "Direct",
    "visitorsWithoutAReferring": "Visitors without a referring website",
    "for": "for",
    "google": "Google",
    "landingPageOrUrl": "Landing page or URL parameter",
    "organic": "Organic",
    "paid": "Paid",
    "pickOneYouCan": "Pick one - you can always change this later.",
    "ppcSearch": "PPC search",
    "visitorsFromGoogleBing": "Visitors from Google, Bing, and Yahoo PPC search",
    "referringPage": "Referring page",
    "visitorsFrom": "Visitors from",
    "visitorsFromGoogleAds": "Visitors from Google Ads",
    "visitorsWhoAreReferred": "Visitors who are referred from",
    "visitorsWhoLandOn": "Visitors who land on",
    "whichVisitorsDoYou": "Which visitors do you want to track?",
    "yahoo": "Yahoo",
    "17Complete": "17% Complete",
    "callTimeoutS": "Call timeout (s)",
    "callWhisper": "Call whisper",
    "disableVoicemailDetect": "Disable voicemail detect",
    "eventName": "Event name",
    "timeoutSeconds": "Timeout (seconds)",
    "editCall": "Edit Call",
    "callWillPatchInstantly": "Call will patch instantly, we will not listen to see if the voicemail picked up on the leads side. This means the camapign will be marked as replied even if voicemail picked up.",
    "thisIsTheMessage": "This is the message you want the person who picks up the phone to hear, you can use custom variables to customize this.",
    "pleaseCheckTheLinks": "Please check the links where you have a custom value. There is an extra '%20' between the {{ and the custom_values.",
    "anErrorOcurredPlease": "An error ocurred, please try again.",
    "pleaseInsertATo": "Please insert a to address.",
    "pickEmailTemplate": "Pick email template",
    "sendTest": "Send Test",
    "composeEmail": "Compose Email",
    "composeEmailTemplate": "Compose Email Template",
    "toAddress": "To Address",
    "addFileThroughUrl": "Add file through URL",
    "appCharacters": "App Characters:",
    "approximateCost": "Approximate Cost:",
    "estimatedCostForUs": "Estimated cost for US to US SMS only.",
    "mobilePhoneNumber": "Mobile Phone Number",
    "numSegments": "Num. Segments",
    "pickMessageTemplate": "Pick message template",
    "pleaseProvideAPhone": "Please provide a phone number to send the test to.",
    "composeEventtype": "Compose {eventType}",
    "composeEventtypeTextTemplate": "Compose {eventType} Text Template",
    "unsupportedSmsContentType": "Unsupported SMS Content Type {fileType}",
    "countOfTheProvided": "{count} of the provided URL attachments {plural} not an image. This may cause errors within Twilio. Do you wish to save anyways?",
    "dropFileHereOr": "Drop file here or click to upload",
    "ifYouHaveAdditional": "If you have additional questions please see the Voicemail Drop FAQ in the help section.",
    "editVoicemail": "Edit Voicemail",
    "selectAMp3Or": "Select a mp3 or wav file, we do not support other formats.",
    "voicemailFile": "Voicemail file",
    "warningVoicemailDropsAre": "Warning: Voicemail drops are a best attempt system and work roughly 70% of the time.",
    "youNeedToPick": "You need to pick atleast 1 day",
    "editWait": "Edit Wait",
    "url": "URL",
    "customTime": "Custom time",
    "executeThisActionIf": "Execute this action if the current time falls in this window, if the current time is outside this window skip this step and move on to the next action.",
    "pickDays": "Pick days",
    "pickTime": "Pick time",
    "noRecordsFound1": "No records found.",
    "formAnalyze": "Form Analyze",
    "totalSubmission": "Total Submission",
    "forgotPassword": "Forgot password?",
    "orContinueWith": "Or continue with",
    "signIn": "Sign in",
    "signIntoYourAccount": "Sign into your account",
    "thePasswordYouPicked": "The password you picked",
    "yourEmailAddress": "Your email address",
    "newEmailFrom": "New email from",
    "newMessageFrom": "New message from",
    "hasLeftANew": "has left a new review.",
    "repliedToTheReview": "replied to the review.",
    "loaded": "Loaded",
    "snapshot": "Snapshot",
    "appointment": "Appointment",
    "appointmentDueInMinutes": "Appointment due in {minutes} min for {contactName}",
    "appointmentReminder": "Appointment Reminder",
    "completedCount": "Completed: {count}",
    "conversation": "Conversation",
    "facebookReview": "Facebook Review",
    "failedCount": "Failed: {count}",
    "googleReview": "Google Review",
    "internalChatMessage": "Internal Chat Message",
    "usernameMentionedYouIn": "{userName} mentioned you in a conversation with {contactName}",
    "newAppointmentAssigned": "New Appointment Assigned",
    "aNewAppointmentWith": "A new Appointment with {contactName} has been assigned to you.",
    "newAppointmentBooked": "New Appointment Booked",
    "youHaveNewAppointment": "You have new appointment booked with {contactName}",
    "newCall": "New Call",
    "aNewChatWith": "A new chat with {contactName} has been assigned to you.",
    "newEmail": "New Email",
    "newMention": "New Mention",
    "newReviewReceivedFrom": "New review received from {contactName}",
    "aNewTypeIs": "A new {type} is received from {contactName}",
    "notification": {
      "noRecentActivity": "No Recent Activity"
    },
    "subAccount": "Sub-Account",
    "subaccount1": "Sub-Account:",
    "titleOnDateAt": "{title} on {date} at {time} for {contactName}",
    "titleDueInDuetime": "{title} due in {dueTime} {unitOfTime} for {contactName}",
    "taskReminder": "Task Reminder",
    "youHaveCountTasks": "You have {count} tasks due today",
    "youHaveCountTasks1": "You have {count} tasks overdue till now",
    "droppedVoicemailTo": "Dropped voicemail to",
    "errorWhileCloningProduct": "Error while cloning product!",
    "productName": "Product Name",
    "selectLocations": "Select locations",
    "selectUptoMaxselectablelocatio": "Select upto {maxSelectableLocations} locations",
    "highlevelInc": "HighLevel Inc.",
    "CountMore": "+ {count} more",
    "emails": "Emails",
    "accountNotification": "Account Notification",
    "customerCare": "Customer Care",
    "deliveryNotification": "Delivery Notification",
    "fraudAlertMessaging": "Fraud Alert Messaging",
    "higherEducation": "Higher Education",
    "lowVolumeMixedRecommended": "Low Volume Mixed (Recommended)",
    "mixed": "Mixed",
    "pollingAndVoting": "Polling and Voting",
    "publicServiceAnnouncement": "Public Service Announcement",
    "securityAlert": "Security Alert",
    "mixedRecommended": "Mixed (Recommended)",
    "australiaCompanyNumberFrom": "Australia: Company Number from ASIC (ACN)",
    "canadaCanadianBusinessNumber": "Canada: Canadian Business Number (CBN)",
    "indiaCorporateIdentityNumber": "India: Corporate Identity Number",
    "greatBritainCompanyNumber": "Great Britain: Company Number",
    "usaEmployerIdentificationNumbe": "USA: Employer Identification Number (EIN)",
    "other": "Other",
    "israelRegistrationNumber": "Israel: Registration Number",
    "estoniaVatNumber": "Estonia: VAT Number",
    "cooperative": "Co-operative",
    "corporation": "Corporation",
    "limitedLiabilityCompanyOr": "Limited Liability Company Or Sole-Proprietorship",
    "nonprofitCorporation": "Non-profit Corporation",
    "partnership": "Partnership",
    "ceo": "CEO",
    "cfo": "CFO",
    "director": "Director",
    "generalCounsel": "General Counsel",
    "onlineTrainingEducation": "Online Training & Education",
    "financialServices": "Financial Services",
    "fitnessLifestyle": "Fitness & Lifestyle",
    "healthMedical": "Health & Medical",
    "homeServices": "Home Services",
    "legalServices": "Legal Services",
    "marketingAdvertising": "Marketing & Advertising",
    "others": "Others",
    "realEstate": "Real Estate",
    "restaurants": "Restaurants",
    "retailEcommerce": "Retail & E-Commerce",
    "yourInformationHasBeen": "Your information has been successfully submitted.",
    "somethingWentWrong1": "Something went wrong",
    "newPassword": "New Password",
    "proceedToLogin": "Proceed to Login",
    "anyTime": "any time.",
    "callUsHighlevelSupport": "Call us HighLevel Support at",
    "troubleLoggingIn": "Trouble Logging In?",
    "sendSecurityCode": "Send Security Code",
    "sendCodeToEmail": "Send code to email",
    "verifySecurityCode": "Verify Security Code",
    "privacyPolicy": "Privacy Policy",
    "businessProfile": "Business Profile",
    "reserveWithGoogleIntegration": "Reserve with Google Integration",
    "friendlyName": "Friendly Name",
    "updateCallerId": "Update Caller ID",
    "internationalFormat": "International Format",
    "localFormat": "Local Format",
    "poolNumbers": "Pool Numbers",
    "swappingNumbers": "Swapping Numbers",
    "selectField": "Select Field",
    "surveyAnalyze": "Survey Analyze",
    "locationIsRequired": "Location is required.",
    "newSurveyName": "New Survey Name",
    "copySurvey": "Copy Survey",
    "primaryCalendar": "Primary calendar",
    "cloneEntityname": "Clone {entityName}",
    "youHaveSuccessfullySubmitted": "You have successfully submitted documents",
    "addCustomValue": "Add Custom Value",
    "value": "Value",
    "youHaveSuccessfullyDeleted": "You have successfully deleted the bundle.",
    "bundleDeletedSuccessfully": "Bundle Deleted Successfully",
    "thereIsAnIssue": "There is an issue with one of your Supporting Documents. Please review the Supporting Documents and its rejection reason(s).",
    "connect1": "Connect!",
    "itSeemsEitherThe": "It seems either the google connection is broken or it's not being connected in the current location. Please check the Integrations settings and re-integrate if the connection already exists.",
    "selectPage": "Select Page",
    "somethingWentWrongPlease": "something went wrong please try again",
    "accept": "Accept",
    "moreThan1Phone": "More than 1 Phone Number permitted",
    "byContinuingToUse": "By continuing to use the HighLevel Platform, you agree to these new {termsLink} and {privacyLink}.",
    "byContinuingToUse1": "By continuing to use the HighLevel Platform, you agree to these new",
    "termsOfService": "Terms of Service",
    "weHaveUpdatedOur": "We have updated our Terms of Service and Privacy Policy, be sure to check them out!",
    "newTriggerName": "New Trigger Name",
    "triggerName": "Trigger Name",
    "disableDndForSpecific": "Disable DND for specific channels",
    "selectAdAccount": "Select Ad Account",
    "selectAppointmentStatus": "Select Appointment Status",
    "below1": "below.",
    "Required": "* required",
    "whenYouGetA": "When you get a new review we will automatically post it to your Facebook page. Remember best practice is to post no more than 3 reviews per day to your account.",
    "skip": "Skip",
    "copyShareLink": "Copy Share Link",
    "agencyRelationshipNumbers": "Agency Relationship Numbers",
    "alteast1AgencyRelationship": "Alteast 1 agency relationship number is required.",
    "alteast1SubaccountId": "Alteast 1 sub-account id is required.",
    "somethingWentWrongWhile": "Something went wrong while saving, please try again later!",
    "5PerPage": "5 per page",
    "10PerPage": "10 per page",
    "amountMustGreaterOr": "Amount must greater or equal to 1 dollar AUD.",
    "regions": {
      "africa": "Africa",
      "asia_pacific": "Asia / Pacific",
      "europe": "Europe",
      "latin_america": "Latin America",
      "usa_and_canada": "USA and Canada",
      "asia": "Asia",
      "latinAmerica": "Latin America",
      "usaCanada": "USA and Canada"
    },
    "expandIcon": "►",
    "noEntriesToShow": "No entries to show",
    "clear": "Clear",
    "filter": "Filter",
    "test": "Test",
    "createNewTwilioSubAccountText": "You'll need to create a new twilio account, update the credentials for this account under Twilio settings and move phone numbers before enabling rebilling.",
    "viewing": "Viewing",
    "makeSmsCompliantByAddingASenderInformation": "Make SMS compliant by adding a sender information.",
    "makeEmailCompliantByAddingAnUnsubscribeLinkInYourEmail": "Make Email compliant by adding an Unsubscribe link in your email",
    "enableMissedCallTextBack": "Enable missed call text back",
    "productInventory": "Product Inventory",
    "viewProductVariants": "View Product Variants",
    "smtpSettings": "SMTP Settings",
    "locationOPMTrafficStatis": "Location OPM Traffic Stats",
    "locationGPMTrafficStatis": "Location GPM Traffic Stats",
    "blacklistMonitorReports": "Blacklist Monitor Reports",
    "twoFactorAuthentication": "Two-Factor Authentication (2FA)",
    "recent": "Recent",
    "noPermission": "You do not have permission to manage templates for this product. Redirecting to dashboard.",
    "tasksNowHave": "Tasks now have",
    "option": "Option",
    "facebookAdsReporting": "Facebook Ads Reporting",
    "googleAdsReporting": "Google Ads Reporting",
    "adsDatePicker": "Ads Date Picker",
    "feedbackSubmitBtn": "Feedback Submit Button",
    "ifYouThinkMistakePleaseContact": "If you think this is a mistake, please contact",
    "forResolution": "for resolution.",
    "live": "Live",
    "payouts": "Payouts",
    "greatChoice": "Great Choice!",
    "toNavigate": "to navigate",
    "teams": "Teams",
    "role": "Role",
    "searchAccounts": "Search Accounts",
    "searchByNameEmailPhone": "Search by name, email or phone",
    "addEmployee": "Add Employee",
    "removeFromLocation": "Remove from Location",
    "knowMore": "Know More",
    "usingNumberPool": "Using Number Pool",
    "numbers": {
      "zero": "0",
      "one": "1"
    },
    "multiplier": "x",
    "reviewer": "Reviewer",
    "cancel1": "Cancel",
    "delete1": "Delete",
    "call1": "Call",
    "message1": "Message",
    "name1": "Name",
    "voicemail1": "Voicemail",
    "title1": "Title",
    "choose_one": "Choose one",
    "select_page": "Select page",
    "confirm1": "Confirm",
    "conversations1": "Conversations",
    "copied1": "Copied",
    "timeOfDay": {
      "am": "AM",
      "pm": "PM"
    },
    "back1": "Back",
    "details1": "Details",
    "month1": "/month",
    "select1": "Select",
    "share1": "Share",
    "facebook1": "Facebook",
    "sidebar": {
      "blacklistMonitorReports": "Blacklist Monitor Reports",
      "domainPurchase": "Domain Purchase"
    },
    "confirmDelete": "Are you sure you want to delete {name}?",
    "clicked1": "Clicked",
    "delivered1": "Delivered",
    "invalid1": "Invalid",
    "open_options": "Open options",
    "_add_account": "Add Account",
    "setTimezoneWarning": "Please set timezone for your location to get proper free slots.",
    "save1": "Save",
    "action1": "Action",
    "actions1": "Actions",
    "all1": "All",
    "previous1": "Previous",
    "results1": "Results",
    "next1": "Next",
    "payments1": "Payments",
    "settings1": "Settings",
    "total_js_heap": "Total JS Heap",
    "table": {
      "pagination": {
        "previous": "Previous",
        "next": "Next"
      },
      "rowsSelected": "{count} rows selected",
      "cantRearrange": "{type} can't be rearranged"
    },
    "ivrCall": "IVR Call",
    "sms": "SMS",
    "username": "Username",
    "stay": "Stay",
    "placeholders": {
      "selectCountry": "Select your Country",
      "nameOfBusiness": "Name of Business",
      "line1": "Line 1",
      "line2": "Line 2",
      "enterState": "Enter State",
      "enterCity": "Enter City",
      "enterPostalCode": "Enter Postal Code",
      "chooseCountry": "Choose country..."
    },
    "addressLine1": "Address Line 1",
    "addressLine2": "Address Line 2",
    "postalCode": "Postal Code",
    "nameOfBusiness": "Name of Business",
    "dispute_this_review": "Dispute this review",
    "story_mention": "Story Mention",
    "story_reply": "Story Reply",
    "no": "No",
    "yes": "Yes",
    "annual": "annual",
    "plan": "Plan",
    "errors": {
      "somethingWrong": "Something went wrong"
    },
    "zero": "0",
    "perMonth": "per month",
    "emailCheckLinks": "Please check the links where you have a custom value. There is an extra \"%20\" between the {{ and the custom_values.",
    "fileSizeTooLarge": "File size is greater than 5MB",
    "fileSizeTooLargeDescription": "The file you are trying to upload is too large. Please try with a smaller size file",
    "minMaxLength40Characters2048Characters": "Min length: 40 characters. Max length: 2048 characters.",
    "sampleMessage2": "Sample message #2*",
    "pleaseSelectWorkflow": "Please select a workflow",
    "childrens": "Childrens",
    "brandAndCampaignRegistration": "Brand and Campaign registration one Time $20.95 will be charged. Additional campaign fee up to $2.25 per month will apply in accordance with TCR rules.",
    "einRequiredForRegistration": "EIN required for registration",
    "changed_props": "Changed Props",
    "total_memory": "Total Memory",
    "total_store_size": "Total store size",
    "total_watchers": "Total Watchers",
    "update_count": "Update Count"
  },
  "contacts": {
    "bulkRequests": {
      "bulkActions": "Bulk Actions",
      "clickHere": "Click here to view bulk actions list.",
      "mergedMessage": "This page been merged with bulk actions list.",
      "title": "Contact Requests"
    }
  },
  "conversations": {
    "noConversationsFound": "No {status} conversations found",
    "create_new": "Create new message​",
    "validations": {
      "minCharsRequired": "Min 3 characters required",
      "twoMoreCharsRequired": "2 more characters required",
      "oneMoreCharRequired": "1 more character required"
    },
    "sortLabels": {
      "latestAllMessages": "Latest - All messages",
      "oldestAllMessages": "Oldest - All messages",
      "latestManualMessages": "Latest - Manual messages",
      "oldestManualMessages": "Oldest - Manual messages",
      "latestAll": "Latest-All",
      "oldestAll": "Oldest-All",
      "latestManual": "Latest-Manual",
      "oldestManual": "Oldest-Manual",
      "highToLow": "{name} (High to Low)",
      "manualMessagesTooltip": "The sort option will be applicable to messages post 18th May 2023."
    },
    "deleteConversation": {
      "title": "Confirmation",
      "confirmWithName": "Are you sure you want to delete the conversation with {name} forever? This cannot be undone.",
      "confirmWithoutName": "Are you sure you want to delete this conversation forever? This cannot be undone."
    },
    "makeCall": {
      "enterPhoneNumber": "To make a call please enter a phone number in this field.",
      "invalidPhoneNumber": "Twilio Lookup marked this phone number as invalid."
    },
    "actions": {
      "markAsStarred": "Mark as starred",
      "unarchive": "Unarchive",
      "unmarkAsStarred": "Unmark as starred"
    },
    "send": {
      "perMonthPerIp": "/ Month / IP",
      "perIp": "/ IP",
      "replyingTo": "Replying to",
      "requestClientsPaymentDetails": "Request Client's Payment Details",
      "saasModeCreditCardRequired": "SaaS Mode requires a credit card on file for the client.",
      "please": "Please",
      "firstBeforeEnablingSaaS": "first before enabling SaaS Mode.",
      "shareALink": "Share a link",
      "shareLinkInstructions": "Share a link with your client to collect their payment details",
      "requestViaEmail": "Request via Email",
      "twilioRebillingDescription": "Rebill Twilio costs ({twilioCopy}) to your clients and include a markup",
      "seeHow": "See how",
      "phoneRebillingCardInfoRequired": "Phone Rebilling requires card information on file for the client.",
      "clientsCompanyBillingPage": "client's company billing page",
      "ifYouPayForTwilioKeepUsing": "If you pay for Twilio, keep using the same Twilio account",
      "ifClientPaysForTwilioCreateNew": "If client pays for Twilio, create a new Twilio account",
      "learnHow": "Learn how",
      "createNewTwilioAccountInstructions": "Create a new Twilio account for this location",
      "learnHowToMovePhoneNumbers": "Learn how to move phone numbers",
      "thisIsMyClientsTwilioCreateNew": "This is my client's Twilio, create a new account",
      "featureUnderDevelopment": "This feature is under development",
      "emailRebillingDescription": "Rebill email costs to your clients and include a markup",
      "emailRebillingCardInfoRequired": "Email Rebilling requires card information on file for the client.",
      "emailRebillingMarginsDescription": "These are margins that are billed to your clients over the email costs",
      "provider": "Provider",
      "morePlanCustomizationsAvailable": "More plan customizations available",
      "plansAndPricing": "Plans & Pricing",
      "connectYourStripeAccountFirst": "Connect your Stripe account first",
      "createRecommendedPlansOnStripe": "Create recommended plans on Stripe",
      "createdPlanInStripe": "Created plan in Stripe",
      "customizeYourSaasPlans": "Customize your SaaS plans",
      "youCanOfferRecommendedPlansOrBuildYourOwn": "You can offer recommended plans or build your own",
      "trialPeriod": "Trial Period",
      "enterNumberOfDaysForTrial": "Enter number of days for trial",
      "nameCantBeEmpty": "Name can't be empty",
      "showStripeProductDetails": "Show Stripe Product Details",
      "addEmail": "Add Email",
      "resetMountCounts": "Reset Mount Counts",
      "connectReconnectGoogleForGbp": "Connect or reconnect Google for GBP",
      "downloadFile": "Download File",
      "showOnlySlowQueries": "Show Only Slow Queries",
      "gmbMessagingAvailable": "GMB messaging is now available",
      "reconnectGbpPageToEnable": "Reconnect your GBP page to enable messaging",
      "failedPaymentsCheckBilling": "Failed payments detected. Please check your billing.",
      "onlyAgencyAdminsCanSeeWarning": "Only agency admins can see this warning.",
      "filter": "Filter",
      "stopDeleteOperation": "Stop Delete Operation",
      "summary": "Summary",
      "enableTracking": "Enable Tracking",
      "exportAll": "Export All",
      "newConversationStarted": "New conversation started",
      "startNewConversation": "Start New Conversation",
      "subAccountScheduledForDeletion": "Sub Account Scheduled For Deletion",
      "deleteSubAccountOnScheduledTime": "Delete Sub Account On Scheduled Time",
      "componentUpdatesDebuggerAlpha": "Component Updates Debugger (Alpha)",
      "componentUpdateTrackingDisabled": "Component update tracking is disabled",
      "deleteSubAccount": "Delete Sub-account",
      "subAccountHasNumbersAndCampaigns": "This sub-account has {phoneNumberCount} phone number(s) and {campaignsCount} campaign(s).",
      "subAccountNoNumbersOrCampaigns": "This sub-account has no phone numbers or campaigns.",
      "areYouSureDeleteSubAccount": "Are you sure you want to delete this sub-account?",
      "confirmDiscussedWithClient": "I confirm that I have discussed this with my client",
      "understandActionIrreversible": "I understand that this action is irreversible",
      "confirmDisconnectCloseLcPhone": "I confirm that I want to disconnect and close the LC Phone account",
      "choosingNotDeleteLcPhoneWarning": "Warning: If you choose not to delete the LC Phone account, you will continue to be charged for the phone numbers associated with this sub-account.",
      "deleteAccount": "Delete Account",
      "send": "Send",
      "typeMessage": "Type message",
      "requestPayment": "Request Payment",
      "reply": "Reply",
      "retry": "Retry",
      "analyzeMemory": "Analyze Memory",
      "memoryAnalysisApproximate": "🚧 Memory Analysis is approximate and not 100% accurate.",
      "subAccountScheduledForDeletionItWillBeDeleted": "This sub-account has been scheduled for deletion. It will be deleted by",
      "youCanChangeYourMindBeforeThisTime": "You can change your mind before this time.",
      "sms": {
        "errors": {
          "skipStayPrompt": "Skip",
          "cannotIdentifyContact": "Cannot identify contact and its location.",
          "contactNotSelected": "The contact not selected.",
          "messageRequired": "Make sure you have entered a message or a selected template.",
          "noPhoneNumber": "The contact does not have a phone number.",
          "genericError": "{message}",
          "stayPrompt": "Stay"
        },
        "scheduledSuccess": "Email scheduled successfully",
        "confirmDelete": "Are you sure you want to delete {name}?"
      },
      "clear": "Clear",
      "edit": "Edit",
      "sendNow": "Send now",
      "schedule": "Schedule",
      "useTemplate": "Use a template (Snippet)",
      "mergeFields": "Merge Fields",
      "customVariablesError": "There are issues in your custom variables, please fix them before sending.",
      "sendLater": "Send Later",
      "scheduledFor": "Scheduled for {date}",
      "call": "Call",
      "leftVoicemail": "Left a voicemail",
      "pleaseSelectCampaign": "Please select a campaign",
      "whatsapp": {
        "no24HourMessage": "You can only send template messages outside the 24-hour window. Please select a template to send."
      },
      "attachFile": "Attach File",
      "email": {
        "fromEmail": "From Email",
        "fromName": "From Name",
        "smtpWarning": "SMTP providers has some limitations. Click here to know more.",
        "subject": "Subject",
        "errors": {
          "cannotIdentifyContact": "Cannot identify contact and its location.",
          "contactNotSelected": "The contact not selected.",
          "genericError": "{message}",
          "bodyRequired": "The e-mail requires a body text to be send.",
          "noEmailAddress": "The contact does not have an email address."
        },
        "scheduledSuccess": "Email scheduled successfully"
      },
      "addCalendarToSchedule": "You need to add calendar to start scheduling appointments.",
      "slotRequired": "Slot required",
      "teamMemberRequired": "Team member is required."
    },
    "added": "added",
    "loadMore": "Load more",
    "admin": "Admin",
    "aiEmployee": {
      "popupBlockedAlert": "You have disabled pop-up. Please allow pop-ups for this site to automatically redirect to Zoom call. Please click on join now to directly redirect to Zoom call."
    },
    "alsoCloseAssociatedSubAccount": "Also close associated",
    "analyzeMemory": "Analyze Memory",
    "announcements": "Announcements",
    "apply": "Apply",
    "appointment": {
      "pickDay": "Pick a day",
      "pickSlot": "Pick an appointment slot",
      "selectDate": "Select date",
      "selectSlot": "Select slot",
      "slot": "Slot",
      "day": "Day"
    },
    "areYouReallySureDeleteSubAccount": "Are you really sure you want to delete this sub-account?",
    "areYouSureDeleteSubAccount": "Are you sure you want to delete this sub-account?",
    "assignedContactOwner": "Assigned ({contact} Owner)",
    "assignedToMe": "Assigned to me",
    "audio": {
      "browserNotSupported": "Your browser does not support the audio element.",
      "loadingTranscription": "Loading transcription...",
      "viewTranscript": "View Transcript",
      "stop": "Stop",
      "playPause": "Play/Pause",
      "timePlayed": "Time played : Total time",
      "mute": "Mute",
      "playbackSpeed": "Playback Speed",
      "download": "Download",
      "remove": "Remove"
    },
    "automated": "Automated",
    "avatar": {
      "aiGenerated": "This message was generated by Conversation AI",
      "messengerAutomation": "Messenger Automation",
      "workflowGenerated": "This message was generated by Conversation AI Workflow Action",
      "messageByAI": "This message was generated by Conversation AI",
      "messageByWorkflow": "This message was generated by Conversation AI Workflow Action",
      "agentPrefix": "E-",
      "unknownFallback": "?"
    },
    "bePartOfFastestGrowingCommunity": "Be part of the fastest growing community.",
    "callHighlevelAt": "Call HighLevel at +1(888)732-4197",
    "callQueueTooltip": "This call is on the User's call queue waiting to be fired.",
    "callTranscript": "Call Transcript",
    "clearFilters": "Clear Filters",
    "clientsCompanyBillingPage": "client's company billing page",
    "closeChat": "Close chat",
    "closeConversation": "Close conversation",
    "component": {
      "dismissMessage": "DISMISS THIS MESSAGE",
      "unblock": "Unblock",
      "inboundDndActive": "Inbound DND has been activated for this contact",
      "fetchOlderMessages": "Fetch older messages",
      "conversationBegan": "Conversation began",
      "celebrationTitle": "Wohoo! Conversations are flowing now",
      "celebrationBody": "Things are just getting started, lets explore how GHL can help build your business.\nMeanwhile, you can keep sending messages to your heart's content"
    },
    "componentUpdateTrackingDisabled": "Component update tracking is currently disabled",
    "componentUpdatesDebuggerAlpha": "🚧 Component Updates Debugger (Alpha) - Work in Progress",
    "confirmDelete": "Delete conversation(s)?",
    "confirmDeleteTextLine11": "Are you sure you want to delete this conversation? This action is irreversible.",
    "confirmDeleteTextLine12": "conversations selected",
    "confirmDeleteTextLine21": "This action is irreversible. Do you still want to proceed?",
    "confirmDisconnectedAllIntegrations": "I confirm that I have disconnected all the integrations like twilio, mailgun, gmb, domains, facebook, zoom etc.",
    "confirmStoppedAllAutomations": "I confirm that I have stopped all automations in this sub-account",
    "connectReconnectGoogleForGbp": "Connect / Reconnect your google to get GBP Messaging!",
    "connectWithCertifiedAdmin": "Connect with a Certified Admin",
    "connectWithTeamForHelp": "Connect with our team for help over a live video call!",
    "connectWithUs": "Connect with Us",
    "connectZoomAccount": "Connect Zoom Account",
    "contactEngagementScore": "{contact} Engagement Score",
    "dailyBrainstormingSessions": "Daily Brainstorming sessions with Highlevel",
    "deleteAccount": "Delete Account",
    "deleteSubAccountOnScheduledTime": "Delete sub-account on scheduled time",
    "disableSaasMode": "Disable SaaS mode",
    "dnd": {
      "configure": "CONFIGURE",
      "status": {
        "on": "ON",
        "partial": "Partial"
      }
    },
    "editAppointment": {
      "updateButton": "Update Appointment",
      "scheduleAppointment": "Schedule appointment",
      "editAppointment": "Edit Appointment",
      "calendar": "Calendar",
      "selectCalendar": "Select calendar",
      "roundRobin": "Round Robin",
      "pickTeamMember": "Pick Team Member",
      "selectTeamMember": "Select Team Member",
      "teamMemberRequired": "Team member is required.",
      "slotRequired": "Slot required",
      "appointmentTitle": "Appointment Title",
      "appointmentTitleTooltip": "Consider leaving it blank, should you choose to use the pre-configured Appointment Title",
      "contactName": "Contact Name",
      "name": "Name",
      "nameRequired": "Name required",
      "emailAddress": "Email Address",
      "phoneNumber": "Phone Number",
      "phoneNumbers": "Phone numbers",
      "dateOfBirth": "Date of Birth",
      "contactTimezone": "Contact Timezone (Used for Reminder)",
      "chooseOne": "Choose one..",
      "meetingLocation": "Meeting Location",
      "meetingLocationTooltip": "Consider leaving it blank, should you choose to use the pre-configured Meeting Location",
      "status": "Status",
      "appointmentStatus": "Appointment Status",
      "additionalNotes": "Additional Notes",
      "notes": "Notes",
      "actionRequired": "Action Required",
      "confirmed": "Confirmed",
      "invalid": "Invalid",
      "cancelled": "Cancelled",
      "showed": "Showed",
      "noShow": "No-Show",
      "busy": "Busy",
      "free": "Free",
      "noCalendarMessage": "You need to add calendar to start scheduling appointments."
    },
    "email": {
      "errors": {
        "bodyRequired": "The e-mail requires a body text to be send.",
        "cannotIdentifyContact": "Cannot identify contact and its location.",
        "contactNotSelected": "The contact not selected.",
        "noEmailAddress": "The contact does not have an email address."
      },
      "thread": {
        "failedToFetch": "Failed to fetch the email content",
        "forward": "Forward"
      },
      "reply": "Reply",
      "share": "Share",
      "facebook": "Facebook",
      "twitter": "Twitter",
      "addAccount": "+ Add Account",
      "respond": "Respond",
      "retry": "Retry",
      "moreEmailsInThread": "{count} more emails in thread",
      "fromName": "From Name",
      "fromEmail": "From Email",
      "subject": "Subject",
      "attachFile": "Attach File",
      "useTemplate": "Use a template (Snippet)",
      "requestPayment": "Request Payment",
      "clear": "Clear",
      "sendNow": "Send now",
      "schedule": "Schedule",
      "send": "Send",
      "smtpWarning": "SMTP providers has some limitations. Click here to know more.",
      "chooseOne": "Choose one..",
      "deliveredCount": "{delivered}/{total} delivered",
      "typeMessage": "Type message",
      "sendLater": "Send Later",
      "scheduledFor": "Scheduled for {date}"
    },
    "emailRebillingCardInfoRequired": "In order to turn on email rebilling, you need to enter your client's card information on",
    "emailRebillingDescription": "This allows you to rebill Email costs to your clients and include a markup.",
    "emailRebillingMarginsDescription": "These are margins that are billed to your clients over the Email cost borne by you",
    "enableTracking": "Enable Tracking",
    "exploreHighlevelExperts": "Explore HighLevel experts who can help set up your system, automate workflows, or customize your project.",
    "exportAll": "Export All",
    "facebook": {
      "errors": {
        "generalError": "An error has occured. Please try again or check the Facebook integration. Error message:",
        "noFacebookId": "The contact does not have a Facebook Id."
      }
    },
    "failedPaymentsCheckBilling": "You have one or more failed payments. Please check your billing history.",
    "fbMessengerDM": "FB Messenger DM",
    "filters": {
      "above": "Above",
      "aiActionLogs": "AI Action Logs",
      "inRange": "In Range",
      "invoice": "Invoice",
      "messageDirectionTooltip": "The filter will be applicable to messages post 9th May 23",
      "appointments": "Appointments"
    },
    "followed": "Followed By",
    "followedByMe": "Followed By Me",
    "followedBySpecificUser": "Followed By Specific User",
    "follower": "Follower",
    "followerAssignmentContact": "Follower ({contact} Assignment)",
    "gbp": {
      "errors": {
        "generalError": "An error has occured. Please try again or check the Google Business Profile integration. Error message:",
        "noGBPId": "The contact does not have a GBP Id."
      }
    },
    "gbpChatNoLongerAvailable": "Google Business Profile Chat is no longer available",
    "getAccessToHighlevelWelcomeCourse": "Get Access To The HighLevel Welcome Course",
    "getPriorityTroubleshooting": "Get priority troubleshooting, expert guidance, and direct access to our technical team via Slack.",
    "gmbMessagingAvailable": "Google Business Messaging is available for your account.",
    "googleMeet": "Google Meet",
    "googleReview": {
      "rating": "Rating:",
      "replyDate": "Reply Date:",
      "replyFrom": "Reply From:",
      "review": "Review",
      "reviewDate": "Review Date:",
      "reviewFrom": "Review From:"
    },
    "highlevelEvents": "Highlevel Events",
    "igMessengerDM": "IG Messenger DM",
    "includeSignatureBeforeQuotedText": "Include this signature before quoted text in replies",
    "instagram": {
      "errors": {
        "generalError": "An error has occured. Please try again or check the Instagram integration. Error message:",
        "noInstagramId": "The contact does not have a Instagram Id."
      }
    },
    "joinOurFacebookGroup": "Join our Facebook Group",
    "keepUpToDateWithLatestNews": "Keep up to date with all the latest news & releases!",
    "lastMessageChannel": "Last Message Channel",
    "lastMessageDirection": "Last Message Direction",
    "lastOutboundMessageType": "Last Outbound Message Type",
    "learnHow": "Learn How?",
    "leftComment": "left a comment",
    "leftPanel": {
      "recents": "Recents",
      "unread": "Unread",
      "createNewMessage": "Create new message",
      "minCharsRequired": "Min 3 characters required",
      "twoMoreCharsRequired": "2 more characters required",
      "oneMoreCharRequired": "1 more character required"
    },
    "liveChat": {
      "endLiveChat": "End Live Chat",
      "errors": {
        "generalError": "An error has occured. Please try again or check the Google My Business integration. Error message:"
      },
      "requestContact": "Request contact"
    },
    "live_chat_message": "Live Chat Message",
    "made": "made",
    "memoryAnalysisApproximate": "🚧 Memory Analysis is approximate and not 100% accurate.",
    "mentioned": "Mentioned To",
    "mentions": "Mentions",
    "mentionsOfMe": "Mentions of me",
    "mentionsOfSpecificUser": "Mentions of Specific User",
    "message": {
      "replyAll": "Reply All",
      "details": "Details",
      "reply": "Reply",
      "unsuccessful": "Unsuccessful",
      "pending": "Pending",
      "inboundCall": "Inbound Call",
      "outboundCall": "Outbound Call",
      "ivrCall": "IVR Call",
      "leftVoicemail": "Left a voicemail",
      "storyReply": "Story Reply",
      "storyMention": "Story Mention",
      "replyAsDM": "Reply as DM",
      "newCommentOnPost": "New comment on {pageName} post.",
      "goToPost": "Go to post",
      "replyNotAvailable": "Replying as a private DM is not available for comments older than 7 days.",
      "addToDocuments": "Add to documents",
      "attachmentsAddedSuccess": "Attachments added to documents successfully",
      "attachmentsAddedFailed": "Failed to add attachments to documents",
      "reportFeedbackForAI": "Report Feedback for AI",
      "sms": "SMS"
    },
    "messageDetails": {
      "bcc": "BCC",
      "cancelScheduleConfirm": "Are you sure you want to cancel this schedule?",
      "cancelScheduledMessage": "Cancel scheduled message?",
      "cancelSend": "Cancel Send",
      "cancelScheduledSuccess": "Scheduled message cancelled successfully",
      "cancelScheduledError": "Some error occurred while cancelling schedule message",
      "cc": "CC",
      "channel": "Channel",
      "createdBy": "Created by",
      "direction": "Direction",
      "emailCampaign": "Email Campaign",
      "facebookMessage": "Facebook Message",
      "instagramMessage": "Instagram Message",
      "messageId": "Message ID",
      "messageIdLabel": "Message ID: ",
      "trigger": "Trigger",
      "unanswered": "Unanswered",
      "yes": "Yes",
      "messageDetails": "Message Details",
      "from": "From",
      "fromLabel": "From:",
      "to": "To",
      "toLabel": "To:",
      "unknown": "Unknown",
      "unknownFrom": "Unknown From",
      "unknownTo": "Unknown To",
      "unknownDirection": "Unknown Direction",
      "dateUnknown": "Date Unknown",
      "emailFromUnknown": "Email From Unknown",
      "smsFromUnknown": "SMS From Unknown",
      "callFromUnknown": "Call From Unknown",
      "voicemailFromUnknown": "Voicemail From Unknown",
      "emailToUnknown": "Email To Unknown",
      "smsToUnknown": "SMS To Unknown",
      "callToUnknown": "Call to Unknown",
      "voicemailToUnknown": "Voicemail to Unknown",
      "failed": "Failed",
      "datetime": "Date & Time",
      "manual": "Manual",
      "automation": "Automation",
      "workflow": "Workflow",
      "campaign": "Campaign",
      "bulkRequest": "Bulk Request",
      "delivered": "Delivered",
      "bounced": "Bounced",
      "opened": "Opened",
      "sent": "Sent",
      "scheduled": "Scheduled",
      "pageName": "Page name",
      "gbpMessage": "GBP Message",
      "no": "No",
      "eventsTrackedForContactOnly": "Events are currently captured for the contact's email address only.",
      "completed": "Completed",
      "voicemail": "Voicemail",
      "busy": "Busy",
      "pending": "Pending",
      "read": "Read",
      "nativeIntegrations": "Native Integrations",
      "smtp": "SMTP",
      "twilio": "Twilio",
      "leadConnector": "LeadConnector",
      "email": "Email",
      "sms": "SMS",
      "phoneCall": "Phone Call",
      "voiceMail": "Voice Mail",
      "facebookMessenger": "Facebook Messenger",
      "instagramMessenger": "Instagram Messenger",
      "gbpMessenger": "GBP Messenger",
      "reviews": "Reviews",
      "others": "Others",
      "partialDetailsWarning": "Partial details will be available for messages prior to July 15, 2022.",
      "agencySystem": "Agency System",
      "reply": "Reply"
    },
    "multiplePhone": {
      "chooseNumber": "Choose a number to start the conversation:",
      "continue": "Continue",
      "noPhones": "No phone numbers available"
    },
    "myChat": "My Chat",
    "myInbox": "My Inbox",
    "newConversationStarted": "New conversation started",
    "newMessage": {
      "title": "New message:",
      "errors": {
        "phoneRequired": "Phone is required"
      }
    },
    "noConversationSelected": "No conversation selected",
    "noResultsToShow": "No results to show",
    "onboardingVideoTutorials": "Onboarding Video Tutorials",
    "onlyAgencyAdminsCanSeeWarning": "Only Agency Admins can see this warning. For more info",
    "onlyVisibleToUsers": "Only visible to users",
    "perMonthPerIp": "/ Month / IP",
    "phone": {
      "call": "Call {name}",
      "callingOptions": "{count} calling options",
      "phoneNumbers": "Phone Numbers",
      "callOptions": "{count} calling options",
      "dndActive": "DND is active for Calls",
      "primary": "Primary"
    },
    "pleaseDisableSaasMode": "Please disable SaaS mode for this sub-account",
    "pleaseSelectCampaign": "Please select a campaign",
    "premiumSupport": "Premium Support",
    "quickFilters": "Quick Filters",
    "reconnectGbpPageToEnable": "Reconnect your GBP page to enable it.",
    "replyAsDMTooltip": "Reply to this comment as a private DM.",
    "replyingTo": "Replying to",
    "resetMountCounts": "Reset Mount Counts",
    "review": {
      "errors": {
        "generalError": "An error has occured. Error message:",
        "googleIntegrationError": "Unable to respond to that review. There seems to be an error with your Google Integration. Please reconnect it under Settings -> Integrations.",
        "noReviewId": "The conversation does not have a review Id."
      },
      "reviewPostTo": "Review post to {network}",
      "sharedOn": "Review Shared on {network}",
      "disputeReview": "Dispute this review",
      "learnHow": "(Learn How?)",
      "seeOnGBP": "See this review on GBP",
      "alreadyShared": "This review has already been posted to {network}. Are you sure you want to re-post it?"
    },
    "reviewId": "Review ID",
    "schedule": {
      "sendSchedule": "Send schedule",
      "timezone": "Timezone ({heading})",
      "title": "Schedule your {type}"
    },
    "scheduling": "Scheduling...",
    "seeHow": "See how",
    "selectFilter": "Select Filter",
    "selected": "selected",
    "sendEmail": {
      "recipientPlaceholder": "recipient{'@'}example.com",
      "subject": "Subject:",
      "subjectPlaceholder": "Email subject",
      "to": "To:",
      "sending": "Sending...",
      "sendButton": "Send Email"
    },
    "setupAccountWithFreeTutorials": "Setup your account, with free tutorials",
    "showOnlySlowQueries": "Show only slow queries (>{threshold}ms)",
    "sms": {
      "confirmSending": "Confirm sending message",
      "editModal": {
        "compose": "Compose SMS"
      },
      "errors": {
        "customVariablesIssue": "There are issues in your custom variables, please fix them before sending.",
        "messageOrTemplateRequired": "Make sure you have entered a message or a selected template.",
        "noPhoneNumber": "The contact does not have a phone number."
      },
      "scheduledSuccessfully": "SMS scheduled successfully",
      "sendAnyway": "Send Anyway",
      "spamWarning": "Your SMS content may include references to Cannabis, SHAFT, Vape, or other prohibited topics. Sending such content via SMS is strictly prohibited and may result in account restrictions. Please review your content carefully before proceeding.",
      "send": "Send"
    },
    "startNewConversation": "Start New Conversation",
    "subAccountAndDeleteAllPhoneNumbers": "sub-account and delete all phone numbers",
    "subAccountScheduledForDeletion": "This sub-account is scheduled for deletion",
    "subAccountScheduledForDeletionItWillBeDeleted": "This sub-account has been scheduled for deletion. It will be deleted by",
    "teamInbox": "Team Inbox",
    "threshold": "Threshold",
    "understandActionIrreversible": "I understand that this action is irreversible & all data inside this sub-account will be lost",
    "unstarred": "Unstarred",
    "use_a_template": "Use a template",
    "userAvailability": "User Availability",
    "userCalendarConfiguration": "User Calendar Configuration",
    "userInfo": "User Info",
    "userRoles": "User Roles",
    "viewSupportTickets": "View your support tickets, our support articles and helpful FAQs!",
    "visitOurHelpCenter": "Visit our Help Center",
    "welcomeCourse": "Welcome Course",
    "whatsapp_logo": "WhatsApp Logo",
    "youCanChangeYourMindBeforeThisTime": "You can change your mind before this time.",
    "zoomAccount": "Zoom Account",
    "deleteEmails": "Delete {count} email(s)",
    "fileAttachment": {
      "urlNotFound": "URL cannot be found",
      "unsupportedAttachment": "These attachments may not be supported anymore.",
      "downloadFile": "Download file"
    },
    "composer": {
      "internalComment": "Internal Comment"
    },
    "dropdown": {
      "openOptions": "Open options",
      "messageDetails": "Message Details"
    },
    "respond": "Respond",
    "selectTemplate": "Select Template",
    "settings": {
      "aiEmployeePromo": {
        "popupBlockedMessage": "You have disabled pop-up. Please allow pop-ups for this site to automatically redirect to Zoom call. Please click on join now to directly redirect to Zoom call.",
        "helpAndSupport": "Help & Support",
        "summerOfAI": "Summer of AI"
      }
    },
    "celebration": {
      "dismiss": "Dismiss",
      "body": "Things are just getting started, lets explore how GHL can help build your business.\nMeanwhile, you can keep sending messages to your heart's content",
      "title": "Wohoo! Conversations are flowing now"
    }
  },
  "cookies": {
    "thirdPartyWarning": {
      "helpArticle": "help article here",
      "message": "Please enable third party cookies to view this page properly. You can refer our",
      "ok": "OK",
      "title": "3rd Party Cookies Not Working"
    }
  },
  "crash": {
    "message": "We're sorry, but something unexpected happened. Please try refreshing the page.",
    "refresh": "Refresh Page",
    "title": "Oops! Something went wrong"
  },
  "deleteLocation": {
    "abortModal": {
      "abortingDeletion": "Aborting deletion for {name}",
      "confirmAbort": "Yes, Abort",
      "keepDeleting": "No, Keep Deleting",
      "message": "Are you sure you wish to abort?",
      "scheduledForDeletion": "This location is scheduled for deletion on {date}",
      "title": "Abort Deletion",
      "warning": "Please note: The location will be deleted on the scheduled date unless you abort the deletion."
    }
  },
  "fileUpload": {
    "dropzone": {
      "defaultMessage": "Drop files here to upload",
      "uploadError": "Network Error : Could not send request to AWS. (Maybe CORS error)"
    }
  },
  "funnel": {
    "acceptShare": {
      "add": "Add {entityName}",
      "clonedMessage": "{entityName} Cloned! Switch to an account where it was cloned and find it under {entityName}s tab.",
      "errorGettingDetails": "There seems to be an error while getting {entityName} details. Please check the url or try again!",
      "permissionError": "Permission error: This is protected funnel and cannot be created here."
    }
  },
  "integrations": {
    "googleCalendar": {
      "logo": "GoogleCalendar Logo"
    },
    "printful": {
      "logo": "Printful Logo",
      "title": "Printful: Print on Demand"
    },
    "printify": {
      "logo": "Printify Logo",
      "title": "Printify: POD"
    },
    "shipStation": {
      "logo": "ShipStation Logo",
      "title": "Shipstation"
    },
    "shippo": {
      "logo": "Shippo Logo",
      "title": "Shippo: Shipping Integration"
    },
    "tikTok": {
      "accountNotConnected": "Account Not Connected",
      "accountNotConnectedMessage": "Your account is not connected with TikTok Ad account. Complete integration to view forms & map fields.",
      "advertiserId": "Advertiser ID",
      "companyFields": "{companyName} Fields",
      "editFields": "Edit Fields",
      "errorSubscribing": "Error while subscribing to page.",
      "formsNotAvailable": "Forms Not Available",
      "mandatoryFieldsNote": "Note: Map any of the following mandatory fields to receive leads into your account successfully. Fields: First Name, Last Name, Email, Phone Number",
      "noFormsMessage": "You currently don't have any lead generation form created in your TikTok Ad account. Visit your TikTok Ad account & create one to get started.",
      "pageId": "Page ID",
      "selectAdvertiserAccount": "Select Advertiser Account"
    }
  },
  "launchpad": {
    "duda": "Duda",
    "joomla": "Joomla",
    "otherOrIDontKnow": "Other / I don't know",
    "shopify": "Shopify",
    "squarespace": "SquareSpace",
    "weebly": "Weebly",
    "wordpress": "WordPress"
  },
  "location": {
    "suspend": {
      "instructionText": "You need to complete few easy steps to pause this sub-account"
    },
    "transfer": {
      "chooseDescription": "Choose your transfer method",
      "chooseMethod": "Transfer this Sub-Account",
      "eject": {
        "description": "Earn 40% recurring commission on the new account's subscription.",
        "title": "Eject as a New Account"
      },
      "modal": {
        "confirmDetails": "Please confirm details before transferring",
        "confirmNomineePrefix": "Nominate owner for",
        "confirmTransfer": "Confirm Transfer",
        "consentText": "I have read and understood the above guide and consent to all the limitations",
        "ejectErrorTitle": "Unable to eject sub-account.",
        "ejectGenericError": "The sub-account that you are trying to eject can not be ejected. Please contact support.",
        "ejectGuidelines": "Sub-Account Eject Guidelines",
        "ejectSubject": "Sub-Account eject is subject to the user accepting the request to create a new agency.",
        "ejectSuccessTitle": "Request to eject sub-account sent to Selected User",
        "enterPassword": "Please enter your password to confirm",
        "genericError": "The sub-account that you are trying to transfer can not be transferred. Please contact support.",
        "guidelines": "Sub-Account Transfer Guidelines",
        "guidelinesConsent": "Please read and consent to",
        "hipaaDisclaimer": "Disclaimer",
        "hipaaText": "You might want to let this sub-account know that they are getting HIPAA coverage currently but might not get the same coverage under the agency to which they are getting transferred.",
        "noUsersDescription": "There are no users associated with this sub-account. Please add a sub-account user and then continue.",
        "noUsersSearch": "No users found.",
        "noUsersTitle": "No Users Found",
        "nomineeInstructions": "The nominee will get a link to sign-up for HighLevel",
        "passwordError": "Invalid Password",
        "passwordErrorDescription": "The password you entered is incorrect. Please try again.",
        "relationshipError": "Please enter correct Relationship No",
        "relationshipNumber": "Receiving Agency's Relationship Number",
        "relationshipPlaceholder": "0-123-456",
        "requestTransfer": "Request Transfer",
        "seeAllRequests": "See all Requests",
        "successMessage": "Sub-Account would be transferred once the Receiving agency accepts your transfer request.",
        "successTitle": "Request to transfer sub-account sent to Receiving Agency",
        "title": "Transfer sub-account",
        "transferSubject": "Sub-Account transfer is subject to the receiving agency accepting it into their account.",
        "confirmNomineeSuffix": " to "
      },
      "transferExisting": {
        "description": "Transfer this entire sub-account to another account.",
        "title": "Transfer to an Existing Account"
      }
    }
  },
  "marketing": {
    "bulkRequests": {
      "nextExecution": "Next execution",
      "title": "Bulk Requests"
    },
    "campaign": {
      "account": "Account",
      "accountBuffer": "Account Buffer",
      "accountBufferDescription": "There is no limit to the number of recipients added to this campaign each day (from a list).",
      "accounts": "Accounts",
      "activity": "Activity",
      "acquire": "Acquire",
      "acquisitionDescription": "Customer acquisition campaigns help you to produce more 'hot' sales leads who are ready to engage.",
      "addEvent": "Add Event",
      "addUser": "Add user",
      "allMarket": "All Market",
      "allowMultiple": "Allow multiple",
      "assignedToTooltip": "When this Campaign started, this Contact was assigned to this User. Changes in the Contact's Assigned To will reflect on the events, but won't change this initial value.",
      "atLeastOneEvent": "At least one event is required.",
      "automations": "Automations",
      "automationsPlaceholder": "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas quaerat pariatur consequatur rerum neque a, id, nam nostrum iure accusantium magnam nemo perferendis eveniet quos perspiciatis molestiae explicabo reprehenderit nesciunt recusandae, quod distinctio vero et quia omnis? Corporis omnis, ipsa in, quae iste libero minus, voluptatem perferendis molestiae consectetur nam odio eligendi enim consequuntur! Quis ratione iure modi eos quaerat facere molestiae. Quaerat voluptatibus distinctio sed nisi aliquam, laboriosam laudantium fugiat dolores. Corporis suscipit modi corrupti. Delectus assumenda perspiciatis asperiores porro ipsam quaerat nesciunt provident sit non distinctio veritatis tempora omnis fugit dicta minima nisi aliquam ducimus rem, nobis cum.",
      "bounced": "Bounced",
      "buffering": "Buffering",
      "campaignActivity": "Campaign Activity",
      "campaignConfiguration": "Campaign Configuration",
      "campaignConfigurationWarning": "Campaign Configuration affects all markets. Ensure that you have to make changes to these settings.",
      "campaignCreation": "Campaign creation",
      "campaignId": "Campaign ID",
      "campaignStatusByRecipients": "Campaign Status by Recipients",
      "clickThroughRate": "Click Through Rate",
      "clickedThrough": "Clicked Through",
      "conditionIfExplanation": "Run this campaign or event if the current time falls in this window, if the current time is outside this window skip the campaign or event and move on to the next one.",
      "conditionWhenExplanation": "Run the events in this campaign when the current time falls in this window, else wait until the next window to run the events.",
      "createCampaign": " Create Campaign",
      "ctr": "CTR",
      "customerAcquisition": "Customer Acquisition",
      "dateAdded": "Date Added",
      "dateAddedTooltip": "The exact date and time at which the contact was added to this campaign. First event start time may vary depending on the configurations.",
      "deletedRestorePrompt": "This Campaign is deleted! Do you wish to restore it?",
      "delivered": "Delivered",
      "deliveryRate": "Delivery Rate",
      "draftMode": "Draft Mode",
      "draftModeDescription": "This campaign is a draft. It cannot be used until it is published.",
      "dropped": "Dropped",
      "emailActivity": "Email Activity",
      "emailActivityFilterExample": "Email Activity: Clicked Through",
      "event": "Event",
      "eventFilterExample": "Event: 10X Email 4 (Listing Distribution)",
      "filters": "Filters",
      "emailPerformanceByAccount": "Email Performance by Account",
      "emailsNotSentOnDays": "Emails will not be sent on Saturday, Sunday.",
      "emailsSentOnDays": "Emails will be sent on Monday, Tuesday, Wednesday, Thursday, Friday.",
      "eventStartDate": "Event Start Date",
      "exampleAddress": "801 7th Avenue North, Saskatoon, SK",
      "exampleCompanyName": "City Perks Coffehouse",
      "exampleDate": "May 8, 2017 1:27PM",
      "exampleEmail": "dstumph{'@'}vendasta.com",
      "exampleEmailDescription": "Ensure data is no older than 30 days",
      "exampleEventName": "10X Email 4 (Listing Distribution)",
      "getMoreCustomers": "Get More Customers",
      "inProgress": "In Progress",
      "includedDays": "Included Days",
      "internalSource": "Internal Source",
      "lastUpdate": "Last update",
      "leadValuePlaceholder": "$ value of lead",
      "loopDetected": "This Campaign has been locked in Draft status because it is causing a loop. To activate this Campaign, please contact Support.",
      "market": "Market",
      "moreDetails": "More Details",
      "myCampaigns": "My Campaigns",
      "na": "N/A",
      "newFolder": " New Folder",
      "nextCampaign": "Next Campaign",
      "nextExecutionTime": "Next execution time",
      "opened": "Opened",
      "openRate": "Open Rate",
      "option2": "Option 2",
      "option3": "Option 3",
      "pageNavigation": "Page navigation example",
      "processed": "Processed",
      "published": "Published",
      "recipient": "Recipient",
      "recipients": "Recipients",
      "sampleCampaign": "Sample Campaign ",
      "scheduling": "Scheduling",
      "seeHotLeads": "See Hot Leads",
      "selectDateRange": "Select Date Range",
      "selectTimeZone": "Select Time Zone",
      "separator": " / ",
      "showingCount": "Showing {current} of {total}",
      "spamReport": "Spam Report",
      "startByAddingEvent": "Start by adding an event to this campaign.",
      "stopOnResponse": "Stop on response",
      "stopped": "Stopped",
      "time": "Time",
      "timeConditionNote": "Note: If the first step in campaigns is set to 'Immediately', then time condition would not apply for that first step.",
      "timeZoneDescription": "This setting will affect the time that your content will be sent.",
      "totalLeads": "Total Leads",
      "undeliverable": "Undeliverable",
      "unsubscribe": "Unsubscribe",
      "upNext": "Up Next",
      "utc": "UTC",
      "window": "Window"
    },
    "embed": {
      "copyLinkInstructions": "Copy the link below and easily share it anywhere you wish.",
      "embed": "Embed",
      "iframeEmbed": "Iframe Embed",
      "integrateInstructions": "Use the following options to integrate your custom form into your website",
      "integrateYourForm": "Integrate Your Form",
      "link": "Link",
      "saveAndExit": "Save and exit"
    },
    "jotbox": {
      "deleteSubmission": "Delete Submission",
      "downloadPdf": "Download PDF",
      "ofSubmissions": " of {total} Submissions",
      "pages": "pages",
      "records": "records",
      "searchPlaceholder": "Search by name, email, phone and contact id",
      "selectYourForm": "Select your form",
      "timeSigned": "Time Signed:",
      "totals": "Totals:"
    },
    "survey": {
      "createNewSurvey": "Create New Survey",
      "integrateYourSurvey": "Integrate Your Survey",
      "noSurveysForAnalyze": "You do not have any survey yet. Please create survey first to see analyze here.",
      "noSurveysForSubmission": "You do not have any survey yet. Please create survey first to see submission here.",
      "noSurveysYet": "You do not have any survey yet.",
      "refreshData": "Refresh Data",
      "searchSurveys": "Search Surveys",
      "surveyBuilder": "Survey Builder",
      "toCreateFirstSurvey": "to create your first survey."
    }
  },
  "membership": {
    "acceptShare": {
      "clonedMessage": "Product Cloned! Switch to an account where it was cloned and find it under Membership > Products tab.",
      "errorGettingDetails": "There seems to be an error while getting product details. Please check the url or try again!"
    },
    "resetPassword": {
      "title": "Reset Password",
      "button": "Reset Password",
      "newPassword": "New Password",
      "generateStrongPassword": "Generate a strong password",
      "sendEmailNotification": "Also, send an email notification.",
      "errorMessage": "An error occurred while resetting the password. Please try again.",
      "updating": "Updating..."
    }
  },
  "notifications": {
    "psBubble": {
      "byText": "⚡ by",
      "combo": {
        "signedUp": "signed up for ProveSource in the last 24 hours",
        "verifiedBy": "verified by "
      },
      "conversions": {
        "recentlyBought": "recently bought this",
        "timeAgo": "in the past 16 minutes ",
        "visitorsCount": "50 visitors"
      },
      "pageVisits": {
        "description": "seem to be hungry, too.",
        "timeAgo": "in the past 21 minutes                        ",
        "title": "50 foodies"
      },
      "proveSource": "ProveSource",
      "review": {
        "proofMessage": " ProofMessge",
        "rating": "5 star rating",
        "recently": "Recently",
        "reviewerName": "Varun Vairavan",
        "starIcon": "⚡"
      },
      "stream": {
        "action": "signed up for ProveSource",
        "location": "(London, UK)",
        "name": "Mike ",
        "timeAgo": "40 minutes ago                        "
      },
      "visitors": {
        "description": "music lovers online"
      }
    },
    "step1": {
      "combo": {
        "description": "Show the total number of people who did a specific action over 24 hours, 7 or 30 days.",
        "title": "Combo"
      },
      "conversions": {
        "description": "Create social validation by displaying how many customers did a specific action."
      },
      "liveReviews": {
        "description": "Show your visitors real time 4+ star reviews from the last 6 months."
      },
      "liveVisitors": {
        "beta": "Beta",
        "description": "Show how many visitors are currently viewing your entire site in real-time."
      },
      "pageVisits": {
        "description": "Show your visitors they aren't the only ones at the party by highlighting recent page visits."
      },
      "stream": {
        "description": "What's better than putting a face on that social proof? Show your recent customers and their actions."
      }
    },
    "step2": {
      "captureDescription2": "Each page URL must have an email form field",
      "captureDescription3": " and ProveSource installed. ",
      "comboType": "Combo Type",
      "connectAccounts": "Make sure to connect the accounts you want to pull reviews from",
      "connectGoogleAccount": "Connect your location's Google Account",
      "formSubmissions": "Form Submissions",
      "googleAccount": "Google Account",
      "howToTrack": "How to Track",
      "howToTrackDescription": "How should we track your conversions?",
      "pageUrl": "Page URL",
      "productPurchase": "Product Purchase",
      "trackAllUrls": "Track all page URLs that contain the following expression. ",
      "trackVisitors": "Track Visitors",
      "trackVisits": "Track Visits",
      "urlTip": " We treat http://, https://, www and non-www as separate versions of the URL and page. ",
      "urlValidationError": "You must add at least one URL. URL is invalid. Make sure to add http:// or https://",
      "userSignup": "User Signup",
      "visits": " Visits",
      "webhookDescription": "Call the following endpoint to let us know about an event or conversion that happened on your side and that is related to this notification, we'll do the rest.",
      "webhookRequest": "Webhook Request",
      "whatToTrack": "What would you like to track?",
      "whereToCapture": "Where to Capture",
      "whereToCaptureDescription": "Where are you capturing conversions?",
      "whichPagesToTrack": "Which pages would you like us to track?",
      "yourWebhookUrl": "Your Webhook URL"
    },
    "step3": {
      "allPages": " All Pages",
      "displayOnAllPages": "Display on all page URLs that contain the following expression: ",
      "whereToDisplay": "Where to Display",
      "whereToDisplayActivity": "Where would you like us to display this activity?"
    },
    "step4": {
      "icons8": "Icons8.com",
      "icons8Instructions": "for nice looking icons (right click an icon -> Copy Image Address)",
      "messageSettings": "Message Settings",
      "messageText": "Message text",
      "referToVisitorsAs": "Refer to visitors as",
      "visitIcons8": "Visit"
    },
    "step5": {
      "allowUsersToClose": " Allow users to close the notification ",
      "behavior": "Behavior",
      "bottomLeft": "Bottom Left",
      "bottomRight": "Bottom Right",
      "clickableNotification": " Clickable Notification ",
      "customizeDescription": "Change the following settings to control the behavior and appearance of your notification",
      "design": "Design",
      "displayNotificationFor": "Display notification for",
      "displayRules": "Display Rules",
      "hideOnMobileScreens": " Hide on mobile screens ",
      "linkRelativeNote": " If http:// is omitted, the link will open relatively to the page displayed ",
      "minimumEventsToDisplay": "Minimum events to display",
      "notificationLink": "Notification Link",
      "notificationPosition": "Notification position",
      "openLinkInNewTab": "Open Link in New Tab",
      "selectPosition": "Select position",
      "showOnlyOncePerSession": " Show only once per session ",
      "titleBackground": "Title Background",
      "titleColor": "Title Color",
      "topLeft": "Top Left",
      "topRight": "Top Right",
      "typeUrlHere": "Type URL here"
    },
    "step6": {
      "identifyNotification": "Identify Your Notification",
      "launchMessage": "We are about to launch, please take your seat and fasten your seat belt.",
      "notificationName": "Notification Name",
      "notificationNamePrompt": "What is the name of your notification?",
      "wellDone": "Well Done."
    },
    "wordpress": {
      "subscriptionCreatedSuccessfully": "Subscription Created Successfully",
      "youCanNowSetupWordPress": "You can now set up your WordPress site",
      "subscriptionFailed": "Subscription Failed",
      "resubscriptionSuccessful": "Resubscription Successful",
      "successfullyReactivated": "Your WordPress subscription has been successfully reactivated",
      "reactiveSub": "Unable to reactivate subscription",
      "resubscriptionFailed": "Resubscription Failed"
    },
    "v2": {
      "viewDetails": "View Details",
      "chatConversationAssigned": "Chat Conversation Assigned",
      "internalChat": "Internal Chat",
      "newTask": "New Task",
      "appointmentReminder": "Appointment Reminder",
      "facebookReview": "Facebook Review",
      "googleReview": "Google Review",
      "internalChatMessage": "Internal Chat Message",
      "newAppointmentAssigned": "New Appointment Assigned",
      "newAppointmentBooked": "New Appointment Booked",
      "newCall": "New Call",
      "newEmail": "New Email",
      "newMention": "New Mention",
      "newReviewReceived": "New review received from {contactName}",
      "taskReminder": "Task Reminder",
      "completed": "completed",
      "failed": "failed",
      "subAccount": "Sub-account",
      "newMessage": "New Message",
      "newAppointmentBookedWith": "New Appointment Booked with {contactName}",
      "newAppointmentAssignedTo": "New Appointment Assigned to {contactName}",
      "appointmentDueIn": "Appointment due in {minutes} minutes with {contactName}",
      "newTypeReceived": "New {type} received from {contactName}",
      "newChatAssigned": "New chat assigned from {contactName}",
      "taskDueDate": "Task '{title}' due on {date} at {time} for {contactName}",
      "tasksDueToday": "{count} tasks due today",
      "tasksOverdue": "{count} tasks overdue",
      "taskDueIn": "Task '{title}' due in {dueTime} {unitOfTime} for {contactName}",
      "mentionedInConversation": "{userName} mentioned you in conversation with {contactName}",
      "now": "now"
    }
  },
  "onboarding": {
    "landscapeMode": {
      "altTexts": {
        "logo": "Company logo"
      },
      "bestExperience": "best experience.",
      "optimizedFor": "This page is optimized for",
      "portraitMode": "portrait mode",
      "toGiveYou": "to give you the"
    }
  },
  "pagination": {
    "goToFirstPage": "Go to first page",
    "goToLastPage": "Go to last page",
    "goToNextPage": "Go to next page",
    "goToPreviousPage": "Go to previous page",
    "itemsSelected": "{count} items selected",
    "showingEntries": "Showing {from} to {to} of {total} entries"
  },
  "pmd": {
    "0": "0",
    "10": "10",
    "_min": "/ min",
    "_please_add_a_payment_method_for": "! Please add a payment method for",
    "_segment": "/ segment",
    "ad_manager": "Ad Manager",
    "add": "[ADD:",
    "ai_employee": "AI Employee",
    "billing": {
      "incompleteBillingInfo": "You have incomplete billing information on this account. Kindly update it immediately.",
      "updateNow": "Update Now"
    },
    "charge": "Charge",
    "contactLimit": {
      "message": "You have reached your current plan's limit for adding {contact}. To continue, please upgrade your plan and unlock additional capacity.",
      "upgradeNow": "Upgrade Now",
      "warningMessage": "You have {current} contact(s) while your plan only allows up to {limit}.",
      "warningTitle": "Account usage is over limit. Please upgrade to continue working uninterrupted."
    },
    "cost_borne_by_you": "cost borne by you",
    "dedicated_ip": "Dedicated IP",
    "electeditem": "electedItem",
    "feedback": "Feedback:",
    "hello": "Hello",
    "helpDrawer": {
      "aiSupportAssistant": "AI Support Assistant",
      "clickToCopy": "Click to copy relationship number",
      "clickToCopyToClipboard": "Click to copy relationship number to clipboard",
      "companyRelationshipNumber": "Company Relationship Number",
      "hiImHighly": "Hi, I'm Highly!",
      "implementation": "Implementation",
      "joinImplementationVideo": "Join implementation Video call",
      "joinTrialZoom": "Join trial Zoom call",
      "kickoff": "kick-off",
      "needHelpChatVideo": "Need help? Start a Chat or Video Call with us now!",
      "openAIAssistant": "Open AI Support Assistant",
      "premium": "Premium",
      "priority": "Priority",
      "raiseSupportTicket": "Raise a support ticket",
      "raiseTicket": "Raise Ticket",
      "relationshipNumber": "Relationship Number",
      "startAISupportChat": "Start AI support chat",
      "startAgentChatWait": "Start agent chat with 2-5 minute wait time",
      "startChatChoose": "Start chat - choose between AI support or agent chat",
      "startImplementationVideo": "Start implementation Video call",
      "startZoom": "Start Zoom",
      "startZoomCall": "Start Zoom call",
      "subtitle": "Whether you want to talk to us, the community, or learn on your own, we've got you covered!",
      "title": "Help & Support",
      "trialExperience": "Trial Experience",
      "useButtonsBelow": "Use any of the buttons below to get help!",
      "videoCallReward": "Jump on a video call to set up your account — and get {amount} credited to your wallet when you attend.",
      "videoCallType": "Jump on a video call with me for your {type} call.",
      "yourPremiumSupportSpecialist": "Your {type} Support Specialist",
      "yourSpecialist": "Your {type} Specialist",
      "yourSupportSpecialist": "Your Support Specialist",
      "videoCall": "Video Call",
      "active": "Active",
      "announcementsAria": "Announcements - click to open in new tab",
      "chat": "Chat",
      "accessWelcomeCourseAria": "Click to access the HighLevel Welcome Course",
      "clickToUpgrade": "Click to Upgrade",
      "connectCertifiedAdminAria": "Connect with a Certified Admin - click to open in new tab",
      "connectWithUsAria": "Connect with Us - start live chat",
      "contactUsAria": "Contact Us - call HighLevel at +1(888)732-4197",
      "copied": "Copied",
      "highlevelEventsAria": "Highlevel Events - click to open in new tab",
      "joinFacebookGroupAria": "Join our Facebook Group - click to open in new tab",
      "onboardingVideoTutorialsAria": "Onboarding Video Tutorials - click to open in new tab",
      "recommended": "Recommended",
      "visitHelpCenterAria": "Visit our Help Center - click to open in new tab",
      "contactUs": "Contact Us",
      "agentChatWaitTime": "Agent Chat (~ 2 - 5 min wait time )",
      "aiSupportChat": "AI Support Chat",
      "startChat": "Start Chat",
      "announcements": "Announcements",
      "fastestGrowingCommunity": "Be part of the fastest growing community.",
      "callHighlevelPhone": "Call HighLevel at +1(888)732-4197",
      "connectCertifiedAdmin": "Connect with a Certified Admin",
      "connectTeamVideoCall": "Connect with our team for help over a live video call!",
      "connectWithUs": "Connect with Us",
      "dailyBrainstormingSessions": "Daily Brainstorming sessions with Highlevel",
      "certifiedAdminDescription": "Explore HighLevel experts who can help set up your system, automate workflows, or customize your project.",
      "getAccessWelcomeCourse": "Get Access To The HighLevel Welcome Course",
      "premiumSupportDescription": "Get priority troubleshooting, expert guidance, and direct access to our technical team via Slack.",
      "highlevelEvents": "Highlevel Events",
      "joinFacebookGroup": "Join our Facebook Group",
      "onboardingVideoTutorials": "Onboarding Video Tutorials",
      "premiumSupport": "Premium Support",
      "setupAccountFreeTutorials": "Setup your account, with free tutorials",
      "viewSupportTicketsArticles": "View your support tickets, our support articles and helpful FAQs!",
      "visitHelpCenter": "Visit our Help Center",
      "welcomeCourse": "Welcome Course",
      "beta": "Beta",
      "closeHelpSupportDrawer": "Close Help & Support drawer",
      "upgradePlanToEnable": "You need to upgrade your plan, to enable this feature",
      "premiumSupportActive": "Your premium support is active",
      "premiumSupportClickUpgrade": "Premium Support - Click to upgrade your plan",
      "premiumSupportActiveAria": "Premium Support - Your premium support is active",
      "keepUpToDateNews": "Keep up to date with all the latest news &amp; releases!"
    },
    "hi": "Hi",
    "is_scheduled_for_deletion_on": "is scheduled for deletion on",
    "k": "K",
    "limit_updated_from": "limit updated from",
    "minimum_must_be": "Minimum must be",
    "more_emails_in_thread": "more emails in thread",
    "multipleUsers": {
      "chooseAccount": "Choose an account to continue"
    },
    "must_be_in_range_of_0": "Must be in range of 0-",
    "numbers_and": "number(s) and",
    "premiumSupport": {
      "assigningManager": "Assigning Technical Account Manager...",
      "bookCall": "Book a Call",
      "hiIm": "Hi, I'm {name}",
      "joinZoomNow": "Join Zoom Call Now",
      "quickActions": "Quick Support Actions",
      "quickLinks": "Quick Links",
      "raiseFeatureRequest": "Raise Feature Request",
      "slackChannelCreating": "Hang tight—your Premium Slack channel is spinning up! 🚀",
      "technicalAccountManager": "Technical Account Manager",
      "viewRoadmap": "View Product Roadmap"
    },
    "prospecting": "Prospecting",
    "reloadPopup": {
      "message": "We've noticed that you haven't refreshed the page in a while. Kindly reload to get the best experience out of the app.",
      "refreshNow": "Refresh Now"
    },
    "resell_settings": "Resell Settings",
    "row": "row",
    "select_upto": "Select upto",
    "seo": "SEO",
    "supportCalendar": {
      "description": "Get dedicated support covered at your convenient time.",
      "title": "Schedule a call with Highlevel support"
    },
    "these_are_margins_that_are_billed_to_your_clients_": "These are margins that are billed to your clients over the",
    "twilioSetup": {
      "autoSetup": {
        "benefit1": "Let us manage Twilio for you hassel free",
        "benefit2": "Our support team takes care of your Twilio issues",
        "button": "Do it for me",
        "drawback": "Pay {price} extra on VAS as compared to do it yourself",
        "title": "We'll do it for you"
      },
      "lowCreditsMessage": "You need to connect a Twilio account to manage calls & texts, that are sent/recieved on the HighLevel.",
      "lowCreditsTitle": "You are low on your free Twilio credits but we have got your back !",
      "selfSetup": {
        "benefit1": "Manage your expenses",
        "benefit2": "Have more control over your Twilio service",
        "button": "I'll Manage",
        "drawback1": "Hire someone to manage Twilio service",
        "drawback2": "Engage with Twilio support when something doesn't work.",
        "title": "Do it yourself"
      },
      "wip": {
        "button": "Setup Twilio Now",
        "fallback": "For now, you'll have to manage your own Twilio account.",
        "message": "Thank you for choosing us but we are still working to build this feature. You will hear from us as soon as we can roll this out for your account.",
        "title": "We are still working on it !!"
      }
    },
    "uiComponents": {
      "loadingMoreOptions": "Loading more options...",
      "noElementsFound": "Oops! No elements found. Consider changing the search query.",
      "noLocationsFound": "No locations found. Try a different search.",
      "typeToSearch": "Type to search",
      "enterUserEmail": "Enter user email"
    },
    "updating": "Updating",
    "usd": "USD",
    "useTemplate": {
      "useTemplate": "Use Template"
    },
    "validEmail": {
      "andYouCan": "And you can",
      "as": "as",
      "canReverify": "You can Reverify your Email",
      "emailIs": "This email is",
      "emailMarkedAs": "This email marked as",
      "markedAsInvalid": "This email is marked as",
      "notVerified": "Not Verified",
      "reverifyHere": "Re-Verify Here",
      "verifyHere": "Verify Here"
    },
    "will_give_you_about": "will give you about",
    "checkout": {
      "confirm": "Confirm",
      "cardInformation": "Card information",
      "cardNumberInvalid": "Your card number is invalid.",
      "commitment": "commitment",
      "paymentConsent": "By confirming, you allow LeadConnector to charge your card for this payment.",
      "subscriptionConsent": "By confirming your subscription, you allow LeadConnector to charge your card for this payment and future payment for this subscriptions",
      "endingIn": "ending in",
      "month": "month",
      "pay": "Pay",
      "payWithCard": "pay with card",
      "paymentBeingProcessed": "Payment is being processed. Please do not reload or press back button",
      "proceedWithExistingCard": "Proceed with existing card",
      "proceedWithNewCard": "Proceed with a new card",
      "purchase": "purchase",
      "subscribe": "Subscribe",
      "subscribeTo": "Subscribe To",
      "pleaseUpdateCardDetails": "Please Update Card Details",
      "zip": "zip",
      "retry": "retry",
      "initialChargesProrated": "Initial charges are pro-rated and regular billing will start from",
      "youWillBeChargedFor": "You will be charged for",
      "days": "days",
      "rightNowForPeriodTill": "right now for period till",
      "startGettingChargedFullAmount": "and start getting charged the full amount of",
      "perMonthStartingFrom": "/month starting from",
      "nameOnCard": "Name On Card",
      "somethingWentWrong": "Something went wrong",
      "errorImg": "error img",
      "networkError": "Network Error, Please try again after sometime",
      "paymentCouldNotBeProcessed": "Payment could not be processed. Please try adding a card again."
    },
    "deleteLocation": {
      "back": "Back",
      "delete": "Delete",
      "completeStepsToDelete": "You need to complete few easy steps to delete this location",
      "alsoCloseAssociated": "Also close associated",
      "scheduling": "Scheduling...",
      "subAccountAndDeletePhoneNumbers": "sub-account and delete all phone numbers",
      "somethingWentWrongTryAgain": "Something went wrong... Please try again after sometime",
      "deleteSubAccount": "Delete Sub-account",
      "scheduleForDeletion": "Schedule for Deletion"
    },
    "productRebilling": {
      "enableRebilling": "Enable Rebilling",
      "ratesMayDifferUK": "Rates may differ as per region. Calculations shown are as per rates for UK,",
      "examplePricingGpt4oMini": "Example Pricing - GPT-4o Mini",
      "input": "Input",
      "output": "Output",
      "supportDoc": "support doc",
      "unsavedChanges": "Unsaved Changes",
      "to": "to",
      "chargedToCustomerLower": "Charged to customer",
      "model": "Model",
      "profit": "Profit",
      "saving": "Saving..",
      "type": "Type",
      "updating": "Updating...",
      "clickHere": "Click here",
      "chargedToCustomer": "Charged to Customer",
      "enabling": "Enabling...",
      "forMoreDetails": "for more details.",
      "tenDollarsWillGive": "$10 will give you about",
      "yourCost": "Your Cost",
      "seeHow": "See how",
      "clientCompanyBillingPage": "client's company billing page",
      "connectStripeToEnable": "In order to turn on rebilling, you need to connect you stripe on",
      "companyStripeIntegrationPage": "company stripe integration page",
      "enterClientCardInfo": "In order to turn on rebilling, you need to enter your client's card information on",
      "gpt4oMini": "GPT-4o-mini",
      "for750kWords": "(for 750,000 words)",
      "words": "words",
      "yourCostLower": "Your cost",
      "and": "and",
      "or": "or",
      "minimumMustBeBetween": "Minimum must be between",
      "upgradeToAgencyPro": "upgrade to Agency Pro",
      "planToSetMargins": "plan to set margins"
    },
    "m": "m",
    "label": "Label",
    "company_email_": "Company Email (",
    "me_": "Me (",
    "automation_type": "Automation Type",
    "calendar_groups": "Calendar Groups",
    "length_": ".length }}"
  },
  "products": {
    "noProducts": "No products available",
    "selectProduct": "Select a Product"
  },
  "reselling": {
    "common": {
      "additionalMessagesInfo": ". Additional {product} Messages will not be charged to the locations. To rebill the customer please enable SaaS Mode and re-billing.",
      "agreementPrefix": "I agree to enable",
      "agreementSuffix": "for this client without resell and I acknowledge that I will be charged",
      "buildResellerOffer": "Build Your Re-sell Offer",
      "deployDirectlyDescription": "Use this option if you are offering {product} as part of your offer or if wish to bill your client externally",
      "deployPrefix": "Deploy",
      "directlySuffix": "Directly",
      "learnMore": "Learn More.",
      "offerPrefix": "Offer",
      "resellPrefix": "Re-sell",
      "resellingPrefix": "Reselling",
      "resellingSections": "Reselling sections",
      "whatIsReselling": "What is Reselling",
      "subscriptionRestriction": "Can't change configuration since location is already subscribed",
      "zero": "0",
      "highlevelPrice": "HighLevel Price",
      "howDoesItWork": "How does it work?",
      "payNowButton": "Pay Now",
      "priceValidationError": "Price must be more or equal to HighLevel price",
      "saving": "Saving",
      "yourPrice": "Your Price",
      "yourProfit": "Your Profit"
    },
    "whatsapp": {
      "inboundMessagesInfo": "Receiving Inbound messages and replying to them using a free text in the conversation window are free. There will be additional pass through charges for outbound template messages if sent.",
      "whatsappLocation": "WhatsApp Location"
    },
    "agencyResellingPage": {
      "seo": {
        "subscriptionRestriction": "Can't change configuration since location is already subscribed",
        "offerPrefix": "Offer ",
        "poweredByPrefix": " (Powered by Search Atlas)",
        "toggleTooltipDisable": "This action will disable SEO Tool for all sub-accounts.",
        "toggleTooltipEnable": "This action will enable SEO Tool for all sub-accounts.",
        "resellPrefix": "Re-sell ",
        "howDoesItWork": "How does it work?",
        "buildResellerOffer": "Build Your Re-sell Offer",
        "yourPrice": "Your Price",
        "highlevelPrice": "HighLevel Price",
        "yourProfit": "Your Profit",
        "priceValidationError": "Price must be more or equal to HighLevel price",
        "saving": "Saving",
        "save": "Save",
        "deployPrefix": "Deploy ",
        "directlySuffix": "Directly",
        "deployDirectlyDescription": "Use this option if you are offering SEO as part of your offer or if wish to bill your client externally",
        "agreementPrefix": "I agree to enable ",
        "agreementSuffix": " for this client without resell and I acknowledge that I will be charged",
        "payNowButton": "Pay Now",
        "subscriptionCreating": "Subscription is being created.<br/>Please do not reload or press back button",
        "subscriptionCreated": "Subscription created successfully. Please wait...",
        "subscriptionError": "Unable to create subscription, please contact support"
      },
      "adManager": {
        "subscriptionRestriction": "Can't change configuration since location is already subscribed",
        "offerPrefix": "Offer ",
        "resellingPrefix": "Reselling",
        "resellPrefix": "Re-sell ",
        "howDoesItWork": "How does it work?",
        "bookACall": "Book a call",
        "bookCallTooltip": "Book a call with our team to learn more about Ad Manager",
        "buildResellerOffer": "Build Your Re-sell Offer",
        "yourPrice": "Your Price",
        "highlevelPrice": "HighLevel Price",
        "yourProfit": "Your Profit",
        "priceValidationError": "Price must be more or equal to HighLevel price",
        "loading": "Loading...",
        "save": "Save",
        "deployPrefix": "Deploy ",
        "directlySuffix": "Directly",
        "deployDirectlyDescription": "Use this option if you are offering Ad Manager as part of your offer or if wish to bill your client externally",
        "agreementPrefix": "I agree to enable ",
        "agreementMiddle": " for this client without resell and I acknowledge that I will be charged",
        "agreementSuffix": " per month",
        "stripeNotConnectedLocationWarning": "Stripe is not connected for this location. Please connect Stripe to enable this feature.",
        "stripeNotConnectedAgencyWarning": "Stripe is not connected for this agency. Please connect Stripe to enable this feature.",
        "underSubAccountReselling": "per month under sub-account reselling"
      },
      "dedicatedIp": {
        "description": "This allows you to rebill dedicated IP (used for email outbound sending) for cost to your clients and include a markup",
        "numberOfIps": "No of IPs:",
        "yourCost": "Your cost:",
        "chargedToCustomer": "Charged to Customer:",
        "profit": "Profit:",
        "monthlyProfit": "Monthly Profit:",
        "loading": "Loading...",
        "save": "Save",
        "revokeDedication": "Revoke Dedication",
        "revokeDescription": "Use this option to discontinue offering new Dedicated IP to your client without charging them",
        "existingSubscriptionsNote": "Existing IP subscriptions will not be effected",
        "revoke": "Revoke",
        "provideDirectlyTitle": "Provide Dedicated IP for email directly",
        "provideDirectlyDescription": "Use this option to give Dedicated IP to your client without charging them",
        "agreeToProvideText": "I agree to provide IP for this client without upsell",
        "acknowledgeChargeText": "I acknowledge that I will be charged $59 / Month / IP",
        "agree": "Agree",
        "yourMonthlyCost": "Your monthly IP cost:",
        "monthlyChargeToCustomer": "Monthly charge to customer:",
        "resellingSettingsSuffix": " Resell Settings",
        "ipRebillingAmount": "IP Rebilling Amount"
      }
    }
  },
  "saas": {
    "disable": {
      "complianceModal": {
        "clientApproval": "I confirm that I have discussed this with my client and I have their approval",
        "confirmQuestion": "Are you sure you want to disable SaaS mode for this account?",
        "dataLossAck": "I acknowledge that all re-billing data, SaaS subscription data & transaction ledger will be lost",
        "disableSaas": "Disable SaaS",
        "irreversibleAck": "I understand that this action is irreversible"
      },
      "confirmationModal": {
        "cancelSubscription": "Also cancel associated SaaS subscription",
        "confirmDisable": "Confirm Disable",
        "confirmQuestion": "Are you sure you want to disable SaaS mode?",
        "somethingWentWrong": "Something went wrong... Please try again after sometime"
      },
      "processingModal": {
        "closeNow": "Close Now",
        "closeWindowInstructions": "You can close this window, we will inform you via email once the process is done",
        "title": "SaaS will be disabled for this location soon.",
        "typicalTime": "This typically takes 10 minutes or less."
      }
    }
  },
  "settings": {
    "customFields": {
      "addCustomField": "Add custom field",
      "fieldKey": "Field Key",
      "fieldName": "Field Name",
      "idWillBeAdded": "ID will be added after lost reason is created",
      "lostReasonID": "Lost Reason ID",
      "placeholder": "Placeholder"
    },
    "locationMailGun": {
      "bccAddress": "BCC Address",
      "clearError": "Clear error",
      "deleteConfirmationMessage": "This action will remove the Mailgun connection.",
      "deleteConnection": "Delete connection",
      "domain": "Domain",
      "domainsAvailable": "{count} avaliable",
      "invalidApiKey": "Invalid API key",
      "selectDomain": "Select Domain"
    },
    "locationWallet": {
      "fetchTransactionDetailsError": "Error while fetching transaction details",
      "transactions": "Transactions"
    },
    "noShowSMS": {
      "smsWithImage": "No show SMS with Image",
      "title": "Customize Review SMS"
    },
    "optOut": {
      "addKeywords": "Please add one of the following opt-out keywords: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT.",
      "customizeTitle": "Customize Opt Out Message",
      "disableConfirm": "Are you Sure want to disable Opt Out message?",
      "disableOptOut": "Disable Opt-out",
      "disableTitle": "Disable Opt Out Message ?",
      "optInConfirmClient": "I confirm that I will make sure SMS are only sent to the contacts who have opted in.",
      "quickTipMessage": "The initial message that you send to an individual needs to include one of the following standard opt-out keywords: STOP, STOPALL, UNSUBSCRIBE, CANCEL, END, or QUIT.",
      "reallyDisableConfirm": "Are you really sure you want to Disable Opt out message?"
    },
    "payments": {
      "logViewer": {
        "requestPostBody": "Request POST body",
        "requestQueryParameters": "Request query parameters",
        "responseBody": "Response body"
      },
      "logs": "Logs",
      "logsPage": {
        "clearAll": "Clear All",
        "loadMore": "Load More",
        "price": "Price",
        "product": "Product",
        "tabsAriaLabel": "Payment logs tabs"
      }
    },
    "senderInfo": {
      "addGeneralTextAt": "Add General text at the",
      "beginning": "Beginning",
      "complianceConfirm": "I confirm that I will ensure all SMS messages sent from this account are in compliance with current policy",
      "customizeTitle": "Customize General Text",
      "disableConfirm": "Are you Sure want to disable SenderID?",
      "disableSenderID": "Disable SenderID",
      "disableTitle": "Disable SenderID ?",
      "end": "End",
      "pleaseAdd": "Please add {text} as mentioned in quick tip.",
      "quickTipMessage": "The initial message that you send to an individual needs to include the sender identification info. Please add {text} in the general text box.",
      "reallyDisableConfirm": "Are you really sure you want to Disable SenderID?",
      "senderID": "Sender ID"
    },
    "shopify": {
      "adminApiAccessToken": "Admin API access token",
      "apiTokenRequired": "API access token is required",
      "checkDocumentation": "Please check this documentation for more information",
      "checkmark": "✓",
      "cross": "✗",
      "customAppApiAccessToken": "Custom App API access token",
      "deleteWarning": "Deleting this will remove the existing connection.",
      "existStoreAlertTitle": "Shopify store integration already exists",
      "integration": "Shopify Integration",
      "integrationHealth": "Integration health",
      "orders": "Orders",
      "scopePermissionsWarning": "Please make sure your app is granted permissions that are marked with red cross",
      "scopes": "Scopes",
      "scopesDescription": "Authorization scopes are required to access the Shopify information. Due to recent changes in Shopify, the read_customers is now required to get the full information from customers, because of the Shopify protected customer data.",
      "storeConnectedMessage": "Shopify store already connected with sub-account {locationName}",
      "storeNameHelp": "Your store name is located the URL for your Shopify account -- after the https:// and before .myshopify.",
      "storeNameLabel": "Name of your shopify store",
      "storeNamePlaceholder": "store name",
      "storeNameRequired": "Store name is required",
      "typeRemoveConfirm": "Type 'REMOVE' to confirm",
      "webhooks": "Webhooks",
      "webhooksDescription": "To receive all events from Shopify, we must register these Shopify webhooks during the integration process. These webhooks are essential for ensuring the proper functioning of Shopify features."
    },
    "slack": {
      "accountConnected": "account connected",
      "accountsConnected": "accounts connected",
      "accountsList": "List of all Slack accounts",
      "added": "Added {date}",
      "connectChannel": "Connect your Slack Channel",
      "description": "Get instant notifications on your Slack channel. Click 'Connect' to add a Slack channel.",
      "manage": "Manage",
      "manageAccounts": "Manage Slack accounts",
      "noIntegrations": "No Slack integrations found."
    },
    "smtpService": {
      "addFirstService": "Add your first SMTP service.",
      "addService": "Add Service",
      "bccEmails": "BCC Emails",
      "cannotDeleteDefaultProvider": "You can not delete default provider.",
      "contactDeveloper": "Contact the developer of this app.",
      "customProvider": "Custom Provider",
      "defaultProvider": "Default Provider",
      "defaultProviderUpdated": "Updated the default provider successfully!",
      "emailDomain": "Email / Domain",
      "emailService": "EMAIL Service",
      "enableReplyTracking": "Enable Reply Tracking",
      "forwardToAssignedUser": "Forward to assigned user",
      "providerType": "Provider Type",
      "smtpConnectionIssue": "There is an issue with this smtp connection. Please reconnect this integration.",
      "useLcEmailMessage": "Use LC Email to send emails for your agency and your clients."
    },
    "socialPosting": {
      "automaticPostingEnabled": "Automatic posting enabled",
      "dailyPostLimit": "Daily post limit",
      "directoriesDescription": "When you get a new review we will automatically post it to 80+ directories online that automatically help grow your brand & SEO.",
      "directoriesTitle": "80+ Directories and Websites",
      "fivePosts": "5 posts",
      "fiveStars": "5 stars",
      "fourPosts": "4 posts",
      "fourStars": "4 stars",
      "googlePlus": "Google +",
      "manageSettingsDescription": "Customize how and when your review reviews automatically get posted to each of your social networks automatically.",
      "manageSettingsTitle": "Manage Your Social Posting Settings",
      "postReviewsForRating": "Post reviews for this star rating or higher.",
      "searchEngines": "Search Engines",
      "threePosts": "3 posts",
      "threeStars": "3 Stars",
      "title": "Social Posting"
    },
    "tags": {
      "addNewTag": "Add New Tag",
      "allTags": "All Tags",
      "deletedTags": "Deleted Tags",
      "here": "here.",
      "newTag": "New Tag",
      "noTagsYet": "No tags to show yet",
      "searchTags": "Search Tags",
      "viewDeletedTags": "You can view and restore deleted tags on the Audit Logs page"
    },
    "templateMessage": {
      "addEmailTemplate": "Add Email Template (Snippet)",
      "addTemplate": "Add Template (Snippet)",
      "addTextTemplate": "Add Text Template (Snippet)",
      "body": "Body",
      "deleteTemplateConfirmation": "Are you sure you want to delete this template?",
      "templatesCount": "{count} templates",
      "title": "Message Templates (Snippets)"
    },
    "unsubscribe": {
      "content": "Content",
      "contentTooltip": "The content of this message will automatically be added to all the emails.",
      "customizeTitle": "Customize Unsubscribe Content",
      "disableConfirm": "Are you sure you want to disable Unsubscribe link from email?",
      "disableTitle": "Disable Unsubscribe link?",
      "disableUnsubscribe": "Disable Unsubscribe",
      "pleaseAddTag": "Please add /*unsubscribe*/ tag",
      "reallyDisableConfirm": "Are you really sure you want to Disable Unsubscribe link from email?",
      "subscribedConfirm": "I confirm that email will only be sent to contacts who have subscribed to receiving email.",
      "subscribedConfirmClient": "I confirm that I will make sure email will only be sent to contacts who have subscribed to receiving email.",
      "suspensionWarning": "Non-compliant activity may lead to the suspension of your account's email features.",
      "tagRequirement": "The initial email that you send to an individual needs to include /*unsubscribe*/ tag"
    },
    "callAndVoicemailSettings": {
      "defaultVoicemailMessage": "This is the default voicemail message for all Twilio numbers in the location unless customized under",
      "forwardCallsToWebApp": "Forward calls to web app",
      "forwardCallsToMobileApp": "Forward calls to mobile app",
      "dedicatedNumberRequiredInfo": "This is only required if the users needs a dedicated number. Not required for voicemail or for routing the call to the assigned user.",
      "voicemailMessageInfo": "This voicemail message will be played instead of the one by phone carrier. We recommend a timeout of 20 seconds or less.",
      "noTimeout": "No timeout",
      "10Secs": "10 Secs",
      "20Secs": "20 Secs",
      "voicemailMessageDuration": " We will record a voicemail if call isn't answered before this duration",
      "saveCallSettings": "Save Call Settings"
    },
    "elizaFAQSetting": {
      "bypassElizaNote": "When this tag is present on the contact, then those messages will NOT get delivered to Eliza",
      "sendToElizaNote": "By default all the conversations will be delivered to Eliza. If this tag is configured, <br />then the new conversations will be sent to Eliza, only when this tag is present on acontact.<br /> If both Eliza bypass tag and Send to Eliza tag are configured, then only Send to Eliza will be honored",
      "permissionNote": "Your user permissions is not enabled for this page. <br />Please talk to your administrator",
      "addFAQ": "Add FAQ"
    },
    "locationSettings": {
      "ownCardWarning": "Do not add your own card to sub-accounts !!",
      "addClientCardWarning": "Please add your client's (sub-account's) card and not your own as this card will be used to bill your client on your behalf.",
      "stripeConnectMissing": "Stripe connect missing",
      "pleaseContactAgencyToAddPaymentMethods": "Please contact agency ({email}) to add payment methods"
    },
    "integrations": {
      "connectWaveAccount": "Connect your location's Wave Account",
      "connectXeroAccount": "Connect your location's Xero Account"
    },
    "gmbSettings": {
      "gbpCallTrackingEnabledOnAnotherSubAccount": "GBP call tracking is enabled on another sub-account. Call tracking can be enabled on a single sub-account at a time.",
      "gbpCallTrackingEnabledOnAnotherPage": "GBP call tracking is enabled on another page({pageName}). Call tracking can be enabled on a single sub-account & single page per location at a time.",
      "gbpCallsProperlySetup": "GBP Calls are properly setup and calls are coming in from",
      "tooManyEditsToPrimaryPhone": "You have made too many edits to the primary phone for this business. Try again later.",
      "setupTwilioToStartCallTracking": "Setup twilio to start call tracking",
      "twoSecondaryNumbersSetupAlready": "You have 2 secondary number setup already, can't swap number",
      "yourAgentIDIs": "Your agentID is"
    },
    "numberPool": {
      "title": "What to Track",
      "tracking": {
        "percentComplete": "34% Complete",
        "searchLower": "search"
      },
      "create": {
        "title": "Create Tracking Number"
      }
    },
    "phoneNumbers": {
      "title": "What to Track",
      "tracking": {
        "percentComplete": "34% Complete",
        "heading": "Create Tracking Number"
      }
    }
  },
  "smartList": {
    "filterMultiInput": {
      "enterValue": "* Enter a value",
      "selectOption": "* Select an option"
    },
    "filterMultiSelections": {
      "atLeastOneRequired": "* At least one {filterName} required",
      "select": "Select {filterName}"
    },
    "newEmailStats": {
      "timeStamp": "TimeStamp"
    },
    "recordsNav": {
      "clickToReloadList": "Click to reload list"
    },
    "reviewRequestActions": {
      "emailReviewReq": "Email Review Request",
      "smsReviewReq": "SMS Review Request",
      "whatsappReviewReq": "WhatsApp Review Request"
    },
    "smartListFilters": {
      "clearAllFilters": "Clear all filters",
      "noneFound": "none found",
      "saveChangesToList": "Save filter changes to this smart list",
      "saveCombinationAsNew": "Save combination of filters, columns and sorting as new smart list",
      "saveCurrentAsNew": "Save current filters as new smart list",
      "searchAndAddFilter": "Search and add a filter",
      "searching": "searching...",
      "undoUnsavedChanges": "Undo unsaved changes"
    },
    "smsStatsPanel": {
      "smsStats": "SMS Stats"
    },
    "manageDuplicates": "Manage Duplicates",
    "emailAction": {
      "attachFiles": "Attach Files",
      "customValues": "Custom Values",
      "triggerLinks": "Trigger Links"
    },
    "atLeastOneRequired": "* At least one {filterName} required",
    "arrayInput": {
      "searchPlaceholder": "Search {filterName}",
      "searching": "Searching..."
    }
  },
  "snapshots": {
    "common": {
      "errorWhileFetchingSnapshotContents": "Error while fetching snapshot contents",
      "overwriteAll": "Overwrite All",
      "skipAll": "Skip All",
      "somethingWentWrongWhileFindingConflicts": "Something went wrong while finding conflicts",
      "step": "Step"
    },
    "confirmOverwrite": {
      "confirmButton": "Confirm Overwrite",
      "description": "This action is irreversible, and may change configurations of campaigns, opportunities, funnels etc. Please confirm your action by typing following in the input.",
      "title": "Are you sure you want to overwrite selected data?"
    },
    "conflicts": {
      "noConflictsDetected": "No Conflicts Detected",
      "overwrite": "Overwrite"
    },
    "pushCloneAccount": {
      "assetsFoundLinked": "Assets found linked",
      "checkingConflicts": "Checking for Conflicts",
      "chooseSnapshot": "Choose a Snapshot",
      "copyingDataNotification": "Copying data to selected locations. Please wait...",
      "linkedLocations": "Linked Locations",
      "noConflictsFound": "No conflicts found",
      "notAuthorizedMessage": "Only Agency Admins can perform this action",
      "overwriteConflicts": "Overwrite Conflicts",
      "pickSnapshot": "Pick a Snapshot",
      "response": "Response",
      "selectAssetsToPush": "Select Assets to Push",
      "selectLocationsToUpdate": "Select Locations to Update",
      "snapshotNotAuthorized": "This snapshot is not authorized for this location",
      "snapshotNotSelected": "Snapshot not selected"
    },
    "share": {
      "agencyRestrictedLink": "Agency Restricted Link",
      "deleteShareLink": "Delete Share Link",
      "editShareLink": "Edit Share Link",
      "permanentLink": "Permanent Link",
      "subaccountRestrictedLink": "Sub-account Restricted Link"
    },
    "shareSnapshot": {
      "addCommaAfterEach": "(Add comma (<span class='text-base font-bold'> , </span>) after each relationship number)",
      "addCommaAfterEachSubAccount": "(Add comma (<span class='text-base font-bold'> , </span>) after each sub-account id)",
      "atLeast1EmailRequired": "Alteast 1 email required.",
      "emailShareLink": "Email share link",
      "enterOnePerLine": "(Enter one per line)",
      "errorGettingLink": "Something went wrong while getting the link, please try again later!",
      "getAgencyRestrictedLink": "Get Agency Restricted link",
      "getLink": "Get link",
      "getOneTimeLink": "Get one-time share link",
      "getPermanentLink": "Get permanent link",
      "getSubAccountRestrictedLink": "Get Sub-account Restricted link",
      "shareType": "Share Type",
      "title": "Share Snapshot"
    },
    "snapshot": {
      "copySnapshotID": "Copy Snapshot ID",
      "deleteSnapshot": "Delete snapshot",
      "editSnapshot": "Edit snapshot",
      "pushUpdate": "Push update to linked accounts",
      "refreshSnapshot": "Refresh snapshot"
    },
    "updateShareLink": {
      "addCommaAfterEach": "(Add comma after each relationship number)",
      "addCommaAfterEachSubAccount": "(Add comma after each sub-account id)",
      "title": "Update Share Link"
    }
  },
  "socialMedia": {
    "engagement": "Engagement",
    "potentialReach": "Potential Reach",
    "storiesCreated": "Stories Created",
    "recentPosts": "Recent Posts",
    "notConnected": "Not Connected (Connect Now!)",
    "totalAudience": "Total Audience",
    "activeAudience": "Active Audience",
    "socialMediaOverview": "Social Media Overview"
  },
  "suspendModal": {
    "currentStatus": "Current Subscription Status: Paused",
    "instructions": "You need to complete few easy steps to {action} this sub-account",
    "nextBillingDate": "Next Billing Date :",
    "noKeepCharging": "No, Keep charging the client.",
    "pauseSubscriptionQuestion": "Do you want to pause subscription as well with the sub-account?",
    "resumeSubAccount": "Resume Sub-Account",
    "resuming": "Resuming...",
    "saasSubscriptionActive": "This sub-account has an active SaaS Subscription.",
    "saasSubscriptionResumed": "SaaS Subscription of this account will be resumed.",
    "yesPause": "Yes, Pause the subscription"
  },
  "table": {
    "perPageOptions": {
      "5": "5 per page",
      "10": "10 per page",
      "15": "15 per page",
      "20": "20 per page",
      "25": "25 per page",
      "50": "50 per page",
      "100": "100 per page"
    },
    "filterPlaceholder": "Search...",
    "emptyText": "No records found",
    "loading": "Loading...",
    "showingEntries": "Showing {from} to {to} of {total} entries",
    "noEntriesToShow": "No entries to show"
  },
  "templateLibrary": {
    "public": {
      "loadingAccountData": "Loading account Data…",
      "toContinueWith": "to continue with"
    },
    "switcherModal": {
      "comingSoon": "Coming Soon!",
      "multiLocationMessage": "This feature is currently available only for single accounts. We're working hard to bring this to multi-location accounts soon."
    },
    "importedMessage": "{productName} Imported! Navigate to Template Library and find it under {productName}s tab.",
    "permissionErrorMsg": "This option is only available on higher plans. Upgrade now to unlock it.",
    "errors": {
      "sourceDeleted": "Error: The source template has been deleted. It is no longer available. Please check the template status or contact the source for assistance.",
      "sourceDraft": "Error: The source template has been moved to Draft. Please check the template status or contact the source for assistance.",
      "linkedDeleted": "Error: The source template, linked to the shared template, has been deleted. Please check the template status or contact the source for assistance.",
      "fetchError": "There seems to be an error while getting {productName} details. Please check the url or try again!",
      "sameAgency": "Can not share template within the same Agency"
    }
  },
  "triggers": {
    "addContactTagRequiresTag": "Add contact tag action requires tag.",
    "addNotesRequiresData": "Add notes action requires notes data.",
    "addTaskRequiresFields": "Add task action requires title and Due in day.",
    "addToCampaignRequiresCampaign": "Add to campaign action requires campaign.",
    "addToCustomAudienceRequires": "Add to custom audience action requires ad account and custom audience.",
    "addTrigger": "Add Trigger",
    "anyAction": "Any Action",
    "anyCondition": "Any Condition",
    "brokenCustomVariables": "Some field(s) contain broken custom variables, please correct them before saving.",
    "conditionCannotBeEmpty": "Condition '{condition}' can't be empty",
    "confirmDeleteTrigger": "Are you sure you want to delete this trigger?",
    "customDateFieldRequired": "Custom Date Field filter is required for Custom Date Reminder Trigger",
    "detailPage": {
      "chooseTriggerPlaceholder": "Choose a trigger",
      "lastUpdate": "Last update:",
      "loopIdentifiedWarning": "This Trigger has been locked in Draft status because it is causing a loop. To activate this Trigger, please contact Support.",
      "ruleNotActiveWarning": "This rule will not run until you activate it.",
      "triggerCreation": "Trigger creation:",
      "triggerDeletedPrompt": "This Trigger is deleted! Do you wish to restore it?",
      "triggerRunDailyTooltip": "Trigger run at 8:00 AM daily",
      "whatTriggersRule": "What should trigger this rule?",
      "whichEventTriggersAutomation": "Which event should trigger this automation?"
    },
    "dndContactRequiresState": "DND contact action requires DND state to set.",
    "emptyConditionNotAllowed": "Empty condition is not allowed.",
    "emptyFieldNotAllowed": "Empty field is not allowed.",
    "executeWebhookRequiresUrl": "Execute webhook action requires webhook url.",
    "fieldCannotBeEmpty": "{field} can't be empty",
    "fillRequiredFields": "Please fill out all required fields in the actions.",
    "googleAdwordsRequiresConversion": "Add to Google Adwords action requires conversion.",
    "googleAnalyticsRequiresFields": "Add to Google Analytics action requires tracking id, action type and action category",
    "membershipGrantOfferRequiresOffer": "Membership grant offer action requires offer.",
    "membershipRemoveOfferRequiresOffer": "Membership remove offer action requires offer.",
    "newBasicRule": "New Basic Rule",
    "opportunitiesRequirePipeline": "Opportunities actions require you to select a pipeline.",
    "opportunityLoopWarning": "This trigger will cause an Opportunity creation loop. Please remove the Allow Duplicate Opportunity or change the Stage that you are referencing.",
    "removeContactTagRequiresTag": "Remove contact tag action requires tag.",
    "removeFromCampaignRequiresCampaign": "Remove from campaign action requires campaign.",
    "removeFromCustomAudienceRequires": "Remove from custom audience action requires ad account and custom audience.",
    "rulesBasedOn": "rules based on",
    "selectUserForNotification": "Select user for send notification.",
    "sendEmailRequiresFields": "Send email action requires from, to, subject and message.",
    "sendNotificationRequiresFields": "Send notification action requires title, body and user type for send notification.",
    "sendSmsRequiresFields": "Send sms action requires to number and message.",
    "stripeMinAmountUSD": "Amount must be greater or equal to 50 cents USD.",
    "stripeRequiresFields": "Stripe one time charge action requires customer id, amount and currency",
    "thatWillFire": "that will fire",
    "triggerCannotBeEmpty": "Trigger can't be empty",
    "updateContactFieldRequires": "Update contact field should have atleast 1 field set."
  },
  "workflow": {
    "resellPaywall": {
      "buttonText": "Pay ${amount} and Subscribe",
      "commitment": "No commitment, cancel anytime",
      "features": {
        "billedOnUsage": "Billed based on usage after the limit is exceeded",
        "externalAI": "Excludes External AI Model actions, which will be billed separately",
        "leadingPricing": "Industry leading pricing!",
        "monthlyPurchase": "Valid for one purchase per month",
        "premiumActions": "Applies to premium actions and triggers"
      },
      "planDetails": "Plan Details",
      "subscribeAndSave": "Subscribe and save today!",
      "title": "${amount} for {executions} executions per month"
    }
  },
  "appointmentWidget": {
    "movedMessage": "This setting has moved to the calendars page.",
    "toNavigate": "here to navigate. This page will be removed soon."
  },
  "attribution": {
    "description": "The first interaction is simply the first touchpoint a user makes. So if someone first discovered you via a paid search (PPC) ad, that channel would get the credit when it comes to a conversion. On the other hand, last interaction would be the last channel.",
    "firstInteraction": "First Interaction",
    "lastInteraction": "Last Interaction",
    "title": "Attribution"
  },
  "campaign": {
    "addEvent": "Add Event",
    "a2p": {
      "address": {
        "chooseState": "Choose state...",
        "city": "City*",
        "postalCode": "Postal/Zip Code*",
        "streetAddress": "Street Address*",
        "streetAddressHelper": "Must be a valid address linked to your business.",
        "title": "Business Address"
      },
      "addressError": {
        "title": "Address Submission Failed"
      },
      "authorizedRep": {
        "jobPosition": "Job Position*",
        "jobTitle": "Job Title*",
        "title": "Authorized Representative Details"
      },
      "brandDetails": {
        "solePropBrand": {
          "heading": "Sole Prop Brand",
          "point1": "Only 1 Phone Number allowed",
          "point2": "EIN/SSN/DUNS not required"
        },
        "solePropCampaign": {
          "heading": "Sole Prop Campaign",
          "point1": "Only 1 number is allowed to be linked to a Sole Prop Campaign",
          "point2": "Once approved your default number will be linked automatically",
          "infoText": "You can also update the number post approval",
          "warningText": "Only 1 number is allowed to be linked to a Sole Prop Campaign. Once approved your default number will be linked automatically, you can also update the number post approval."
        },
        "solePropSubtitle": "Sole Prop Brand and Campaign Details",
        "standardBrand": {
          "heading": "$4.41 - One Time",
          "point1": "EIN/SSN/DUNS required",
          "point2": "More than 1 Phone Number allowed"
        },
        "standardCampaign": {
          "heading": "$16.54 - One Time",
          "point1": "More than 1 number is allowed to be linked to a Standard Campaign",
          "point2": "EIN/SSN/DUNS required",
          "infoText": "Additional campaign fee up to $12 per month will apply in accordance with TCR rules."
        },
        "standardSubtitle": "Standard Brand and Campaign Details",
        "title": "Brand and Campaign Details"
      },
      "businessInfo": {
        "soleProp": {
          "contactInfo": "Contact information",
          "contactInfoSubtitle": "This can be any person that can answer questions about this brand, if needed. Please note that you cannot reuse contact information between brands. Each brand you create must have unique contact information.",
          "emailHelper": "Don't use the same email for more than 5 brands.",
          "phoneNumberHelper": "Don't use the same phone number for more than 5 brands.",
          "profileName": "Business Name Or Your First and Last Name*",
          "profileNameHelper": "Use either legal name of the organization which is sending the messages, or your own name if this brand is not for an organization.",
          "nextLoading": "Next...",
          "invalidPhoneNumber": "Invalid Phone Number",
          "phoneNumberWithCountryCode": "Phone Number (With country code)*",
          "phoneNumberRequired": "Phone Number is required.",
          "emailRequired": "Email is required.",
          "profileNameRequired": "Profile name is required."
        },
        "standard": {
          "businessType": "Business Type*",
          "legalBusinessName": "Legal Business Name*",
          "legalBusinessNameHelper": "Enter the exact business name, as registered with the Government and mentioned in your tax documents (CP 575). E.g. Leadconnector LLC rather than Leadconnector.",
          "regionsOfOperations": "Business Regions of Operations*",
          "registrationNumber": "Business Registration Number*",
          "registrationNumberHelper": "The number used to identify your business. In case of US EIN, must be a 9-digit number e.g.12-3456789.",
          "registrationType": "Business Registration ID Type*",
          "website": "Business Website*"
        }
      },
      "businessProfileRegistration": {
        "stepProgress": "Step {currentStep} of {businessInfoSteps}"
      },
      "businessProfileSuccess": {
        "message": "Your business profile has been submitted successfully.",
        "startA2P": "Start A2P Registration",
        "title": "Business Profile Submitted Successfully",
        "tooltips": {
          "agency": "Agency users can start A2P registration",
          "location": "Location users can start A2P registration"
        }
      },
      "campaign": {
        "endUserConsent": {
          "closeExample": "Close Example",
          "optInKeywords": "Opt-in Keywords*",
          "optInKeywordsHelper": "Max length: 255 characters.",
          "optInKeywordsPlaceholder": "Keywords separated by comma, Example: SUBSCRIBE, START.",
          "optInMessage": "Opt-in Message*",
          "optInMessageInfo": "Must contain business name and opt-out keyword",
          "optInMessagePlaceholder": "Example: You have successfully opted-in to receive notification and promotional SMS from company_name. Please reply STOP if you need to Opt-out in future.",
          "placeholder": "Example: End users opt-in by visiting - https://www.mycompany.com/book and filling in their details. Users check a box to receive notifications & promotional messages from us to provide their consent.Additionally end users can also text START to +1 (213) 725-2867.",
          "question": "How do end-users consent to receive messages?*",
          "seeExample": "See Example"
        },
        "messageDetails": {
          "embeddedLink": "The message will include an embedded link",
          "phoneNumbers": "The messages will include phone numbers",
          "sampleMessage1Placeholder": "Example: Hi John! This is Jane from company_name. Our appointment for July 20 11:00 AM is confirmed. Please reach out to +1(213) 725-2867 in case you need to reschedule.Reply STOP to unsubscribe.",
          "sampleMessage2Placeholder": "Example: Hey Brian! This is Jane from company_name. I see that you weren't able to make it for our appointment. Would you like to reschedule? - https://www.mycompany.com/book.Reply STOP to unsubscribe.",
          "sampleMessageInfo": "Must include lead name, your name, business name & opt-out language",
          "subtitle": "Add Sample messages"
        },
        "useCaseDetails": {
          "explainInDetail": "Please explain in detail",
          "pickUseCase": "Pick Campaign use case",
          "solePropLabel": "Sole Proprietor",
          "subtitle": "Enter the campaign details and description",
          "useCase": "Campaign Use Case*",
          "useCaseDescription": "Use Case Description*",
          "useCaseDescriptionPlaceholder": "Example: This campaign sends appointment information - confirmation & reminder messages to our customers once they have booked an appointment with us on our website and opted-in to receive promotional and notification SMS from us."
        }
      },
      "einModal": {
        "disableNoEINText": "Only Business with valid US and Canada address are allowed to register A2P brand without a tax ID.",
        "hasEIN": "Yes, the business I'm registering has a Tax ID (E.g. EIN, CCN etc.).",
        "infoText": "You can find your US EIN on your CP 575 form.",
        "noEIN": "No, the business I'm registering does not have a Tax ID (E.g. EIN, CCN etc.).",
        "question": "Does the business you're registering have a Tax ID (E.g. EIN, CCN etc.)?*",
        "title": "Determine A2P Brand needs"
      },
      "exampleModal": {
        "examples": "Examples"
      },
      "otpError": {
        "message": "There was some issue while sending the OTP.",
        "title": "Failed to resend OTP"
      },
      "otpSuccess": {
        "title": "Your OTP has been sent successfully."
      },
      "validation": {
        "cityRequired": "City is required.",
        "countryRequired": "Country is required.",
        "invalidMobileNumber": "Invalid Mobile Number",
        "postalCodeRequired": "Postal / Zip Code is required.",
        "stateRequired": "State is required.",
        "streetAddressRequired": "Street address is required."
      }
    },
    "affiliates": {
      "affiliateAboutIframe": "affiliate-about-iframe",
      "agencyOwner": "Agency Owner",
      "agencyOwnerAndAdmins": "Agency Owner and Admins",
      "contactAgencyOwner": "If you need assistance, please contact your",
      "firstPromoterAccessMessage": "This FirstPromoter reports is only accessible by the",
      "firstPromoterIframe": "firstpromoter-iframe",
      "noPartnerFound": "Could not find a partner matching your filters. Click",
      "paymentDetailsAccessMessage": "This payment details section is only accessible and editable by the",
      "toApplyPartner": "to apply to become a partner."
    },
    "common": {
      "actions": {
        "googleDrive": "Google Drive"
      },
      "labels": {
        "doc": "Doc"
      },
      "loading": "Loading",
      "legalBusinessNameHelper": "Enter the exact business name, as registered with the Government and mentioned in your tax documents (CP 575). E.g. Leadconnector LLC rather than Leadconnector."
    },
    "desktop": {
      "highlevel": {
        "logoAltText": "HighLevel Logo",
        "launchingDescription": "Click <span class='font-semibold'>Open HighLevel</span> to launch the desktop app.<br>Not working? You can also <a href=\"/\" class='!text-blue-700 hover:underline'>use HighLevel in your browser</a>",
        "launchingTitle": "Launching HighLevel Desktop",
        "launchButtonText": "Open HighLevel"
      },
      "leadconnector": {
        "logoAltText": "LeadConnector Logo",
        "launchingDescription": "Click <span class='font-semibold'>Open LeadConnector</span> to launch the desktop app.<br>Not working? You can also <a href=\"/\" class='!text-blue-700 hover:underline'>use LeadConnector in your browser</a>",
        "launchingTitle": "Launching LeadConnector Desktop",
        "launchButtonText": "Open LeadConnector"
      }
    },
    "email": {
      "actionCard": {
        "chooseAction": "Choose an action",
        "destination": "Destination",
        "removeFromAllCampaigns": "This action will remove leads from all campaigns except the current campaign",
        "triggerLinks": "Trigger Links"
      },
      "importTemplate": {
        "errorImporting": "Error while importing Template!",
        "importTemplate": "Import template",
        "importing": "Importing",
        "title": "Import {entityName} template",
        "unnamedEntity": "Unnamed {entityName} Copy"
      },
      "lcEmail": {
        "migrationModal": {
          "below": "below",
          "confirmByTyping": "Please confirm by typing",
          "confirmWord": "CONFIRM",
          "existingNotMoved": "If your client already have Mailgun or SMTP setup they will not be moved over",
          "notNow": "Not Now",
          "pricingInfo": "LC Email is cheaper than Mailgun and will cost about $0.68 for 1000 emails",
          "setAsDefault": "Set LC Email as the default provider for your agency and clients who don't already have Mailgun or SMTP",
          "thisWill": "This will:",
          "title": "You are migrating to Lead Connector Email",
          "useLcEmail": "Use LC Email"
        }
      },
      "newPostModal": {
        "dragDropMedia": "Drag or Drop Media Here",
        "editPost": "Edit Post",
        "enterText": "Enter text here",
        "exampleComment": "Very Cool!! Looking forward to this!",
        "exampleName": "Test Tech",
        "hashtag1": "#hashtag",
        "hashtag2": "#awesome",
        "hashtag3": "#cool",
        "imagePlaceholder": "img(02).png",
        "needReview": "Need Review?",
        "network": "Network",
        "photo": "photo",
        "previewPost": "Preview Post",
        "selectNetwork": "Select Social Network",
        "sizeExample": "245kb",
        "textExample": "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
        "urlExample": "https://searchengineland.com/google-announces-new-features-for-retail-advertisers-at-smx-advanced-300001"
      },
      "numberPool": {
        "confirmation": {
          "createdMultiple": "You've created number pool of {count} numbers to track visitors on your website. <br />Your calls will be forwarded to",
          "createdSingle": "You've created {count} number to track visitors on your website. <br />Your calls will be forwarded to",
          "percentComplete": "100% Complete"
        },
        "create": {
          "correctErrors": "Correct them errors!",
          "forwardHelp": "Tell us which phone should ring when the customer calls your tracking phone number. This is typically your primary business phone number. Example: 404-555-1212",
          "heading": "Number Pool & Call Forwarding",
          "nameHelp": "The '{name}' is how we'll refer to this tracking number in your account. Pick a brief and memorable name.",
          "newTrackingNumbers": "new tracking numbers.",
          "nextTracking": "Next: Tracking Options",
          "percentComplete": "50% Complete",
          "pleaseConfirm": "Please confirm:",
          "poolSize": "Pool Size",
          "poolSizeError": "Enter a pool size between 4 and 30 tracking numbers.",
          "poolSizeHelp": "The size of your number pool determines how many concurrent visitors we can track on your website at any given time. Your pool size should be a quarter of the peak hourly traffic reported in Google Analytics, with a minimum of 4 numbers.",
          "swappingHelp": "Tell us which phone number should we swap on the website. Example: 404-555-1212",
          "swappingNumber": "Swapping Number",
          "validationError": "There was an error validating the form"
        },
        "features": {
          "activateNumber": "Activate Number",
          "address": "{type} Address",
          "addressHelp": "Purchasing number for some countries require address. Kindly contact support about how to add address if you need help.",
          "heading": "Number Features",
          "leaveBlank": "Leave blank for no message",
          "recordingDescription": "Activate call recording and play a short message to the caller.",
          "recordingHelp": "Some jurisdictions require both parties to consent to any recorded conversation. To assist in the compliance of these laws, you can enable a greeting to inform the caller that the call may be recorded.",
          "whisperDescription": "A short message that plays before the call. The caller does not hear this message."
        },
        "tracking": {
          "heading": "Tracking Options",
          "nextCreatePool": "Next: Create Pool",
          "percentComplete": "34% Complete",
          "searchLower": "search"
        },
        "whatToTrack": {
          "heading": "What do you want to track on your website?",
          "trackCampaign": "Track a marketing campaign",
          "trackCampaignDescription": "Create one phone number that tracks all callers to a single marketing campaign.",
          "trackVisitor": "Track visitor activity",
          "trackVisitorDescription": "Create multiple numbers that correlate calls to website visitors, PPC keywords, and more."
        }
      }
    },
    "loader": {
      "clickHereToRefresh": "click here to refresh.",
      "issuesLoadingApp": "If you are having issues loading the app",
      "loadingFreshData": "Loading fresh data...",
      "loadingNewSubAccountData": "Loading new sub account data..."
    },
    "login": {
      "bySigningInYouAgree": "By signing in you agree to our <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Terms and Conditions</a>",
      "newPasswordSent": "A new password is sent to your email."
    },
    "regulatoryBundle": {
      "a2p": {
        "activityHistory": {
          "by": "By:"
        },
        "affiliates": {
          "partnerBadgeAlt": "Partner badge"
        },
        "checkout": {
          "cardInformation": "Card information",
          "cardNumberInvalid": "Your card number is invalid.",
          "commitment": "commitment",
          "consentOneTime": "By confirming, you allow LeadConnector to charge your card for this payment.",
          "consentSubscription": "By confirming your subscription, you allow LeadConnector to charge your card for this payment and future payment for this subscriptions",
          "defaultIntervalCount": "1",
          "endingIn": "ending in",
          "errorImageAlt": "Error illustration",
          "intervalSuffix": "(s)",
          "month": "month",
          "pay": "Pay",
          "payWithCard": "pay with card",
          "paymentProcessing": "Payment is being processed. Please do not reload or press back button",
          "proceedWithExistingCard": "Proceed with existing card",
          "proceedWithNewCard": "Proceed with a new card",
          "prorationDetails": "You will be charged for {days} days right now for period till {billingEnd}, and start getting charged the full amount of ${amount}/month starting from {billingDate}.",
          "prorationMessage": "Initial charges are pro-rated and regular billing will start from {billingDate}",
          "purchase": "purchase",
          "subscribe": "Subscribe",
          "subscribeTo": "Subscribe To",
          "updateCardDetails": "Please Update Card Details",
          "zip": "zip"
        },
        "options": {
          "jobPosition": {
            "gm": "GM",
            "vp": "VP"
          }
        },
        "registration": {
          "stepProgress": "Step {currentStep} of 8",
          "successDescription": "Your A2P brand and campaign has been submitted.",
          "successMessage": "Note: You will receive an OTP message on your provided mobile number to verify from TCR. Please reply Yes within 24 hrs of receiving the SMS.",
          "successWaitDays": "7 days",
          "successWaitPrefix": "It might take up to ",
          "successWaitSuffix": " for your Brand approval and additional 4-5 weeks for Campaign approval."
        },
        "reminder": {
          "noReplyYet": "No Reply Yet",
          "patientConfirmed": "Patient Confirmed"
        },
        "sendGrid": {
          "apiKeyRequired": "API Key Required"
        },
        "update": {
          "brandNameHelper": "Use legal name of the organization which is sending the messages.",
          "businessVerticals": "Business Verticals*",
          "resendOTP": "Resend OTP",
          "retryOTPTitle": "Retry OTP Verification"
        }
      },
      "addCustomEmailModal": {
        "title": "Add Custom Email"
      },
      "addEditSMTPServiceModal": {
        "addProvider": "Add Provider",
        "clickHereForInfo": "Click here to get more information.",
        "clickHereToFindOut": "Click here to find out about them.",
        "createProviderError": "Something went wrong while creating provider!",
        "gmailLimitations": "Gmail have some limitations.",
        "needHelp": "Need Help to find SMTP server and port number?",
        "port25NotSupported": "Port 25 is not supported! Please use port 2525 instead",
        "providerExists": "A provider with this email/username already exist.",
        "providerName": "Provider Name",
        "selectProvider": "Select Provider",
        "smtpPortNumber": "SMTP Port Number",
        "smtpProvider": "SMTP Provider",
        "smtpServer": "SMTP Server",
        "username": "Username",
        "usernameOrEmailRequired": "Either username or email is required.",
        "verifySmtpAccount": "Verify SMTP account"
      },
      "addTagModal": {
        "addTag": "Add Tag",
        "editTag": "Edit Tag",
        "tagAlreadyExists": "Tag {tag} already exists"
      },
      "affiliates": {
        "firstPromoterAccessMessage": "This FirstPromoter reports is only accessible by the <strong>Agency Owner and Admins</strong>. If you need assistance, please contact your <strong>Agency Owner ({agencyOwnerEmail})</strong>.",
        "firstPromoterIframeTitle": "FirstPromoter dashboard",
        "noPartnersFound": "Could not find a partner matching your filters. Click <a href='javascript:void(0);'>here</a> to apply to become a partner.",
        "paymentDetailsAccessMessage": "This payment details section is only accessible and editable by the <strong>Agency Owner</strong>. If you need assistance, please contact your <strong>Agency Owner ({agencyOwnerEmail})</strong>."
      },
      "appointmentDetails": {
        "title": "Appointment Details"
      },
      "attachSnapshotToggle": {
        "loadSnapshot": "Load Snapshot:",
        "loadSnapshotWarning": "Do you wish to load the snapshot associated with this plan? <br /> <strong class='text-danger'>Existing data may be lost</strong>"
      },
      "auth": {
        "changePassword": {
          "changeButton": "Change Password",
          "confirmPassword": "Confirm New Password",
          "expired": "Your password reset link has expired.",
          "regenerateLink": "Regenerate Link",
          "success": "Password changed successfully",
          "title": "Set New Password",
          "passwordMismatch": "Passwords do not match"
        },
        "forgotPassword": {
          "contactAgency": "contact your agency.",
          "contactSupport": "contact HighLevel Support 24/7 by calling",
          "supportMessage": "If you don't have access to that email box, please",
          "successMessage": "A password reset link has been sent to your email address.",
          "rateLimitError": "Too many password reset requests. Please try again later."
        },
        "login": {
          "inactivityMsg": "We noticed you've been inactive for a while, so we've logged you out to ensure your security.",
          "loginButton": "Login",
          "resetPasswordMsg": "A password reset link is sent to your email.",
          "signInWithGoogle": "Sign in with Google",
          "contactHighLevelSupport": " contact HighLevel Support 24/7 by calling"
        },
        "logout": {
          "loggingOut": "Logging out..."
        },
        "otp": {
          "enterBackupCode": "Enter your backup code",
          "resend": "Resend",
          "resendIn": "Resend in",
          "sendToPhone": "Send code to phone",
          "sending": "Sending",
          "useAuthenticator": "Use Authenticator App",
          "useBackupCode": "Use backup code",
          "verifyButton": "Verify with backup code"
        },
        "sso": {
          "agreeTerms": "By signing in you agree to our <a class='font-semibold text-curious-blue-500 hover:text-curious-blue-800' href='{termsConditionsURL}' target='_blank'>Terms and Conditions</a>",
          "and": ", and",
          "loginDifferentMethod": "Log in using a different method",
          "loginSuccessRedirecting": "Login successful, redirecting...",
          "processing": "Processing your request...",
          "redirecting": "Redirecting...",
          "redirectingToDashboard": "Redirecting to dashboard...",
          "signedIn": "Signed in",
          "signingIn": "Signing in...",
          "testFailedRedirecting": "Test failed, redirecting...",
          "testSuccessRedirecting": "Test successful, redirecting..."
        }
      },
      "businessDetailModal": {
        "businessAddress": "Business Address: {address}",
        "businessDetailsText": "The following Business details will be submitted to Google Local Services Ads for Reserve with Google Integration. Please check and confirm or {link} to update your Business Profile.",
        "businessInfoRequired": "The above listed Business info are required for integration, {link} to update the missing/incorrect business details.",
        "businessName": "Business Name: {name}",
        "businessNiche": "Business Niche: {niche}",
        "city": "City: {city}",
        "confirmDetails": "I hereby confirm the above mentioned details are correct",
        "country": "Country: {country}",
        "mustConfirmDetails": "You have to confirm the above mentioned details.",
        "phoneNumber": "Phone Number: {phone}",
        "state": "State: {state}",
        "zipCode": "Zip Code: {zipCode}"
      },
      "calendarHourRow": {
        "addHours": "Add Hours",
        "applyAll": "Apply All"
      },
      "campaign": {
        "callerIdVerificationModal": {
          "answerCall": "Answer the call and enter this verification code:",
          "leadConnectorCalling": "Lead Connector is calling...",
          "title": "Add a Caller ID By Voice",
          "waitingForVerification": "Waiting for the verification..."
        },
        "callerIdVerificationStatus": {
          "failed": "Caller ID verification failed. Please try again.",
          "success": "You have successfully verified <strong>{contact}</strong>"
        },
        "choosePhoneNumberModal": {
          "addExistingNumbers": "Add Existing Number(s)",
          "areaCode": "Area Code:",
          "checkAvailability": "Check Availiability",
          "checkingAvailability": "Checking Number Availiability.",
          "chooseAreaCode": "Choose an Area Code",
          "choosePhoneNumbers": "Choose Phone Number(s)",
          "goBack": "Go Back",
          "localNumbers": "Local {type}",
          "nextNumberFeatures": "Next: Number Features",
          "noExistingNumbers": "No existing number(s) to add",
          "noNumbersAvailable": "No numbers available",
          "notEnoughNumbers": "Not enough numbers available",
          "numbersAvailable": "Numbers available",
          "numbersDifferentArea": "Numbers in a different area code",
          "numbersLocalTo": "Numbers local to <strong>{number}</strong>",
          "problemChecking": "Problem checking number availiability kindly, check network connection or contact support.",
          "somethingWentWrong": "Something went wrong. Please check your Twilio Account Credentials and message support if this persists.",
          "tollFreeNumbers": "Toll-free numbers ($2.00 per number per month surcharge)",
          "percentageComplete": "67% Complete"
        },
        "deleteNumberPoolModal": {
          "confirmDelete": "I understand the consequences, delete the pool",
          "confirmText": "Please type <b>{name}</b> to confirm",
          "title": "Delete NumberPool - <strong>{name}</strong>",
          "warning": "This action cannot be undone. This will permanently delete the number(s) from your twilio account along with Number Pool from our database. Also, if you are deleting number pool because you are facing an issue then do get in touch with our support team."
        },
        "editNumberFormatModal": {
          "description": "You can update the formatting of swapping number(s) and pool number(s) according to your convenience. Make sure that the swapping number(s) appear same on website as formatted.",
          "title": "Update Number Formatting - <strong>{name}</strong>"
        },
        "editNumberPoolModal": {
          "addEditGroupId": "Add/Edit Group Id",
          "callConnectTooltip": "This feature requires that the receiver press a key in order to connect the call, this will result in higher accuracy for call reporting.",
          "createGroupIdDescription": "Create/Add a unique group id to use multiple number pool with a single javascript snippet.",
          "enableCallConnect": "Enable call connect feature",
          "groupId": "Group Id",
          "outboundCallTimeout": "Outbound Call Timeout",
          "passCallerID": "Pass called number as caller id",
          "passCallerIDTooltip": "By default the system passes the number of the caller through but if you want the caller id to instead be the number dialed by the caller enable this feature",
          "selectCallerID": "Select Caller ID",
          "timeDuration": "Time Duration in second(s)",
          "titleNumber": "Number - <strong>{number}</strong>",
          "updateWhisperWarning": "Update whisper message as this feature requires that the receiver press a key to connect the call.",
          "useVerifiedNumber": "Use your Verified Number as callerID for outbound calls",
          "useVerifiedNumberTooltip": "Only applicable for Verified Phone Numbers. You can verify a phone number in Settings > Phone Numbers > Add Verified CallerID"
        },
        "emailOTPModal": {
          "confirmCode": "Confirm Code",
          "resendCode": "If you did not receive the code click here to resend",
          "unexpectedIssue": "Unexpected issue happened"
        },
        "facebookFieldMapModal": {
          "customFieldInfo": "Custom Field Info",
          "customFieldTooltip": "Custom Field Tooltip: {options}",
          "field": "{companyName} Field",
          "trackingParameters": "Tracking Parameters",
          "zipCode": "Zip code"
        },
        "howToUseNumberPoolModal": {
          "addSwappingNumbers": "Add Swapping Numbers",
          "addingSnippets": "Adding Javascript Snippets",
          "groupSnippet": "Group '{id}' Snippet",
          "normalSnippet": "Normal Snippet",
          "noswapDescription": "If you don't want us to swap the number in certain place, add a class 'noswap'.",
          "notReplacing": "Not Replacing at certain place",
          "requiredSteps": "Required Steps",
          "snippetsDescription": "Copy the below snippet and add it just above closing body tag of each page where you want to replace the numbers.",
          "swappingDescription": "Use the numbers below to enable phone number swapping. Select a local or international or even both format."
        },
        "newPhoneNumberModal": {
          "areaCode": "Area Code",
          "availableNumbers": "Available numbers",
          "bundle": "Bundle",
          "chooseAddress": "Choose address...",
          "chooseBundle": "Choose bundle...",
          "createRegulatory": "Create a Regulatory Bundle/Address here.",
          "monthlyFee": "Monthly fee",
          "noNumbersFound": "No numbers found, please try another area code.",
          "selectAddress": "Please select 'Address' to purchase number.",
          "selectBundle": "Please select 'Bundle' to purchase number.",
          "title": "Add Phone Number",
          "upgradeAccount": "Please upgrade your Twilio account, only upgraded accounts can purchase phone numbers, and make phone calls",
          "cardAuthenticationFailed": "Card Authentication failed!"
        },
        "reserveWithGoogleIntegration": {
          "agreeTerms": "You have to agree the terms and privacy condition.",
          "clickingProceed": "Clicking on Proceed will open the LSA linking page in a new tab",
          "configureCalendar": "Configure at least one calendar to proceed with Reserve with Google Integration",
          "configureCalendarBtn": "Configure calendar",
          "linkOneAccount": "Make sure you link only one account. Contact Support if you are unable to view the page in the screenshot above.",
          "readInstructions": "I have read through the aforementioned instructions"
        },
        "updateTrackingModal": {
          "title": "Update Tracking Option"
        },
        "usageSummary": {
          "agencyOnlyVisible": "( This is visible only to Agency Admins)",
          "updatedEvery24Hours": "(updated every 24 hours)"
        },
        "userCalendarConfiguration": {
          "calendarNotSelected": "Calendar not selected for sync",
          "check": "Check {email}",
          "checkForConflicts": "Check for conflicts",
          "checkForConflictsTooltip": "Set the calendar(s) to check for conflicts to prevent double bookings.",
          "contactCreationAllowed": "Contact creation allowed",
          "googleCalendar": "Google Calendar Logo",
          "noGoogleAccounts": "No google/outlook accounts added in Integrations settings yet",
          "noGoogleAccountsTeamMember": "No google/outlook accounts added for this team member in the current location. Please ask your team member to login through his/her account and add google connection from his/her Integrations settings.",
          "outlookCalendar": "Outlook UserCalendar",
          "primaryCalendarTooltip": "Set the calendar you would like to add new events to as they're scheduled.",
          "runTriggerAllowed": "Run Trigger allowed"
        },
        "warningModal": {
          "contactAgency": "Please contact your agency to change email settings.",
          "title": "Warning"
        }
      },
      "checkout": {
        "prioritySupport": {
          "features": {
            "faster247Chat": "Faster 24/7 Chat Support",
            "faster247Ticket": "Faster 24/7 Ticket Support & Response Times"
          },
          "highlight": {
            "description": "We get it, you need to go faster. When you have a question or concern you want it to be answered as soon as possible! With the Priority Support Upgrade, you can skip the line and automatically accelerate your requests to the front of the line.",
            "heading": "Are you ready for the VIP Treatment?"
          },
          "name": "Priority Support",
          "success": {
            "description": "Priority support has been activated on your account. No more waiting in line for you.",
            "heading": "You are now a priority customer!"
          }
        }
      },
      "cloneFunnel": {
        "cloneButton": "Clone {entityName}",
        "cloning": "Cloning...",
        "cloningLimit": "Cloning is limited to 3 locations at a time",
        "error": "Error while cloning funnel!",
        "locationsLabel": "Select Locations",
        "nameLabel": "Name for the cloned {entityName}",
        "namePlaceholder": "Enter name for cloned {entityName}",
        "selectUpTo": "Select up to {maxSelectableLocations} locations",
        "title": "Clone {entityName}"
      },
      "cnam": {
        "learnMore": {
          "description": "With CNAM, your business name appears on caller ID, making your calls instantly recognizable and boosting trust. Let your customers know it's you calling every time.",
          "title": "Make Your Calls Stand Out!"
        },
        "registration": {
          "characterLimit": "{count}/15",
          "confirm": "Confirm & Register",
          "description": "Display your business name to call recipients to increase trust and call answer rates.",
          "title": "Boost Call Trust with CNAM",
          "warning": "Display of Business Name is not guaranteed, especially on mobile."
        },
        "submitted": {
          "checkStatus": "Check CNAM Status",
          "description": "Your business name should be shown to applicable contacts in around 3-5 days.",
          "subtitle": "Your CNAM request is now submitted.",
          "title": "Congratulations!"
        }
      },
      "confirmMerchantDeleteModal": {
        "confirmDelete": "Confirm Delete",
        "confirmation": "Confirmation"
      },
      "createAddress": {
        "successTitle": "Address Submitted Successfully",
        "underReview": "Address submitted is under review"
      },
      "createEndUser": {
        "dateFormat": "Date format should be YYYY-MM-DD.",
        "phoneExample": " Example: +14155552671",
        "title": "Business Details:"
      },
      "customValueModal": {
        "changingNameWarning": "Changing the name will not affect the field key.",
        "editCustomValue": "Edit Custom Value",
        "fieldKeyCreatedWarning": "The field key will be created according to the name and cannot be changed later.",
        "nameRequired": "The Name field is required",
        "nameValidation": "Name should be alphanumeric and contain at least one character",
        "valueRequired": "The Value field is required"
      },
      "details": {
        "addressName": "Address Name",
        "addressTitle": "Address Details",
        "bundleName": "Bundle Name",
        "bundleTitle": "Regulatory Bundle Details",
        "countryFlag": "{country} flag",
        "id": "ID",
        "organisation": "Organisation",
        "rejectionReason": "Rejection Reason",
        "status": {
          "approved": "Approved",
          "notValidated": "Not Validated",
          "rejected": "Rejected",
          "validated": "Validated"
        },
        "typeOfNumber": "Type of number"
      },
      "drChronoOfficeSelect": {
        "selectOffice": "Select Office",
        "whichOffice": "Which office do you want to link to this account?"
      },
      "editAddToCalendarModal": {
        "allowContactCreation": "Allow contact creation:",
        "allowTrigger": "Allow Trigger:",
        "doNotSync": "Do not sync new events to the primary calendar",
        "primaryCalendarTooltip": "You can only select a calendar with write access that you've not selected for check for conflicts.",
        "selectDefaultCalendar": "Select Default Calendar",
        "whichCalendar": "Which calendar should we use to sync (read and write) events to?"
      },
      "editCheckForConflictsCalendarsModal": {
        "checkThesePlaces": "Check these places for conflicts",
        "howToCheckConflicts": "How should we check for conflicts?"
      },
      "ejectModal": {
        "agencyClosing": "The Elite Marketing agency account with Highlevel is closing. To keep your account, Please reach out to {userName} for migrating your account directly to Highlevel.",
        "cancelWarning": "Please be aware that your account will be officially cancelled on 30th June 2025, and we won't be able to retrieve your data after this date if the transfer is not completed.",
        "contactEmail": "transfers{'@'}gohighlevel.com",
        "contactUs": "If you have any questions, please contact us at",
        "faqsUrl": "gohighlevel.com/getstartedtoday-em",
        "freeTransition": "To support you during this free transition, we're applying {months} of free access to your new subscription.",
        "intro": "Due to repeated violations of HighLevel's Terms of Service, Elite Marketing Authority (EMA) has been permanently removed from the HighLevel platform.",
        "platformCommitment": "As the platform powering EMA's services, HighLevel is committed to maintaining a safe, compliant, and trustworthy environment for all users. To avoid disruption to your account, we're here to help you seamlessly transition - either to another white-label provider or directly to HighLevel.",
        "questions": "If you have any questions,",
        "retainAccess": "To retain access to your existing data and tools, click the button below and follow the instructions to initiate the transfer.",
        "speakWithTeam": "to speak with our team.",
        "startTransfer": "Start Your Free Transfer",
        "title": "Attention Elite Marketing Customers",
        "viewFaqs": "View FAQs here:",
        "whiteLabel": "If you'd prefer to access HighLevel through another white-label provider, we'll be happy to accommodate that change via our support ticketing system after you've transferred your account directly to HighLevel."
      },
      "emailTemplate": {
        "createdOn": "Created On",
        "updatedOn": "Updated On"
      },
      "error": {
        "title": "Regulatory Bundle Submission Failed"
      },
      "errors": {
        "funnel": {
          "multiplePages": "More than one page has this URL, change the path of this page to get it to work.",
          "urlNotFound": "Sorry, we can't find the url you were looking for"
        },
        "productRebilling": {
          "requestFailed": "Request failed"
        },
        "template": {
          "categoryNotFound": "Sorry, we can't find the category you were looking for.",
          "internalError": "An internal error occured!"
        },
        "transfer": {
          "hipaaEnabled": {
            "message": "The sub-account that you are trying to transfer is HIPAA enabled, and can not be transferred to a non-HIPAA agency."
          },
          "limitExceeded": {
            "message": "The agency that you are trying to transfer the sub-account to has exhausted their usage limit and can not gain any more sub-accounts.  Kindly ask them to either delete a sub-account that is not in use or upgrade to a higher agency plan in order to gain this sub-account."
          },
          "pendingRequest": {
            "heading": "A transfer request for this sub-account is already pending.",
            "message": "Kindly cancel the already existing transfer request for this sub-account before proceeding to raise a new one."
          }
        }
      },
      "facebookPageSelect": {
        "cannotFind": "Cannot find the page you are looking for? Please visit your Facebook settings & ensure all the pages are selected.",
        "instagramAvailable": "Instagram is available for this Account!",
        "noPages": "You don't have any pages under this account.",
        "title": "Select which facebook page you want to link to this location"
      },
      "googleLocationSelect": {
        "closeButton": "Close!",
        "enableCallTracking": "Enable GBP call tracking",
        "noBusinesses": "You don't have any connected businesses under this account."
      },
      "importCustomers": {
        "newExperience": {
          "efficient": "More Efficient",
          "faster": "Faster",
          "itsText": "It's",
          "smoother": "Smoother",
          "title": "A New Import Experience is Here!",
          "warningMessage": "Enabling the New Import experience activates Labs for this Sub-Account and turns on the Beta Feature."
        },
        "validateEmails": "Validate emails?"
      },
      "initBundle": {
        "numberType": "Type of numbers you planned to use",
        "numberTypes": {
          "local": "Local Numbers",
          "mobile": "Mobile",
          "tollfree": "Tollfree"
        },
        "selectCountry": "Select your Country",
        "selectUserType": "Select the user type",
        "userTypes": {
          "business": "Business",
          "individual": "Individual"
        }
      },
      "manageLocationCredits": {
        "creditLastAddedOn": "Credit last added on:",
        "currentBalance": "Current Balance",
        "debitBalance": "- Debit Balance",
        "depositComplimentaryCreditsOf": "Deposit Complimentary credits of",
        "manageBalance": "Manage Balance",
        "mustBeValidInteger": "Must be a valid Integer",
        "nextDate": "Next Date:",
        "perMonth": "per month",
        "remainingWalletBalance": "Remaining wallet balance of this sub-account",
        "rolloverCredits": "Rollover Credits to next month",
        "toManageMonthlyCredits": "To manage monthly credits,"
      },
      "manageLocationSubscriptionModal": {
        "addNewSubscription": "Add New Subscription"
      },
      "manualActions": {
        "confirmDelete": "Are you sure you want to delete this action?",
        "confirmDeleteAll": "Are you sure you want to delete all of the manual actions in this page?"
      },
      "membership": {
        "resetPassword": {
          "generateStrongPassword": "Generate a strong password",
          "sendEmailNotification": "Also, send an email notification."
        }
      },
      "modal": {
        "description": "You need to complete few easy compliance steps to use phone systems",
        "submit": "Submit",
        "title": "Lead connector Phone Service"
      },
      "notifications": {
        "list": {
          "homePageVisitors": "Home page visitors",
          "launched": "Launched",
          "newNotification": "New Notification",
          "startMessage": "Start boosting your conversions by creating your first notification",
          "types": {
            "combination": "Combination"
          }
        },
        "page": {
          "createTitle": "Create New Notification",
          "steps": {
            "display": "Display",
            "track": "Track"
          }
        }
      },
      "opportunities": {
        "columns": {
          "additionalInfo": "Additional Info",
          "calendarEvent": "Calendar Event",
          "hideAssignedTo": "Hide Assigned To",
          "hideTags": "Hide Tags"
        },
        "filters": {
          "dateAddedAsc": "↑ Date Added (ASC)",
          "dateAddedDesc": "↓ Date Added (DESC)",
          "orderBy": "OrderBy"
        },
        "getStarted": "get started!",
        "noPipelines": "Oops! Looks like there are no pipelines. Create a new pipeline to"
      },
      "pages": {
        "pageMoved": {
          "title": "Online Listings have moved"
        }
      },
      "recentlyVisited": {
        "prices": "{count} prices"
      },
      "reminders": {
        "appointmentReminders": "Appointment Reminders",
        "apptTime": "Appt Time",
        "defaultDateRange": "Sun, Apr 1st, 2018 - Mon, Apr 31st, 2018"
      },
      "saasAccountDetailsActiveSubscription": {
        "onHold": "On Hold",
        "rebillingOnHoldWarning": "This account already has rebilling configurations on hold. SaaS plan can only be attached after the client has added a payment method.",
        "subscriptionId": "Subscription ID:"
      },
      "saasPricingTable": {
        "confirmAndProceed": "Confirm & Proceed",
        "documents": {
          "acceptedDocuments": "Accepted Documents",
          "acceptedDocumentsLabel": "Accepted Documents:",
          "additionalInfo": "Additional Information:",
          "createAddressLink": "Create Address.",
          "createAddressPrompt": "Please create an address first and then proceed with the bundle creation.",
          "documentInfo": "PNG, JPG, PDF up to 5 MB",
          "documentType": "Document Type",
          "option": "Option {number}",
          "selectAddress": "Select Address:",
          "selectDocumentType": "Select Document Type:",
          "selectFile": "Select File",
          "title": "Required Documents:",
          "updateDocuments": "Update Documents"
        },
        "everythingIn": "Everything in <b>{plan}+</b>",
        "noPaymentMethod": {
          "linkText": "add credit card here",
          "message": "Please ask your client to",
          "title": "Location needs to add payment method first."
        },
        "noSaasPlan": {
          "linkText": "create your SaaS plans here.",
          "message": "Please",
          "title": "You have no SaaS plan configured."
        },
        "saasModeSetupPendingWarning": "The SaaS plan will be activated after the client adds a payment method. Until then, their account access will be restricted.",
        "skipForNow": "Skip for now",
        "skipPlan": "Skip Plan",
        "success": {
          "title": "Regulatory Bundle Submitted Sucessfully",
          "underReview": "Bundle Submitted Under Review"
        }
      },
      "selectBundle": {
        "addressBundle": {
          "description": "This option will add new address to your account",
          "label": "Address Bundle"
        },
        "regulatoryBundle": {
          "description": "This option will help you create new regulatory bundle",
          "label": "Regulatory Bundle"
        },
        "title": "Choose which bundle you want add"
      },
      "settings": {
        "billing": "Billing",
        "calendars": "Calendars",
        "customEmails": "Custom Emails",
        "domains": "Domains",
        "domainsAndUrlRedirects": "Domains & URL Redirects",
        "facebookFormFieldsMapping": "Facebook Form Fields Mapping",
        "groups": "Groups",
        "integrations": "Integrations",
        "labs": "Labs",
        "media": "Media",
        "noShowSMS": "No Show SMS",
        "pipelines": "Pipelines",
        "profile": "Profile",
        "smtpAndMailGunService": "SMTP and MailGun Service",
        "templates": "Templates",
        "urlRedirects": "URL Redirects"
      },
      "shakenStir": {
        "confirmation": {
          "title": "Your Calls Are Now Verified!"
        },
        "modal": {
          "andThe": " and the ",
          "certification": "I certify that the associated Business Profile is the originator of the phone calls and certify that I will participate in traceback efforts, including those initiated by the",
          "failedTitle": "Submission Failed",
          "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 at 19:47:14",
          "linkInfo": {
            "description": "All current available numbers and future bought numbers will automatically will be registered with SHAKEN/STIR.",
            "title": "All numbers will be Linked Automatically"
          },
          "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
          "subtitle": "Enter the details and Description",
          "successMessage": "Your request for SHAKEN/STIR registration submitted. It might take up to <b>3-4 days</b> to get approved. The status will be updated soon.",
          "successTitle": "SHAKEN/STIR Trusted Calling Enabled.",
          "title": "Enable SHAKEN/STIR Trusted Calling",
          "tracebackGroup": "US Telecom Traceback Group"
        },
        "withCnam": {
          "cnamPromo": "Want to go a step further? Show your business name on calls with CNAM.",
          "registerCnam": "Register for CNAM",
          "title": "Build Customer Trust and Increase Call Answer Rates"
        },
        "successMessage": "Your request for SHAKEN/STIR registration submitted. It might take up to <b>3-4 days</b> to get approved. The status will be updated soon."
      },
      "shopify": {
        "selectLocation": "Select which location you want to link to this shopify store"
      },
      "signup": {
        "accountType": "Account type",
        "agencyProAccount": "Agency Pro Account ($497/month)",
        "agencyTestAccount": "Agency Test Account",
        "freeTrialMessage": "Get a 14 day <strong>free</strong> trial by signing up right now.",
        "freelancerAccount": "Freelancer Account ($297/month)",
        "getStartedForFree": "Get started for free!",
        "pickPassword": "Pick a password",
        "signUp": "Sign up",
        "starterAccount": "Starter Account ($97/month)",
        "termsAndConditions": "By signing up, you agree to our <a href='https://www.gohighlevel.com/privacy' target='_blank'>Terms and Conditions</a>",
        "yourCompanyName": "Your company name",
        "yourFullName": "Your full name"
      },
      "standardPlan": {
        "description": "We have the following plans for Standard Brand registrations.",
        "plans": {
          "common": {
            "einRequiredForRegistration": "EIN required for registration",
            "moreThan1Phone": "More than 1 Phone Number allowed"
          },
          "highVolume": {
            "heading": "High Volume Standard",
            "point3": "Up to 600,000 segments per day",
            "infoText": "Brand and Campaign registration one Time $20.95 will be charged. Additional campaign fee up to $2.25 per month will apply in accordance with TCR rules.",
            "point2": "Send upto 3000 segments per day",
            "point1": "EIN required for registration"
          },
          "lowVolume": {
            "heading": "Low Volume Standard",
            "recommended": "Recommended",
            "point3": "Upto 6000 segments per day",
            "infoText": "Brand and Campaign registration one Time $20.95 will be charged. Additional campaign fee up to $2.25 per month will apply in accordance with TCR rules.",
            "point2": "Send upto 3000 segments per day",
            "point1": "EIN required for registration"
          }
        },
        "title": "Select your Standard Brand Plan"
      },
      "submissionDetail": {
        "titles": {
          "bookingDetails": "Booking Details",
          "form": "Form",
          "quiz": "Quiz",
          "submissionDetail": "Submission Detail",
          "survey": "Survey"
        }
      },
      "suspension": {
        "suspended": {
          "description": "Only agency admins/users have access to this sub-account. Currently, you and other account admins/users do not have access to this sub-account.",
          "heading": "This sub-account has been paused."
        },
        "temporarily": {
          "description": "All your data is safe and all triggers/campaigns, etc will resume working after activation.",
          "heading": " Your account has been suspended temporarily."
        }
      },
      "triggers": {
        "assignUser": {
          "onlyUnassignedContacts": "Only apply to unassigned contacts",
          "splitTraffic": "Split Traffic",
          "trafficWeightage": "Traffic Weightage",
          "userRequired": "User needs to be selected",
          "weightage": "Weightage"
        },
        "birthdayFilters": {
          "afterDays": "After no. of days",
          "beforeDays": "Before no. of days",
          "dayIs": "Day is",
          "daysInNumber": "Days in number",
          "hasTag": "Has Tag",
          "monthIs": "Month is",
          "selectDay": "Select day",
          "selectMonth": "Select month"
        },
        "botConversation": {
          "enterTimeout": "Enter a Timeout (Hours)",
          "selectEliza": "Select Eliza",
          "selectThankyouTemplate": "Select Thankyou Template",
          "selectWelcomeTemplate": "Select Welcome Template"
        },
        "contactField": {
          "addField": "Add field",
          "defineFilters": "Define filters"
        },
        "copyModal": {
          "title": "Copy Trigger"
        },
        "detailModal": {
          "actionsPerform": "What actions should we perform?",
          "campaignNameRequired": "The Campaign name field is required",
          "campaignsDeprecation": "Campaigns are no longer maintained. To ensure a smooth transition, kindly convert your existing Campaigns into Workflows.",
          "folderName": "Folder Name",
          "mustSelectFolder": "Must select a folder.",
          "newFolderName": "New folder name",
          "selectFolder": "Select folder",
          "triggerNameRequired": "The Trigger name field is required",
          "triggersDeprecation": "Triggers are no longer maintained. To ensure a smooth transition, kindly convert your existing Triggers into Workflows.",
          "triggerName": "Trigger Name"
        },
        "dnd": {
          "disableAll": "Disable DND for all channels",
          "disableSpecific": "Disable DND for specific channels",
          "enableAll": "Enable DND for all channels",
          "enableSpecific": "Enable DND for specific channels",
          "selectAction": "Select Action"
        },
        "email": {
          "sendTestEmail": "Send Test Email",
          "smtpWarning": "SMTP providers has some limitations. Click here to know more."
        },
        "facebook": {
          "avatarAlt": "Facebook avatar",
          "selectCustomAudience": "Select custom audience"
        },
        "googleAds": {
          "conversionName": "Conversion Name",
          "conversionTooltip": "Conversion source should be Import From Clicks and category should be Imported Lead or Lead",
          "noConversions": "No conversions found",
          "selectConversion": "Select conversion"
        },
        "googleAnalytics": {
          "eventAction": "Event Action",
          "eventActionRequired": "Event Action is required.",
          "eventCategory": "Event Category",
          "eventCategoryRequired": "Event Category is required.",
          "eventLabel": "Event Label",
          "eventValue": "Event Value",
          "hitType": "Hit Type",
          "hitTypeRequired": "Hit Type is required.",
          "trackingId": "Tracking Id",
          "trackingIdRequired": "Tracking Id is required."
        },
        "membershipOffer": {
          "selectOffer": "Select offer"
        },
        "notification": {
          "selectRedirectPage": "Select Redirect Page",
          "selectUser": "Select User",
          "selectUserType": "Select User Type"
        },
        "sms": {
          "sendTestSMS": "Send Test SMS"
        },
        "stripeCharge": {
          "customerId": "Stripe Customer ID",
          "enterAmount": "Enter Amount",
          "selectCurrency": "Select Currency"
        },
        "webhook": {
          "webhookUrl": "Webhook URL"
        }
      },
      "twilioReselling": {
        "transactions": {
          "fields": {
            "activityDate": "Activity Date",
            "balance": "Balance",
            "id": "id"
          }
        },
        "upgradeBanner": {
          "subtitle": "Agencies on pro plan make about $363 per month by rebilling phone costs to their clients",
          "title": "Want to rebill this to your clients?"
        }
      },
      "updateModals": {
        "error": {
          "title": "Failed to submit your Profile."
        },
        "success": {
          "message": "Your A2P brand and campaign has been submitted.<br/><br/><b>Note:</b> You will <b>receive an OTP message on your provided mobile number to verify</b> from TCR. Please <b>reply Yes within 24 hrs</b> of receiving the SMS."
        }
      },
      "usageLimit": {
        "contactLimit": "Contact Limit",
        "maxContactsAllowed": "Maximum contacts allowed in the sub-account",
        "maxUsersAllowed": "Maximum users allowed in the sub-account",
        "unlimited": "Unlimited",
        "usageLimits": "Usage Limits",
        "userLimit": "User Limit",
        "userLimitHelpMessage": "Only sub-account level users count towards this limit. You can still add as many agency users to the sub-accounts as you require"
      },
      "yext": {
        "reselling": {
          "agreeToEnable": "I agree to enable Listings for this client without upselling and I acknowledge that I will be charged",
          "deployDirectly": "Deploy Listings Directly",
          "deployDirectlyDesc": "Use this option if you are offering Listings as part of your offer or if you wish to bill your client externally",
          "minimumCommitment": "with a 1 month minimum commitment period.",
          "offerListings": "Offer Listings",
          "resellListings": "Re-sell Listings",
          "subscribedInfo": "{withoutUpsell} Without Upsell, {withUpsell} With Upsell and {withSaas} With Saas Bundle",
          "subscriptionCreated": "Subscription created successfully. Please wait...",
          "subscriptionCreating": "Subscription is being created.<br/>Please do not reload or press back button",
          "unableToCreate": "Unable to create subscription, please contact support",
          "unavailabilityForAgencyAdmin": "Yext is not available in this country. If you believe this is a mistake, please request it on our roadmap at",
          "yourResellOffer": "Your Re-sell Offer"
        }
      },
      "selectCountry": "Select your Country",
      "documents": {
        "additionalInfo": "Additional Info",
        "createAddressLink": "Create Address.",
        "createAddressPrompt": "Please create an address first and then proceed with the bundle creation.",
        "selectAddress": "Select Address:"
      }
    },
    "triggers": {
      "emptyTrigger": "Empty trigger"
    },
    "util": {
      "addFiles": "+ Add files",
      "fillValues": "Fill values",
      "image": "img",
      "ok": "Ok",
      "pleaseTypeOrCancel": "Please type {consentString} above or cancel this action.",
      "pressEnterToAddCustomOption": "Press enter to add custom option",
      "required": "* required",
      "unsaved": "Unsaved"
    },
    "workflow": {
      "announcement": {
        "enableMessage": "To enable the Workflow for a location, go to the Accounts tab, click the three-dots icon to the right of a sub-account, and select <strong>Enable Workflow Builder</strong>. This process is temporary as Workflows will go live to all locations next week."
      },
      "faq": "FAQ",
      "gotIt": "Got it",
      "workflowIsLive": "Workflow is live in your account!"
    },
    "action": {
      "stats": {
        "bounced": "Bounced",
        "clicked": "Clicked",
        "delivered": "Delivered",
        "opened": "Opened",
        "replied": "Replied",
        "unsubscribed": "Unsubscribed",
        "total": "Total",
        "failed": "Failed"
      },
      "actions": {
        "edit": "Edit",
        "send": "Send",
        "remove": "Remove"
      },
      "timing": {
        "days": "Days",
        "immediately": "Immediately",
        "before": "Before",
        "after": "After",
        "minutes": "Minutes",
        "hours": "Hours"
      },
      "labels": {
        "template": "Template",
        "manual": "Manual"
      },
      "details": {
        "hideDetail": "Hide Detail",
        "showDetail": "Show Detail"
      },
      "queue": {
        "people": "people",
        "person": "person",
        "queued": "queued"
      },
      "tooltips": {
        "clickedHelp": "Click tracking accuracy may vary based on email client and user settings.",
        "statsAccuracy": "Stats accuracy may vary based on email client and user settings."
      }
    },
    "bulkRequest": {
      "list": {
        "confirmDelete": "Are you sure you want to delete this bulk request?",
        "startImmediately": "Start Immediately"
      },
      "modal": {
        "contactTypes": {
          "all": "All",
          "leads": "Leads",
          "customers": "Customers"
        },
        "buttons": {
          "cancel": "Cancel",
          "update": "Update",
          "add": "Add"
        },
        "labels": {
          "name": "Name",
          "contactType": "Contact Type",
          "campaign": "Campaign",
          "scheduledDate": "Scheduled Date",
          "tag": "Tag"
        },
        "placeholders": {
          "tags": "Tags",
          "selectCampaign": "Select campaign",
          "pickType": "Pick type"
        },
        "sections": {
          "bulkRequest": "Bulk Request",
          "whoShouldRun": "Who should it run for?"
        },
        "titleAdd": "Add Bulk Request",
        "titleEdit": "Edit Bulk Request",
        "validation": {
          "scheduledDateRequired": "Scheduled date is required"
        }
      }
    },
    "listFolder": {
      "expandIcon": "Expand"
    },
    "list": {
      "confirmDeleteFolder": "Confirm Delete Folder",
      "delete": "Delete",
      "confirmDelete": "Are you sure you want to delete this campaign?",
      "moveToFolder": "Move to folder",
      "pleaseRename": "please rename",
      "removeFromFolder": "Remove From folder"
    },
    "copy": {
      "title": "Copy Campaign",
      "newCampaignName": "New Campaign Name",
      "locations": "Locations"
    }
  },
  "compliance": {
    "findOutMore": "Find out more",
    "gdprDescription": "We take the protection of your and your customer's personal data very seriously and treat personal data verfiy confidentially and in accordance with the statutory data protection regulations and this data protection declaration",
    "gdprTitle": "GDPR Compliance",
    "hipaaDescription": "Activate security upgrades to ensure the data in your HighLevel account is secure and meets the requirments of the HIPAA",
    "hipaaTitle": "HIPAA Compliance"
  },
  "customValues": {
    "key": "Key",
    "selectedItemsCountSingular": "{count} row selected",
    "selectedItemsCountPlural": "{count} rows selected"
  },
  "facebookAdFields": {
    "checkIcon": "Form mapped successfully",
    "errorMessage": "Page access token is either expired or does not have enough permissions. Please make sure you have admin access to the pages."
  },
  "fbLeadSync": {
    "confirmTitle": "Confirm Facebook Leads Sync?",
    "impactMessage": "Please understand the impact of the Facebook Leads sync before you proceed:",
    "observations": "1. This will sync Facebook Leads and create new contacts for every lead generated in the last {days} days that does not exist in your contacts list. <br>2. If you have manually imported missing leads using CSV exported from Facebook Ads Manager, please disable 'Allow duplicate contacts' to prevent the sync from creating duplicate contacts. <br>3. If you have workflows that trigger on <b>contact creation</b> or <b>Facebook Lead form submitted</b>, they will get triggered for every new contact created. <br>4. Existing contacts created through Facebook Leads will not be affected. <br>5. The contact creation time on record will be the current time. <br>6. The sync may take up to one hour to complete, depending on the count of leads that are yet to be synced. <br>",
    "proceedQuestion": "Would you like to proceed with Facebook Leads Sync?"
  },
  "integrationAI": {
    "accountDisconnected": "Account Disconnected!",
    "appNotFound": "App configuration not found. Using fallback data.",
    "checkingConnection": "Checking connection status...",
    "connecting": "Connecting...",
    "disconnectApp": "Disconnect App",
    "disconnecting": "Disconnecting...",
    "loadingAppInfo": "Loading app information...",
    "refreshConnection": "Refresh Connection",
    "refreshing": "Refreshing...",
    "svgNotAvailable": "SVG not available"
  },
  "phoneSystem": {
    "additionalSettings": "Additional Settings",
    "messaging": "Messaging",
    "messagingAnalytics": "Messaging Analytics",
    "regulatoryBundles": "Regulatory Bundles",
    "title": "Phone System",
    "trustCenter": "Trust Center",
    "voice": "Voice"
  },
  "demo": {
    "draggable": {
      "title": "Draggable Component Test",
      "usingVue3": "Using Vue 3 Compatible Draggable",
      "description": "This component is now using the revised Vue 3 compatible draggable component.",
      "buttons": {
        "resetAllLists": "Reset All Lists",
        "clearLog": "Clear Log",
        "stopLoading": "Stop Loading",
        "simulateLoading": "Simulate Loading",
        "refreshData": "Refresh Data"
      },
      "examples": {
        "basicDraggable": "Basic Draggable",
        "draggableWithElement": "Draggable with Element",
        "draggableWithTransitionGroup": "Draggable with Transition Group",
        "draggableWithMoveFunction": "Draggable with Move Function"
      },
      "eventLog": "Event Log",
      "handle": "Handle",
      "name": "Name",
      "cannotMove": "(cannot move)"
    },
    "tableDemo": {
      "title": "Vue 3 UIBTable Demo",
      "basicControls": "Basic Controls",
      "labels": {
        "filter": "Filter:",
        "sortBy": "Sort By:",
        "sortDirection": "Sort Direction:",
        "perPage": "Per Page:",
        "tableStyling": "Table Styling:"
      },
      "placeholders": {
        "typeToSearch": "Type to search..."
      },
      "checkboxLabels": {
        "striped": "Striped",
        "bordered": "Bordered",
        "hover": "Hover",
        "small": "Small",
        "responsive": "Responsive"
      },
      "fields": {
        "id": "ID",
        "name": "Name",
        "email": "Email",
        "status": "Status",
        "created": "Created",
        "actions": "Actions"
      },
      "statuses": {
        "active": "Active",
        "inactive": "Inactive",
        "pending": "Pending",
        "banned": "Banned"
      },
      "modal": {
        "title": "Item Details",
        "close": "Close"
      },
      "messages": {
        "confirmDelete": "Are you sure you want to delete {name}?",
        "editItem": "Edit item {id}",
        "showingItems": "Showing {count} of {total} items"
      }
    },
    "saasPricingTable": {
      "confirmAndProceed": "Confirm & Proceed",
      "everythingIn": "Everything in <b>{plan}+</b>",
      "noPaymentMethod": {
        "linkText": "add credit card here",
        "message": "Please ask your client to",
        "title": "Location needs to add payment method first."
      },
      "noSaasPlan": {
        "linkText": "create your SaaS plans here.",
        "message": "Please",
        "title": "You have no SaaS plan configured."
      },
      "saasModeSetupPendingWarning": "The SaaS plan will be activated after the client adds a payment method. Until then, their account access will be restricted.",
      "skipForNow": "Skip for now",
      "skipPlan": "Skip Plan"
    }
  },
  "isv": {
    "business_registration_id_type": "Business Registration ID Type",
    "business_registration_number": "Business Registration Number",
    "business_website": "Business Website",
    "enter_your_business_registration_id_type": "Enter Your Business Registration ID Type",
    "name_of_other_registration_id_type": "Name of Other Registration ID Type",
    "pick_business_industry": "Pick Business Industry",
    "pick_business_registration_id_type": "Pick Business Registration ID Type",
    "emailWithStar": "Email*",
    "businessIndustry": "Business Industry*",
    "businessType": "Business Type*",
    "regionsOfOperations": "Business Regions of Operations*",
    "registrationNumber": "Business Registration Number*",
    "registrationNumberHelper": "The number used to identify your business. In case of US EIN, must be a 9-digit number e.g.12-3456789.",
    "businessWebsiteWithStar": "Business Website*",
    "businessTypeWithStar": "Business Type",
    "businessWebsite": "Business Website"
  },
  "aiProductRebilling": {
    "enableRebilling": "Enable Rebilling",
    "ratesMayDiffer": "Rates may differ as per region. Calculations shown are as per rates for UK,",
    "supportDoc": "support doc",
    "cancel": "Cancel",
    "profit": "Profit",
    "chargedToCustomer": "Charged to Customer",
    "enabling": "Enabling...",
    "forMore": "for more details.",
    "rebillAmount": "Rebill Amount",
    "tenDollarsWillGive": "$10 will give you about",
    "yourCost": "Your Cost",
    "clientBillingPage": "client's company billing page",
    "needStripeConnection": "In order to turn on rebilling, you need to connect your stripe on",
    "per1000Words": "per 1000 words",
    "perImage": "per Image",
    "perReviewResponse": "per Review Response",
    "perFunnel": "per Funnel",
    "minimumBetween": "Minimum must be between {min} and {max}",
    "images": "images",
    "reviewResponse": "review response",
    "funnel": "funnel",
    "pleaseCheckSupport": "please check"
  },
  "a2p": {
    "otpSuccess": {
      "title": "OTP Success",
      "message": "OTP Success Message"
    },
    "otpError": {
      "title": "OTP Error",
      "message": "OTP Error Message"
    },
    "businessProfileError": {
      "title": "Business Profile Error",
      "message": "Business Profile Error Message"
    },
    "addressError": {
      "title": "Address Error",
      "status": "Address Error Status"
    },
    "profileError": {
      "title": "A2P Profile Error",
      "message": "A2P Profile Error Message"
    },
    "address": {
      "country": "Country",
      "state": "State",
      "chooseCountry": "Choose country...",
      "statePlaceholder": "Enter State",
      "chooseState": "Choose state...",
      "city": "City*",
      "postalCode": "Postal/Zip Code*",
      "streetAddress": "Street Address*",
      "streetAddressHelper": "Must be a valid address linked to your business.",
      "title": "Business Address"
    },
    "validation": {
      "brandNameRequired": "Brand name is required.",
      "businessVerticalRequired": "Business vertical is required.",
      "cityRequired": "City is required.",
      "countryRequired": "Country is required.",
      "invalidMobileNumber": "Invalid mobile number.",
      "mobileNumberRequired": "Mobile number is required.",
      "postalCodeRequired": "Postal / Zip Code is required.",
      "stateRequired": "State is required.",
      "streetAddressRequired": "Street address is required."
    },
    "authorizedRep": {
      "email": "Email*",
      "firstName": "First Name*",
      "jobPosition": "Job Position*",
      "jobTitle": "Job Title*",
      "jobTitlePlaceholder": "Enter job title",
      "lastName": "Last Name*",
      "phoneNumber": "Phone Number*",
      "phoneNumberPlaceholder": "Enter phone number",
      "pickJobPosition": "Pick Job Position",
      "title": "Authorized Representative Details"
    },
    "registration": {
      "stepProgress": "Step {currentStep} of 8",
      "successTitle": "Your A2P brand and campaign has been submitted.",
      "successWaitDays": "7 days",
      "successWaitPrefix": "It might take up to ",
      "successWaitSuffix": " for your Brand approval and additional 4-5 weeks for Campaign approval.",
      "otpNote": "Note: You will receive an OTP message on your provided mobile number to verify from TCR. Please reply Yes within 24 hrs of receiving the SMS."
    },
    "update": {
      "brandDetailsTitle": "Update Brand Details",
      "brandName": "Brand name*",
      "brandNameHelper": "Use either legal name of the organization which is sending the messages, or your own name if this brand is not for an organization.",
      "businessVerticals": "Business Industry*",
      "chooseVertical": "Choose vertical...",
      "mobileNumber": "Mobile Number For OTP Verification (With country code)*",
      "mobileNumberHelper": "Please provide a mobile number that you have access to so you can confirm OTP verification. Only US/Canadian numbers will be accepted. You may not use a CPaaS phone number such as one obtained from LeadConnector. You cannot use the same mobile number to register more than 3 Sole Proprietor brands. This limit is managed by TCR.",
      "updateButton": "Update",
      "retryOTPTitle": "Retry OTP",
      "retryOTPMessage": "Click the button below to resend the OTP verification message.",
      "sending": "Sending...",
      "resendOTP": "Resend OTP"
    },
    "einModal": {
      "title": "Do you have an EIN?",
      "question": "Do you have an Employer Identification Number (EIN)?",
      "hasEIN": "Yes, I have an EIN",
      "noEIN": "No, I don't have an EIN",
      "disableNoEINText": "EIN is required for non-US/CA locations",
      "infoText": "An EIN is required for businesses in the United States and Canada."
    },
    "brandDetails": {
      "brandHeading": "Brand Details",
      "brandName": "Brand name*",
      "brandNameHelper": "Use either legal name of the organization which is sending the messages, or your own name if this brand is not for an organization.",
      "businessIndustry": "Business Industry*",
      "chooseVertical": "Choose vertical...",
      "mobileNumber": "Mobile Number For OTP Verification (With country code)*",
      "mobileNumberHelper": "Please provide a mobile number that you have access to so you can confirm OTP verification. Only US/Canadian numbers will be accepted. You may not use a CPaaS phone number such as one obtained from LeadConnector. You cannot use the same mobile number to register more than 3 Sole Proprietor brands. This limit is managed by TCR.",
      "solePropBrand": {
        "heading": "Sole Prop Brand",
        "point1": "Only 1 Phone Number allowed",
        "point2": "EIN/SSN/DUNS not required",
        "subheading": "Sole Prop Brand Registration"
      },
      "solePropCampaign": {
        "heading": "Sole Prop Campaign",
        "point1": "Only 1 number is allowed to be linked to a Sole Prop Campaign",
        "point2": "Once approved your default number will be linked automatically",
        "infoText": "You can also update the number post approval",
        "warningText": "Only 1 number is allowed to be linked to a Sole Prop Campaign. Once approved your default number will be linked automatically, you can also update the number post approval.",
        "subheading": "Sole Prop Campaign Registration"
      },
      "solePropSubtitle": "Sole Prop Brand and Campaign Details",
      "standardBrand": {
        "heading": "$4.41 - One Time",
        "point1": "EIN/SSN/DUNS required",
        "point2": "More than 1 Phone Number allowed",
        "subheading": "Standard Brand Registration"
      },
      "standardCampaign": {
        "heading": "$16.54 - One Time",
        "point1": "More than 1 number is allowed to be linked to a Standard Campaign",
        "point2": "EIN/SSN/DUNS required",
        "infoText": "Additional campaign fee up to $12 per month will apply in accordance with TCR rules.",
        "subheading": "Standard Campaign Registration"
      },
      "standardSubtitle": "Standard Brand and Campaign Details",
      "title": "Brand and Campaign Details"
    },
    "campaign": {
      "useCaseDetails": {
        "title": "Campaign Use Case Details",
        "subtitle": "Enter the campaign details and description",
        "useCase": "Campaign Use Case*",
        "pickUseCase": "Pick Campaign use case",
        "useCaseDescription": "Use Case Description*",
        "explainInDetail": "Please explain in detail",
        "useCaseDescriptionPlaceholder": "Example: This campaign sends appointment information - confirmation & reminder messages to our customers once they have booked an appointment with us on our website and opted-in to receive promotional and notification SMS from us.",
        "useCaseDescriptionHelper": "Please provide a detailed description of how you will use this campaign.",
        "solePropLabel": "Sole Proprietor",
        "seeExamples": "See Examples",
        "closeExamples": "Close Examples"
      }
    }
  },
  "opportunities": {
    "email": "Email",
    "phone": "Phone",
    "status": "Status",
    "contactType": "Contact Type",
    "bulkOperation": "Bulk Operation",
    "contactName": "Contact Name",
    "unassigned": "Unassigned",
    "abandoned": "Abandoned",
    "addOpportunityName": "Add Opportunity Name",
    "companyName": "Company Name",
    "contactInfo": "Contact Info",
    "enterValue": "Enter Value",
    "lost": "Lost",
    "open": "Open",
    "opportunityInfo": "Opportunity Info",
    "opportunityName": "Opportunity Name",
    "opportunitySource": "Opportunity Source",
    "owner": "Owner",
    "pipeline": "Pipeline",
    "selectPipeline": "Select Pipeline",
    "selectStage": "Select Stage",
    "stage": "Stage",
    "won": "Won",
    "createdOn": "Created On",
    "goToContactDetail": "Go to contact detail page",
    "leadValue": "Lead Value",
    "removeOwner": "Remove Owner",
    "createdBy": "Created By",
    "notAllowedToChange": "You are not allowed to change this contact",
    "opportunityAlreadyExists": "An opportunity already exists for this contact in the selected pipeline",
    "filters": {
      "all": "All",
      "statuses": {
        "all": "All",
        "open": "Open",
        "won": "Won",
        "lost": "Lost",
        "abandoned": "Abandoned"
      },
      "search": "Search",
      "status": "Status",
      "campaign": "Campaign",
      "owner": "Owner",
      "pipeline": "Pipeline",
      "dateAddedAsc": "↑ Date Added (ASC)",
      "dateAddedDesc": "↓ Date Added (DESC)",
      "orderBy": "OrderBy"
    },
    "columns": {
      "note": "Note",
      "task": "Task",
      "companyName": "Company Name",
      "additionalInfo": "Additional Info",
      "calendarEvent": "Calendar Event",
      "hideAssignedTo": "Hide Assigned To",
      "hideTags": "Hide Tags"
    },
    "buttons": {
      "new": "New"
    },
    "dragActions": {
      "abandoned": "Abandoned",
      "lost": "Lost",
      "won": "Won"
    },
    "getStarted": "get started!",
    "noPipelines": "Oops! Looks like there are no pipelines. Create a new pipeline to",
    "addTask": "Add Task",
    "tasksCount": "{count} tasks"
  },
  "appointmentDetails": "Appointment Details",
  "cloneFunnel": {
    "cloneButton": "Clone {entityName}",
    "cloning": "Cloning...",
    "cloningLimit": "Cloning is limited to 3 locations at a time",
    "error": "Error while cloning funnel!",
    "locationsLabel": "Select Locations",
    "nameLabel": "Name for the cloned {entityName}",
    "namePlaceholder": "Enter name for cloned {entityName}",
    "selectUpTo": "Select up to {maxSelectableLocations} locations",
    "title": "Clone {entityName}"
  },
  "errors": "Errors",
  "renderEmailAddress": "Render Email Address",
  "noPaymentMethodWarning": "No Payment Method Warning",
  "pageDetail": "Page Detail",
  "activityHistory": "Activity History",
  "uiAlert": "UI Alert",
  "eventModals": {
    "wait": {
      "save": "Save",
      "days": "Days",
      "fri": "Fri",
      "mon": "Mon",
      "sat": "Sat",
      "sun": "Sun",
      "thu": "Thu",
      "tue": "Tue",
      "wed": "Wed",
      "wait": "Wait",
      "minutes": "Minutes",
      "hours": "Hours",
      "title": "Edit Wait Event",
      "whichDaysResume": "Which days should we resume?",
      "pickDayError": "Please pick at least one day",
      "whatTimeResume": "What time should we resume?"
    },
    "sms": {
      "send": "Send",
      "name": "Name",
      "attachFile": "Attach File",
      "learnMore": "Learn More",
      "sendTest": "Send Test",
      "title": "Edit {eventType} Event",
      "titleTemplate": "Edit {eventType} Template",
      "nameRequired": "Name is required",
      "pickTemplate": "Pick Template",
      "appCharacters": "App Characters",
      "numSegments": "Num Segments",
      "approximateCost": "Approximate Cost",
      "costEstimateNote": "Cost estimate note",
      "urlAttachmentAutocompleteToken": "URL Attachment",
      "addFileUrl": "Add File URL",
      "urlImageAlt": "URL Image",
      "fileImageAlt": "File Image",
      "enterMessage": "Enter Message",
      "mobilePhonePlaceholder": "Mobile Phone",
      "unsupportedContentType": "Unsupported content type: {fileType}",
      "urlAttachmentWarning": "{count} URL attachment{plural} failed to load. Do you want to continue?",
      "provideMobileNumber": "Please provide mobile number"
    },
    "email": {
      "text": "Text",
      "checkLinks": "Please check the links where you have a custom value. There is an extra '%20' between the {{ and the custom_values.",
      "errorOccurred": "An error ocurred, please try again.",
      "insertToAddress": "Please insert a to address."
    },
    "voicemail": {
      "save": "Save",
      "dropFile": "Drop file here or click to upload",
      "faq": "FAQ",
      "title": "Edit Voicemail Event",
      "voicemailFile": "Voicemail File",
      "warning": "Warning: Voicemail files must be in MP3, WAV, or GSM format.",
      "unsupportedFormat": "Unsupported file format. Please use MP3, WAV, or GSM."
    },
    "call": {
      "title": "Edit Call Event",
      "save": "Save",
      "name": "Name",
      "nameRequired": "Name is required",
      "callWhisper": "Call Whisper",
      "whisperMessage": "Whisper Message",
      "thisIsTheMessage": "This is the message that will be played to the agent before connecting the call.",
      "callTimeoutS": "Call Timeout (s)",
      "timeoutSeconds": "Timeout (seconds)",
      "disableVoicemailDetect": "Disable Voicemail Detection",
      "callWillPatchInstantly": "The call will be patched instantly without detecting voicemail."
    }
  },
  "emailTemplate": {
    "createdOn": "Created On",
    "updatedOn": "Updated On"
  },
  "cnam": {
    "learnMore": {
      "title": "CNAM Learn More",
      "description": "CNAM Description"
    },
    "submitted": {
      "checkStatus": "Check CNAM Status",
      "description": "Your business name should be shown to applicable contacts in around 3-5 days.",
      "subtitle": "Your CNAM request is now submitted.",
      "title": "Congratulations!"
    },
    "registration": {
      "confirm": "Confirm",
      "learnMore": "Learn More",
      "characterLimit": "{count}/15",
      "title": "CNAM Registration",
      "description": "Enter your business name (max 15 characters)",
      "warning": "Warning: Your business name will be displayed on caller ID. "
    }
  },
  "updateModals": {
    "error": {
      "title": "Update Error",
      "message": "Update Error Message"
    },
    "success": {
      "message": "Your A2P brand and campaign has been submitted.<br/><br/><b>Note:</b> You will <b>receive an OTP message on your provided mobile number to verify</b> from TCR. Please <b>reply Yes within 24 hrs</b> of receiving the SMS.",
      "title": "Your A2P brand and campaign has been submitted. It might take up to <b>7 days</b> for your Brand approval and additional 4-5 weeks for Campaign approval."
    }
  },
  "regulatoryBundle": {
    "error": {
      "title": "Regulatory Bundle Error",
      "status": "Regulatory Bundle Error Status"
    },
    "createAddress": {
      "successMessage": "Your A2P brand and campaign has been submitted.",
      "successTitle": "Address Submitted Successfully",
      "underReview": "Address submitted is under review"
    },
    "createEndUser": {
      "dateFormat": "Date format should be YYYY-MM-DD.",
      "phoneExample": " Example: +14155552671",
      "title": "Business Details:"
    },
    "success": {
      "title": "Regulatory Bundle Submitted Sucessfully",
      "underReview": "Bundle Submitted Under Review",
      "message": "Your request for SHAKEN/STIR registration submitted. It might take up to <b>3-4 days</b> to get approved. The status will be updated soon."
    },
    "documents": {
      "additionalInfo": "Additional Info",
      "createAddressLink": "Create Address.",
      "createAddressPrompt": "Please create an address first and then proceed with the bundle creation.",
      "selectAddress": "Select Address:"
    },
    "selectBundle": {
      "addressBundle": {
        "description": "This option will add new address to your account",
        "label": "Address Bundle"
      },
      "regulatoryBundle": {
        "description": "This option will help you create new regulatory bundle",
        "label": "Regulatory Bundle"
      },
      "title": "Choose which bundle you want add"
    },
    "modal": {
      "back": "Back",
      "next": "Next",
      "submit": "Submit",
      "title": "New Regulatory Bundle",
      "description": "Create a new regulatory bundle for your location"
    }
  },
  "reminder": {
    "phone": "Phone",
    "noReplyYet": "No Reply Yet"
  },
  "sendGrid": {
    "apiKey": "SendGrid API Key",
    "save": "SendGrid Save",
    "apiKeyRequired": "SendGrid API Key Required"
  },
  "twilioReselling": {
    "upgradeBanner": {
      "upgradeButton": "Upgrade",
      "subtitle": "Agencies on pro plan make about $363 per month by rebilling phone costs to their clients",
      "title": "Want to rebill this to your clients?"
    }
  },
  "emailField": {
    "label": "Email",
    "placeholder": "Email",
    "tooltip": {
      "primary": "Primary",
      "emails": "Emails"
    }
  },
  "attachSnapshotToggle": {
    "loadSnapshot": "Load Snapshot:",
    "loadSnapshotWarning": "Do you wish to load the snapshot associated with this plan? <br /> <strong class='text-danger'>Existing data may be lost</strong>"
  },
  "suspension": {
    "suspended": {
      "description": "Only agency admins/users have access to this sub-account. Currently, you and other account admins/users do not have access to this sub-account.",
      "heading": "This sub-account has been paused."
    },
    "temporarily": {
      "description": "All your data is safe and all triggers/campaigns, etc will resume working after activation.",
      "heading": " Your account has been suspended temporarily."
    }
  },
  "callerIdUpdateModal": {
    "friendlyName": "Friendly Business Name",
    "title": "Update Caller ID"
  },
  "drChronoOfficeSelect": {
    "selectOffice": "Select Office",
    "whichOffice": "Which office do you want to link to this account?",
    "connect": "Connect!"
  },
  "phoneField": {
    "label": "Phone",
    "placeholder": "Phone Number",
    "tooltip": {
      "invalidNumber": "Invalid phone number",
      "notSmsCapable": "This {type} number is not SMS capable"
    }
  },
  "submissionDetail": {
    "titles": {
      "bookingDetails": "Booking Details",
      "form": "Form",
      "quiz": "Quiz",
      "submissionDetail": "Submission Detail",
      "survey": "Survey"
    }
  },
  "shakenStir": {
    "confirmation": {
      "description": "Your request for SHAKEN/STIR registration submitted. It might take up to <b>3-4 days</b> to get approved. The status will be updated soon.",
      "title": "SHAKEN/STIR Trusted Calling Enabled."
    },
    "modal": {
      "andThe": " and the ",
      "businessProfile": "Business Profile",
      "certification": "I certify that the associated Business Profile is the originator of the phone calls and certify that I will participate in traceback efforts, including those initiated by the",
      "failedTitle": "Submission Failed",
      "friendlyName": "Friendly Name",
      "friendlyNamePlaceholder": "Ex: SHST 2022-11-24 at 19:47:14",
      "linkInfo": {
        "description": "All current available numbers and future bought numbers will automatically will be registered with SHAKEN/STIR.",
        "title": "All numbers will be Linked Automatically"
      },
      "stiPa": "Secure Telephony Identity Policy Administrator (STI-PA)",
      "subtitle": "Enter the details and Description",
      "successMessage": "Your request for SHAKEN/STIR registration submitted. It might take up to <b>3-4 days</b> to get approved. The status will be updated soon.",
      "successTitle": "SHAKEN/STIR Trusted Calling Enabled.",
      "title": "Enable SHAKEN/STIR Trusted Calling",
      "tracebackGroup": "US Telecom Traceback Group"
    },
    "withCnam": {
      "cnamPromo": "Register for CNAM to display your business name on caller ID",
      "registerCnam": "Register CNAM"
    }
  },
  "task": {
    "2day": "2 days",
    "3day": "3 days",
    "4day": "4 days",
    "5day": "5 days",
    "addTask": "Add Task",
    "countTasks": "{count} tasks"
  },
  "updatedProductsModal": {
    "title": "Updated Products",
    "copyDirectSaleLink": "Copy Direct Sale Link",
    "setupFeeInstruction": "Setup fee can be configured in Stripe Dashboard. ",
    "doNotDeleteWarning": "Do not delete products or prices from Stripe Dashboard. This will break the integration."
  },
  "termsOfService": {
    "privacyLink": "Privacy Policy",
    "accept": "Accept",
    "termsLink": "Terms of Service",
    "updateMessage": "We've updated our Terms of Service and Privacy Policy. Please review and accept to continue.",
    "agreementPrefix": "By continuing, you agree to our ",
    "agreementConjunction": " and "
  },
  "callerIdVerificationModal": {
    "answerCall": "Answer the call and enter this verification code:",
    "leadConnectorCalling": "Lead Connector is calling...",
    "title": "Add a Caller ID By Voice",
    "waitingForVerification": "Waiting for the verification..."
  },
  "emailOTPModal": {
    "confirmCode": "Confirm Code",
    "resendCode": "If you did not receive the code click here to resend"
  },
  "survey": {
    "copy": {
      "cancel": "Cancel",
      "location": "Location",
      "copy": "Copy",
      "newSurveyName": "New Survey Name",
      "title": "Copy Survey",
      "locationRequired": "Location is required"
    }
  },
  "stripeProductDetailsModal": {
    "productName": "Product Name",
    "planDetails": "Plan Details",
    "title": "Product Details",
    "planId": "Plan ID",
    "copiedToClipboard": "Copied to clipboard"
  },
  "importCustomers": {
    "newExperience": {
      "efficient": "More Efficient",
      "faster": "Faster",
      "itsText": "It's",
      "smoother": "Smoother",
      "title": "A New Import Experience is Here!",
      "warningMessage": "Enabling the New Import experience activates Labs for this Sub-Account and turns on the Beta Feature.",
      "tryNow": "Try Now"
    },
    "validateEmails": "Validate emails?"
  },
  "yext": {
    "reselling": {
      "zero": "0",
      "highlevelPrice": "HighLevel Price",
      "howDoesItWork": "How does it work?",
      "payNow": "Pay Now",
      "priceError": "Price must be more or equal to HighLevel price",
      "saving": "Saving",
      "yourPrice": "Your Price",
      "yourProfit": "Your Profit",
      "subscriptionCreating": "Subscription is being created.<br/>Please do not reload or press back button",
      "subscriptionCreated": "Subscription created successfully. Please wait...",
      "unableToCreate": "Unable to create subscription, please contact support",
      "perMonth": "per month",
      "agreeToEnable": "I agree to enable Listings for this client without upselling and I acknowledge that I will be charged",
      "deployDirectly": "Deploy Listings Directly",
      "deployDirectlyDesc": "Use this option if you are offering Listings as part of your offer or if you wish to bill your client externally",
      "minimumCommitment": "with a 1 month minimum commitment period.",
      "offerListings": "Offer Listings",
      "resellListings": "Re-sell Listings",
      "subscribedInfo": "{withoutUpsell} Without Upsell, {withUpsell} With Upsell and {withSaas} With Saas Bundle",
      "yourResellOffer": "Your Re-sell Offer"
    }
  }
}
